/* eslint-disable no-unused-vars */
// mainCalendar.jsx
import FullCalendar from '@fullcalendar/react';
import { useState, useEffect, useRef, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import Sidebar from '../../Sidebar/Sidebar';
// import HeaderFilter from '../../Header/HeaderFilter';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { handleApiResponse } from '../../../hooks/notificationHelper';
import { getAccessToken, getGuId } from '../../../utils/SecurityService';
import { useApiUiResponse } from "../../../hooks/apiUiResponseHelper.js";
// import "../../../assets/css/bootstrap.min.css";

// import * as authMemory from '../../../services/authMemory';

import {
    Login,
    ZoneList,
    Calendar_api,
    BASE_URL,
    fetchWithTokenRefresh2,
    FetchCalendarWithZone,
    MakeBooking_API,
    CancelBooking_API,
    Calendar_API,
    BookingCancelNewWeekRefresh,
    DeviceId,
    OsVersion,
    App_version,
    ManufactureModel,
    // Calendar_APIforBooking
    CheckInUser_API,
    BookingStatus_API,
    CheckOutUser_API,
    CheckInOutsingleBtn
} from '../../apiUtils';
import CalendarLogic from './CalendarRefresh';
import { useTranslation } from 'react-i18next'

// import filterIcon from "../../../assets/images/icons/filterIcon.svg"
import Close from "../../../assets/images/icons/close.svg";
import OrangeStar from "../../../assets/images/icons/orange-star.svg";
import GreenMap from "../../../assets/images/icons/green-map.svg";
import EditSquare from "../../../assets/images/icons/edit-square.svg";
import MapOrange from "../../../assets/images/icons/map-orange.svg";
import TimeIcon from "../../../assets/images/icons/time.svg";
import UserIcon from "../../../assets/images/icons/user-name.svg"
import Deskbooking from "../../../assets/images/desk-booking.png"
import iconParking from "../../../assets/images/icons/parking-booking.png"
import cancelBooking from "../../../assets/images/icons/black-cancel-icon.svg"
import notificationicon from "../../../assets/images/icons/notification.svg"
import profileImg from "../../../assets/images/profileImg.jpg"
import edit from "../../../assets/images/icons/edit.svg"
import logoutwhite from "../../../assets/images/icons/logout-white.svg"
import Profile from "../../../assets/images/profile.png"
import ProfileLocation from "../../../assets/images/icons/profile-location.svg"
import FillStar from "../../../assets/images/icons/fill-star.svg"
import GrayStar from "../../../assets/images/icons/gray-star.svg"
import BlackClose from "../../../assets/images/icons/black-close.svg"
import LoaderFull from "../../../assets/images/loading.gif"
import NotificationPanel from '../../Common/Notification';
import PlusButton from "../../../assets/images/icons/white-plus.svg"
import Deleteicon from "../../../assets/images/icons/trash.svg"
import ScheduleMeetingicon from "../../../assets/images/icons/schedule-meeting.svg"
import CheckInIcon from "../../../assets/images/icons/checkin-checkout.svg"
import ParkingIcon from "../../../assets/images/icons/parkingIcon.svg"
import DeskIcon from "../../../assets/images/icons/DeskIcon.svg"
import MeetingIcon from "../../../assets/images/icons/meetingIcon.svg"
import userInQueIcon from '../../../assets/images/icons/user-booking.svg'; // Adjust the path as necessary
import userQueIcon from '../../../assets/images/icons/user-in-join-queue.svg';
import NewMeetingModal from '../../Common/NewMeetingModal';
import CheckInCheckOutList from '../../Common/CheckInCheckOutList';

import { formatDate, formatDateToEEEddMMM, formatReactString, getBookingDateStr, toSafeFloat, getDisplayRefundCreditValue } from '../../../utils/CommonUtils';

import filterIcon from "../../../assets/images/icons/filterIcon.svg"
import CommonFilter from "../../Common/FilterCalendarMap";
import filterIconOrange from "../../../assets/images/icons/filterIconOrange.svg"
import CreditInfoCard from "../../Common/CreditInfoCard";
import { Images } from '../../Common/Images';
import { BookingStatus_api, GetAlternateParkingSpot_api, PostBookingQuestion_api, ReportParkingViolation_api } from '../../WeeklyCalendar/WeeklyCalendarAPI';
import PostbookingQueModal from '../../Common/PostbookingQueModal';
import { useApiResponseHandler } from '../../../hooks/useApiResponseHandler';
import CustomSearchableDropdown from '../../Common/CustomSearchableDropdown';
import DOMPurify from "dompurify";
import closeIcon from "../../../assets/images/icons/black-cancel-icon.svg"
import { AppConstant } from '../../../config/AppConstants';
import WarningIcon from "../../../assets/images/icons/Warningicon.svg"
import WarningcloseIcon from "../../../assets/images/icons/close.svg"
import NotificationMessage from "../../Common/NotificationMessage.jsx";
import { handleApiResponsemap } from "../../../hooks/mapnotificationHelper.js";
import guestConfirmation from "../../../assets/images/icons/GuestConformation.svg"

const SESSION = {
    selectedZoneIDInCalendarScreen: 'selectedZoneIDInCalendarScreen',
    SelectedTranslation: 'selectedTranslation',
};

const SHARED_SELECTIONS_KEY = "sharedMapCalendarSelections";
const MAP_TO_CALENDAR_SYNC_KEY = "mapToCalendarUseSharedZone";

const Calendar = () => {
    const { t } = useTranslation();
    const { i18n } = useTranslation();
    const [loadingWeeks, setLoadingWeeks] = useState({});
    const [calendarEl, setCalendarEl] = useState(null);
    const [weeklyPercentages, setWeeklyPercentages] = useState([]);
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedDay, setSelectedDay] = useState(null);
    const [displayMonth, setDisplayMonth] = useState(null);
    const [displayYear, setDisplayYear] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);
    const [clickedFullDay, setClickedFullDay] = useState(false);
    const loadedMonthKeyRef = useRef("");
    const visibleCalendarViewRef = useRef("dayGridMonth");
    const visibleMonthStartRef = useRef(new Date(new Date().getFullYear(), new Date().getMonth(), 1));

    const [currentDate, setCurrentDate] = useState(new Date()); // Represents today's date for logic
    const [events, setEvents] = useState([
        { id: '1', title: 'Spot 3467TY - All day', start: '2024-12-09', status: 'checked-out' },
        { id: '2', title: 'Spot WER 234 - 10:50 - 12:00', start: '2024-12-10', status: 'available' },
        { id: '3', title: 'Spot WER 234 - 10:50 - 12:00', start: '2024-12-10', status: 'available' },
        { id: '4', title: 'Spot WER 234 - 10:50 - 12:00', start: '2024-12-10', status: 'available' },
        { id: '5', title: 'Spot WER 234 - 10:50 - 12:00', start: '2024-12-10', status: 'available' },
    ]);
    const employeeOptions = [
        "Michael Furey",
        "John Warde",
        "Mathieu Pegeot",
        "Daire O Brien",
        "Angela Hernandez",
        "New User",
        "One more Added"
    ];
    const [showModal, setShowModal] = useState(false);
    const [weekData, setWeekData] = useState({}); // Stores fetched weekly booking schedules

    const [isLoading, setIsLoading] = useState(false); // For initial full calendar load
    const [availabilityDays, setAvailabilityDays] = useState([]);
    const [startbookingData, setStartBookingData] = useState([]);
    const [bookingSpotData, setBookingSpotData] = useState([]); // This appears to be initial/default booking data before week-specific fetches
    const [calendarRenderKey, setCalendarRenderKey] = useState(0); // To force re-render FullCalendar if needed

    const calendarRef = useRef(null);
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [bookingToCancelDate, setBookingToCancelDate] = useState(null); // Full date object
    const [showBookingModal, setShowBookingModal] = useState(false);
    const [bookingCreateDate, setBookingCreateDate] = useState(null); // Full date object

    const [showNoVehicleModal, setShowNoVehicleModal] = useState(false);

    const [showJoinQueueModal, setShowJoinQueueModal] = useState(false);
    const [joinQueueDate, setJoinQueueDate] = useState(null); // Full date object
    const [showLeaveQueueModal, setShowLeaveQueueModal] = useState(false);
    const [leaveQueueDate, setLeaveQueueDate] = useState(null); // Full date object
    const [showReportParkingViolationModal, setShowReportParkingViolationModal] = useState(false);
    const [showAlternateParkingSpotModal, setShowAlternateParkingSpotModal] = useState(false);
    const [parkingViolationReportingData, setParkingViolationReportingData] = useState(null);

    const [recordsData, setRecordsData] = useState(null);
    const [teamLeadFlag, setTeamLeadFlag] = useState(0);
    const [isQueue, setIsQueue] = useState(0);
    const [preBookingQuestion, setPreBookingQuestion] = useState("");
    const [mapAvailable, setMapAvailable] = useState(); // New state for map availability
    const [mapAvailableType, setMapAvailableType] = useState(); // New state for map availability
    const [iconzoneType, setIconZoneType] = useState(); // New state for zone type
    const [creditInfoJSX, setCreditInfoJSX] = useState(null); // Set to null initially, render only if available
    const [creditValue, setCreditValue] = useState(0);
    const [zoneCreditValue, setZoneCreditValue] = useState(0);
    const [creditBalance, setCreditBalance] = useState(0);
    const [creditBalanceRefill, setCreditCreditBalance] = useState(0);
    const [isThumbnailPresent, setIsThumbnailPresent] = useState(0);
    const [companyId, setCompanyId] = useState(0);

    const [mainCurrentDate, setMainCurrentDate] = useState("");
    const [selectedZoneName, setSelectedZoneName] = useState('Loading Zones...');
    const [selectedCalendarZoneId, setSelectedCalendarZoneId] = useState(0); // Holds the ID of the currently selected zone

    const [zoneList, setZoneList] = useState([]);
    // Team member dropdown state (copied from MapDefault)
    const [teamMemberList, setTeamMemberList] = useState([]);
    const [selectedTeamMember, setSelectedTeamMember] = useState("");
    const [teamMemberOpen, setTeamMemberOpen] = useState(false);
    const teamMemberDropdownRef = useRef(null);

    const [selectedName, setSelectedName] = useState("");
    const [selectedQueueUser, setSelectedQueueUser] = useState(0);
    const [selectedTeamId, setSelectedTeamId] = useState(null);
    const [isGuest, setIsGuest] = useState(0);
    const isGuestTeamMember = String(selectedTeamMember) === "0";
    const activeGuestFlag = selectedTeamId === null && isGuestTeamMember
        ? 1
        : (isGuest ?? 0);

    const [visibleRange, setVisibleRange] = useState({ start: null, end: null });

    const getSharedSelections = () => {
        try {
            const raw = sessionStorage.getItem(SHARED_SELECTIONS_KEY);
            return raw ? JSON.parse(raw) : {};
        } catch (error) {
            console.error("Error reading shared selections:", error);
            return {};
        }
    };

    const saveSharedSelections = (overrides = {}) => {
        try {
            const current = getSharedSelections();
            sessionStorage.setItem(
                SHARED_SELECTIONS_KEY,
                JSON.stringify({
                    ...current,
                    ...overrides,
                })
            );
        } catch (error) {
            console.error("Error saving shared selections:", error);
        }
    };

    const getDefaultZone = (zones = []) => {
        return (zones || []).find((zone) => zone.DefaultId === 1) || (zones || [])[0] || null;
    };

    const getPersistedCalendarZoneId = () => {
        const sessionZoneId = Number(sessionStorage.getItem(SESSION.selectedZoneIDInCalendarScreen));
        if (sessionZoneId) {
            return sessionZoneId;
        }

        const sharedZoneId = Number(getSharedSelections().zoneId);
        return sharedZoneId || null;
    };

    const resetDropdownToDefault = (zones = zoneList) => {
        const fallbackZone = getDefaultZone(zones);
        if (fallbackZone) {
            setZoneList(zones);
            setSelectedCalendarZoneId(fallbackZone.Id);
            setSelectedZoneName(fallbackZone.ZoneName);
            saveSharedSelections({
                zoneId: fallbackZone.Id,
                zoneName: fallbackZone.ZoneName,
            });
        } else {
            setZoneList([]);
            setSelectedCalendarZoneId(0);
            setSelectedZoneName("No Zones Available");
        }
        setBookingSpotData([]);
    };

    const resetMemberDropdownToDefault = () => {
        const defaultMember = teamMemberList[0];

        if (defaultMember) {
            setSelectedTeamMember(defaultMember.GuId);
            setSelectedTeamId(null);
            setIsGuest(defaultMember.GuId === "0" ? 1 : 0);
            setSelectedName(defaultMember.FullName);
            setSelectedQueueUser(defaultMember.QueueUser ?? 0);
            setCreditBalance(defaultMember.Credit ?? 0);
            saveSharedSelections({
                teamMemberId: defaultMember.GuId,
                teamId: null,
                isGuest: defaultMember.GuId === "0" ? 1 : 0,
                selectedName: defaultMember.FullName,
            });
        } else {
            setSelectedTeamMember("");
            setSelectedTeamId(null);
            setIsGuest(0);
            setSelectedName("");
            setSelectedQueueUser(0);
            setCreditBalance(0);
            saveSharedSelections({
                teamMemberId: "",
                teamId: null,
                isGuest: 0,
                selectedName: "",
            });
        }
    };

    const handleMemberSelectionInCalendar = async (member) => {
        setSelectedTeamMember(member.GuId);
        setSelectedTeamId(null);
        setIsGuest(member.GuId === "0" ? 1 : 0);
        setCreditBalance(member.Credit ?? 0);
        setTeamMemberOpen(false);
        setSelectedName(member.FullName);
        setSelectedQueueUser(member.QueueUser ?? 0);
        saveSharedSelections({
            teamMemberId: member.GuId,
            teamId: null,
            isGuest: member.GuId === "0" ? 1 : 0,
            selectedName: member.FullName,
        });

        try {
            setWeekData({});
            setLoadingWeeks({});
            setIsLoading(true);
            const zoneResponse = await ZoneList(member.GuId);
            const fetchedZoneList = zoneResponse?.Data?.Records?.ZoneList ?? [];
            const zoneResponseCode = Number(zoneResponse?.Data?.ResponseCode || 0);

            // Show error popup
            handleApiUiResponse(zoneResponse, {
                successToaster: 0,
                errorToaster: 1,
                alertPopup: 1
            });

            // Direct code check - reset immediately if error (MapDefault pattern)
            if (zoneResponseCode !== 200) {
                resetMemberDropdownToDefault();
                return;
            }

            if (fetchedZoneList.length > 0) {
                setZoneList(fetchedZoneList);
            }

            const selectedZoneForMember =
                fetchedZoneList.find((zone) => zone.Id === selectedCalendarZoneId) ||
                null;
            const defaultZoneForMember =
                fetchedZoneList.find((zone) => zone.DefaultId === 1) ||
                fetchedZoneList[0] ||
                null;
            const resolvedZone =
                selectedZoneForMember ||
                defaultZoneForMember;

            const targetZoneId = resolvedZone?.Id ?? selectedCalendarZoneId;

            if (resolvedZone && !selectedZoneForMember) {
                setSelectedCalendarZoneId(resolvedZone.Id);
                setSelectedZoneName(resolvedZone.ZoneName);
            }

            const isGuestFlag = member.GuId === "0" ? 1 : 0;
            const targetZoneFilters = getStoredFilters(targetZoneId);
            const apiTargetZoneFilters = serializeFiltersForApi(targetZoneFilters);
            setFilters(apiTargetZoneFilters);
            const { zoneData, calendarData, error } = await FetchCalendarWithZone(targetZoneId, apiTargetZoneFilters, member.GuId, isGuestFlag);
            const updatedZoneList = zoneData?.Data?.Records?.ZoneList ?? fetchedZoneList;
            const fallbackZone =
                updatedZoneList.find((zone) => zone.DefaultId === 1) ||
                updatedZoneList[0] ||
                null;
            const fallbackMember =
                teamMemberList[0] || null;

            const resetToDefaultSelections = () => {
                if (updatedZoneList.length > 0) {
                    setZoneList(updatedZoneList);
                }

                if (fallbackZone) {
                    setSelectedCalendarZoneId(fallbackZone.Id);
                    setSelectedZoneName(fallbackZone.ZoneName);
                }

                if (fallbackMember) {
                    setSelectedTeamMember(fallbackMember.GuId);
                    setSelectedTeamId(null);
                    setIsGuest(fallbackMember.GuId === "0" ? 1 : 0);
                    setSelectedName(fallbackMember.FullName);
                    setSelectedQueueUser(fallbackMember.QueueUser ?? 0);
                    setCreditBalance(fallbackMember.Credit ?? 0);
                    saveSharedSelections({
                        zoneId: fallbackZone?.Id ?? selectedCalendarZoneId,
                        zoneName: fallbackZone?.ZoneName ?? selectedZoneName,
                        teamMemberId: fallbackMember.GuId,
                        teamId: null,
                        isGuest: fallbackMember.GuId === "0" ? 1 : 0,
                        selectedName: fallbackMember.FullName,
                    });
                }

                setBookingSpotData([]);
            };

            handleApiUiResponse(calendarData, {
                successToaster: 0,
                errorToaster: 1,
                alertPopup: 1,
                onConfirmByCode: {
                    453: resetToDefaultSelections
                }
            });

            if (!error && calendarData?.Data?.ResponseCode === 200) {
                if (updatedZoneList.length > 0) {
                    setZoneList(updatedZoneList);

                    const calendarZone =
                        updatedZoneList.find((zone) => zone.Id === calendarData?.Data?.Records?.ZoneId) ||
                        updatedZoneList.find((zone) => zone.Id === targetZoneId) ||
                        updatedZoneList[0];

                    if (calendarZone) {
                        setSelectedCalendarZoneId(calendarZone.Id);
                        setSelectedZoneName(calendarZone.ZoneName);
                    }
                }

                const rec = calendarData.Data.Records || {};
                setRecordsData(rec);
                if (Array.isArray(rec.Schedule)) {
                    setBookingSpotData(rec.Schedule);
                } else {
                    setBookingSpotData([]);
                }
            } else if (!error && calendarData?.Data?.ResponseCode === 448) {
                if (updatedZoneList.length > 0) {
                    setZoneList(updatedZoneList);
                }

                if (fallbackZone) {
                    setSelectedCalendarZoneId(fallbackZone.Id);
                    setSelectedZoneName(fallbackZone.ZoneName);
                }

                setBookingSpotData([]);
            } else if (!error && calendarData?.Data?.ResponseCode === 453) {
                // Reset happens after popup confirm.
            } else {
                setBookingSpotData([]);
            }
        } catch (err) {
            console.error("Error in handleMemberSelectionInCalendar:", err);
            setBookingSpotData([]);
        } finally {
            setIsLoading(false);
        }
    };

    const [UserFirstName, setUserFirstName] = useState("");
    const [userLastName, setUserLastName] = useState("");
    const [cancelBookingSpotId, setCancelBookingSpotId] = useState(null);
    const [checkInFlag, setCheckInFlag] = useState(null);
    const [checkInCheckOutRecords, setCheckInCheckOutRecords] = useState([]);

    const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);

    const [currentDayBooking, setCurrentDayBooking] = useState([])

    const [showScheduleMeetingModal, setShowScheduleMeetingModal] = useState(false);

    const [userZoneCreditValue, setUserZoneCreditValue] = useState();
    const [UserzoneCreditBalance, setUserZoneCreditBalance] = useState();

    // const [showBookingModal, setShowBookingModal] = useState(false);
    const [showMeetingModal, setShowMeetingModal] = useState(false);
    const [selectedBookingDate, setSelectedBookingDate] = useState(null);
    const [selectedCancelDate, setSelectedCancelDate] = useState(null);
    const [selectedMeetingDate, setSelectedMeetingDate] = useState(null);
    const [calendarWeeks, setCalendarWeeks] = useState({}); // Cache for weeks already fetched
    const [loadingDates, setLoadingDates] = useState([]); // Dates currently loading bookings
    const activeZoneIdRef = useRef(null);
    const [isMonthly, setIsMonthly] = useState(false);

    const [meetingModalDate, setMeetingModalDate] = useState(null);
    const [notification, setNotification] = useState(null);

    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);

    const history = useHistory();

    const [showFilter, setShowFilter] = useState(false);
    const [filters, setFilters] = useState({});
    const [filteredLayout, setFilteredLayout] = useState([]);
    const [showBookingProcess, setShowBookingProcess] = useState(false)
    const { handleApiUiResponse, renderApiUi } = useApiUiResponse(t);

    const getStoredFilters = (zoneId) => {
        if (!zoneId) return {};

        try {
            const stored = sessionStorage.getItem(`mapFilters_${zoneId}`);
            if (!stored) return {};

            const parsed = JSON.parse(stored);
            return {
                ...parsed,
                FacilityFilter: parsed.FacilityFilterApiValue ?? parsed.FacilityFilter ?? "",
            };
        } catch (error) {
            console.error("Error reading stored filters:", error);
            return {};
        }
    };

    const serializeFiltersForApi = (filterValues = {}) => {
        const normalizeFilterValue = (value) => {
            if (Array.isArray(value)) {
                return value.join(",");
            }
            return value || "";
        };

        return {
            FacilityFilter: normalizeFilterValue(filterValues.FacilityFilter),
            VehicleTypeFilter: normalizeFilterValue(filterValues.VehicleTypeFilter),
            FuelFilter: normalizeFilterValue(filterValues.FuelFilter),
            FilterStartTime: normalizeFilterValue(filterValues.FilterStartTime),
            FilterEndTime: normalizeFilterValue(filterValues.FilterEndTime),
            TagsFilter: normalizeFilterValue(filterValues.TagsFilter),
            AccessibleFilter: normalizeFilterValue(filterValues.AccessibleFilter),
            ShareableFilter: normalizeFilterValue(filterValues.ShareableFilter),
            IsGuest: filterValues?.IsGuest ?? undefined,
        };
    };

    const selectedMemberData =
        teamMemberList.find(m => m.GuId === selectedTeamMember);
    const selectedMemberCredit = selectedMemberData?.Credit ?? creditBalance;
    console.log(selectedMemberCredit, "selectedMemberCreditselectedMemberCredit")
    const selectedMemberCreditBalanceRefillEvery =
        selectedMemberData?.CreditBalanceRefillEvery ?? creditBalanceRefill;
    const selectedCreditPersonName =
        activeGuestFlag === 1
            ? ""
            : (selectedMemberData?.FullName || "");
    const getUpdatedCreditForSelectedMember = (records) => {
        const selectedMemberCreditFromResponse = records?.TeamMemberList?.find(
            (member) => member.GuId === selectedTeamMember
        )?.Credit;

        return selectedMemberCreditFromResponse ?? records?.CreditBalance ?? creditBalance;
    };

    useEffect(() => {
        document.title = `${t("calendar")} | Ronspot`
    }, []);

    useEffect(() => {
        if (!selectedTeamMember) return;
        const member = teamMemberList.find(m => m.GuId === selectedTeamMember);
        if (member && typeof member.Credit !== 'undefined') {
            setCreditBalance(member.Credit);
        }
    }, [selectedTeamMember, teamMemberList]);

    useEffect(() => {
        if (selectedTeamId !== null || !selectedTeamMember) return;

        const nextIsGuest = String(selectedTeamMember) === "0" ? 1 : 0;
        if (isGuest !== nextIsGuest) {
            setIsGuest(nextIsGuest);
        }
    }, [selectedTeamMember, selectedTeamId, isGuest]);

    //handle Postbooking Que Modal
    const [showPostbookingQueModal, setShowPostbookingQueModal] = useState(false);
    const [postbookingQueModalData, setPostbookingQueModalData] = useState([]);
    const [postRequestParams, setPostRequestParams] = useState(null);

    //Pre Booking Question
    const [checkedPreBookingQue, setCheckedPreBookingQue] = useState(false);

    const [showGuestPopupFullday, setshowGuestPopupFullday] = useState(false);
    const [showGuestPopup30mit, setShowGuestPopup30mit] = useState(false);
    const [showAddVehiclePopup, setShowAddVehiclePopup] = useState(false);
    const [pendingGuestBooking, setPendingGuestBooking] = useState(null);
    const [guestBookingConfirmation, setGuestBookingConfirmation] = useState(null);

    const [guestName, setGuestName] = useState("");
    const [guestLastName, setGuestLastName] = useState("")
    const [guestEmail, setGuestEmail] = useState("");
    const [identificatoin, setIdentification] = useState("")
    const [selectedGuestVehicleNumber, setSelectedGuestVehicleNumber] = useState("")
    const [guestName30mit, setGuestName30mit] = useState("");
    const [guestLastName30mit, setGuestLastName30mit] = useState("")
    const [guestEmail30mit, setGuestEmail30mit] = useState("");
    const [identificatoin30mit, setIdentification30mit] = useState("")
    const [guestErrors, setGuestErrors] = useState({
        fullDay: {
            firstname: "",
            lastname: "",
            email: ""
        },
        thirtyMin: {
            firstname: "",
            lastname: "",
            email: ""
        }
    });
    const [selectedGuestVehicleType, setSelectedGuestVehicleType] = useState(null);
    const [selectedGuestFuelType, setSelectedGuestFuelType] = useState(null);
    const [selectedGuestShareableType, setSelectedGuestShareableType] = useState(null);
    const [selectedGuestAccessibleType, setSelectedGuestAccessibleType] = useState(null);
    const [isTagListDataEmpty, setIsTagListDataEmpty] = useState(true);
    const emailPattern = /^[a-zA-Z0-9_.\-^'`?=]+@([a-zA-Z0-9-]+\.)+([a-zA-Z0-9]{2,4})$/;

    const getSafeDisplayDate = (value) => {
        if (!value) return null;
        
        if (value instanceof Date) {
            const parsed = new Date(value.getFullYear(), value.getMonth(), value.getDate());
            return Number.isNaN(parsed.getTime()) ? null : parsed;
        }

        const stringValue = String(value).trim();
        const parts = stringValue.split("-");

        if (parts.length === 3) {
            const [year, month, day] = parts.map(Number);
            const parsed = new Date(year, month - 1, day);
            return Number.isNaN(parsed.getTime()) ? null : parsed;
        }

        const parsed = new Date(stringValue);
        return Number.isNaN(parsed.getTime()) ? null : parsed;
    };

    const getLocalDateString = (value) => {
        const parsed = getSafeDisplayDate(value);

        if (!parsed) {
            return "";
        }

        return `${parsed.getFullYear()}-${String(parsed.getMonth() + 1).padStart(2, "0")}-${String(parsed.getDate()).padStart(2, "0")}`;
    };

    const getWeekKeyFromDate = (value) => {
        const parsed = getSafeDisplayDate(value);

        if (!parsed) {
            return null;
        }

        const dayOfWeek = parsed.getDay();
        const diff = parsed.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
        const monday = new Date(parsed);
        monday.setDate(diff);

        return `${monday.getFullYear()}-${monday.getMonth()}-${monday.getDate()}`;
    };

    useEffect(() => {
        const tagListData = recordsData?.TagListData;

        if (!tagListData) {
            setIsTagListDataEmpty(true);
            return;
        }

        const areAllArraysEmpty = Object.values(tagListData).every(
            (list) => Array.isArray(list) && list.length === 0
        );
        console.log(areAllArraysEmpty, "areAllArraysEmpty")

        setIsTagListDataEmpty(areAllArraysEmpty);
    }, [recordsData?.TagListData]);

    const resetForm = () => {
        setShowBookingModal(false)
        setCheckedPreBookingQue(false)
        setshowGuestPopupFullday(false);
        setShowGuestPopup30mit(false);
        setPendingGuestBooking(null);
        setGuestName("");
        setGuestLastName("");
        setGuestEmail("");
        setIdentification("");
        setGuestName30mit("");
        setGuestLastName30mit("");
        setGuestEmail30mit("");
        setIdentification30mit("");
        setSelectedGuestVehicleType(null);
        setSelectedGuestFuelType(null);
        setSelectedGuestShareableType(null);
        setSelectedGuestAccessibleType(null);
        setSelectedGuestVehicleNumber("")
        setGuestErrors({
            fullDay: {
                firstname: "",
                lastname: "",
                email: ""
            },
            thirtyMin: {
                firstname: "",
                lastname: "",
                email: ""
            }
        });

    };

    const closeGuestBookingConfirmation = () => setGuestBookingConfirmation(null);
    const openGuestBookingConfirmation = (calendarResponse, reqParams = {}) => {
        if (Number(reqParams?.IsGuest) !== 1) {
            return;
        }

        const records = calendarResponse?.Data?.Records || {};
        const bookedDate =
            reqParams?.BookingDateStr ||
            reqParams?.BookingDate ||
            "";
        const zoneName =
            records?.ZoneName ||
            selectedZoneName ||
            "";
        const name =
            [reqParams?.GuestFirstName, reqParams?.GuestLastName]
                .filter(Boolean)
                .join(" ")
                .trim() ||
            records?.GuestName ||
            records?.Name ||
            records?.FullName ||
            t("guest");
        const spotNameFromRequest =
            typeof (reqParams?.SpotName || reqParams?.spotName) === "string"
                ? (reqParams?.SpotName || reqParams?.spotName).trim()
                : "";
        const spotNameFromCalendarResponse =
            records?.CurrentDayBookingRecords?.find((booking) => {
                const bookingSpotName =
                    booking?.SpotName ||
                    booking?.Schedules?.[0]?.SpotName ||
                    "";

                if (!bookingSpotName) {
                    return false;
                }

                const bookingDateValue =
                    booking?.BookingDateStr ||
                    booking?.BookingDate ||
                    booking?.BookedDate ||
                    "";

                return !bookedDate || bookingDateValue === bookedDate;
            })?.SpotName ||
            records?.CurrentDayBookingRecords?.[0]?.SpotName ||
            records?.Schedule?.find((booking) => {
                const bookingSpotName =
                    booking?.SpotName ||
                    booking?.Schedules?.[0]?.SpotName ||
                    "";

                if (!bookingSpotName) {
                    return false;
                }

                const bookingDateValue =
                    booking?.BookingDateStr ||
                    booking?.BookingDate ||
                    booking?.BookedDate ||
                    "";

                return !bookedDate || bookingDateValue === bookedDate;
            })?.SpotName ||
            records?.Schedule?.[0]?.SpotName ||
            "";
        const spotName =
            (spotNameFromCalendarResponse && spotNameFromCalendarResponse !== "0"
                ? spotNameFromCalendarResponse
                : "") ||
            (spotNameFromRequest && spotNameFromRequest !== "0"
                ? spotNameFromRequest
                : "") ||
            records?.SpotName ||
            records?.SpaceName ||
            records?.Schedules?.[0]?.SpotName ||
            "";

        setGuestBookingConfirmation({
            name,
            zoneName,
            bookedDate,
            spotName,
            startTime: reqParams?.BookingStartTime || reqParams?.StartTime || "",
            endTime: reqParams?.BookingEndTime || reqParams?.EndTime || "",
        });
    };

    const clearGuestFieldError = (section, field) => {
        setGuestErrors((prev) => ({
            ...prev,
            [section]: {
                ...prev[section],
                [field]: ""
            }
        }));
    };

    const validateGuestFields = ({ name, surname, email }, section) => {
        const nextErrors = {
            firstname: "",
            lastname: "",
            email: ""
        };
        let isValid = true;

        if (!(name || "").trim()) {
            nextErrors.firstname = t("please_enter_name");
            isValid = false;
        }

        if (!(surname || "").trim()) {
            nextErrors.lastname = t("react_enter_valid_surname");
            isValid = false;
        }

        const trimmedEmail = (email || "").trim();
        if (!trimmedEmail || !emailPattern.test(trimmedEmail)) {
            nextErrors.email = t("enter_your_valid_email_address");
            isValid = false;
        }

        setGuestErrors((prev) => ({
            ...prev,
            [section]: nextErrors
        }));

        return isValid;
    };

    const {
        handleResponseCode,
        showAlertPopupModal,
        alertPopupModalData,
        showErrorPopupModal,
        errorPopupModalData,
        setShowAlertPopupModal,
        setShowErrorPopupModal
    } = useApiResponseHandler();

    const toggle = (e) => {
        e.stopPropagation();                // prevent immediate close
        if (zoneList?.length > 0) setOpen((v) => !v);
    };

    // const onSelect = (zone) => {
    //     // Build a fake <select>-like event
    //     const fakeEvent = {
    //         target: {
    //             value: zone.Id.toString(),
    //             options: [{ text: zone.ZoneName }],
    //             selectedIndex: 0,
    //         },
    //     };

    //     handleZoneChange(fakeEvent);
    //     setOpen(false);
    // };

    const onSelect = (zone) => {
        // ⏳ 1. Wipe cached future weeks data so it pulls fresh filtered data
        loadedMonthKeyRef.current = "";
        setWeekData({});
        setLoadingWeeks({});
        // Pass the zone object and the current team member ID directly
        handleZoneChange(zone, selectedTeamMember, activeGuestFlag);
        setOpen(false);
    };

    const timeOutTime = 3000;
    // const getGuId = () => localStorage.getItem("guId");
    //const getGuId = () => sessionStorage.getItem("guId");

    // const getGuId = () => authMemory.getGuId(); //reactmemory version

    console.log("getGuId in Calendar Testing file:", getGuId());
    const day = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();
    const TodayDate = year + "-" + month + "-" + day;

    const today = new Date(); // Use a local 'today' for comparison
    const todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    const getBookingForDate = (bookingDateStr) => {
        const weekMatch = Object.values(weekData || {})
            .flat()
            .find((booking) => booking.BookingDate === bookingDateStr);

        return weekMatch || bookingSpotData.find((booking) => booking.BookingDate === bookingDateStr) || null;
    };

    useEffect(() => {
        if (!showGuestPopupFullday || !pendingGuestBooking?.bookingDateStr) return;

        const bookingForDate = getBookingForDate(pendingGuestBooking.bookingDateStr);
        const guestVehicleTypes = bookingForDate?.GuestVehicleTypes || bookingForDate?.GuestVehicleType || [];
        const guestFuelTypes = bookingForDate?.GuestFuelTypes || [];
        const guestShareableTypes = bookingForDate?.GuestShareableTypes || [];
        const guestAccessibleTypes = bookingForDate?.GuestAccessibleTypes || [];

        setSelectedGuestVehicleType(guestVehicleTypes[0] || null);
        setSelectedGuestFuelType(guestFuelTypes[0] || null);
        setSelectedGuestShareableType(guestShareableTypes.length > 0 ? { Id: 0, Name: "--" } : null);
        setSelectedGuestAccessibleType(guestAccessibleTypes.length > 0 ? { Id: 0, Name: "--" } : null);
    }, [showGuestPopupFullday, pendingGuestBooking, weekData, bookingSpotData]);

    useEffect(() => {
        setWeeklyPercentages(generateUniquePercentages(7, 10, 30));

        // Remove the 1-second interval entirely (causes popup flicker)
        setCurrentDate(new Date());

        Calendar_Logic();

        if (sessionStorage.getItem("vehiclenotavailable") === "true") {
            setShowAddVehiclePopup(true);
            sessionStorage.removeItem("vehiclenotavailable");
        }
    }, []);

    const handleAddVehiclePopupClose = () => {
        setShowAddVehiclePopup(false);
    };

    const handleAddVehiclePopupConfirm = () => {
        setShowAddVehiclePopup(false);
        history.push("/profile");
    };

    useEffect(() => {
        const handleOutsideClick = (event) => {
            // Check if the click is outside the dropdown
            if (rootRef.current && !rootRef.current.contains(event.target)) {
                setOpen(false); // Close the dropdown
            }
        };

        // Add the event listener to the document
        document.addEventListener('mousedown', handleOutsideClick);

        // Clean up the event listener when the component unmounts
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [rootRef]);

    useEffect(() => {
        if (recordsData?.TeamMemberList && Array.isArray(recordsData.TeamMemberList)) {
            setTeamMemberList(recordsData.TeamMemberList);

            const sharedSelections = getSharedSelections();
            const sharedMemberGuid = sharedSelections.teamMemberId || "";
            const firstMemberGuid = recordsData.TeamMemberList[0]?.GuId;

            // 🛡️ Only set if selectedTeamMember is completely empty or null
            if (!selectedTeamMember && sharedMemberGuid && recordsData.TeamMemberList.some(m => m.GuId === sharedMemberGuid)) {
                setSelectedTeamMember(sharedMemberGuid);
                setIsGuest(sharedSelections.isGuest ?? 0);
                setSelectedName(sharedSelections.selectedName || "");
            } else if (!selectedTeamMember && firstMemberGuid) {
                setSelectedTeamMember(firstMemberGuid);
                setIsGuest(firstMemberGuid === "0" ? 1 : 0);
            } else if (selectedTeamMember && firstMemberGuid) {
                // Check if the current selected member even exists in this new zone's list
                const exists = recordsData.TeamMemberList.some(m => m.GuId === selectedTeamMember);
                if (!exists) {
                    setSelectedTeamMember(firstMemberGuid); // Only overwrite if it's invalid for this zone
                    setIsGuest(firstMemberGuid === "0" ? 1 : 0);
                }
            }
        }
    }, [recordsData]);

    // Close dropdown on outside click
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                teamMemberDropdownRef.current &&
                !teamMemberDropdownRef.current.contains(e.target)
            ) {
                setTeamMemberOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        if (!selectedCalendarZoneId && !selectedTeamMember && selectedTeamId == null && !selectedName) {
            return;
        }

        saveSharedSelections({
            zoneId: selectedCalendarZoneId || null,
            zoneName: selectedZoneName || "",
            teamMemberId: selectedTeamMember || "",
            teamId: selectedTeamId ?? null,
            isGuest: activeGuestFlag,
            selectedName: selectedName || "",
        });
    }, [selectedCalendarZoneId, selectedZoneName, selectedTeamMember, selectedTeamId, activeGuestFlag, selectedName]);

    function formatDateString(dateString) {
        if (!dateString) { // Handle cases where dateString might be null or undefined
            return null; // Or new Date() to return today's date, depending on your logic
        }

        const date = getSafeDisplayDate(dateString);

        // Crucial: Check if the created Date object is valid
        if (!date || isNaN(date.getTime())) {
            // It's an "Invalid Date". Log an error or handle it.
            console.error("Could not parse date string:", dateString);
            return null; // Or throw an error, or return a default date
        }
        return date;
    }

    const performCalendarApiCall = async (bookingDateInput, zoneId, SpotId, options = {}) => {
        console.log("performCalendarApiCall()", bookingDateInput, zoneId, SpotId, options);

        const bookingDate = getSafeDisplayDate(bookingDateInput);
        if (!bookingDate) {
            console.error("Invalid booking date passed to performCalendarApiCall:", bookingDateInput);
            return;
        }

        bookingDate.setHours(0, 0, 0, 0);
        const formattedBookingDate = `${bookingDate.getFullYear()}-${String(bookingDate.getMonth() + 1).padStart(2, "0")}-${String(bookingDate.getDate()).padStart(2, "0")}`;
        const passMonthtoAPI = bookingDate.getMonth() + 1
        console.log(passMonthtoAPI, "passMonthtoAPI")
        const dayOfWeek = bookingDate.getDay();
        const diff = bookingDate.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
        const mondayOfWeek = new Date(bookingDate);
        mondayOfWeek.setDate(diff);
        mondayOfWeek.setHours(0, 0, 0, 0);
        const weekKey = `${mondayOfWeek.getFullYear()}-${mondayOfWeek.getMonth()}-${mondayOfWeek.getDate()}`;

        // setLoadingWeeks((prev) => ({ ...prev, [weekKey]: true }));
        setIsLoading(true);

        try {
            const activeFilters = serializeFiltersForApi(getStoredFilters(zoneId));
            setFilters(activeFilters);
            const { calendarData, error } = await BookingCancelNewWeekRefresh(
                formattedBookingDate,
                zoneId,
                passMonthtoAPI,
                selectedTeamMember,
                activeGuestFlag,
                activeFilters
            );

            if (error) {
                console.error("Error in performCalendarApiCall:", error);
                return;
            }

            if (calendarData?.Data?.ResponseCode === 200) {
                setRecordsData(calendarData?.Data?.Records);

                if (Array.isArray(calendarData.Data.Records.Schedule)) {
                    const rawSchedule = [...calendarData.Data.Records.Schedule];
                    const isMonthNavigationRefresh = options?.source === "month-navigation";

                    const getWeekKeyForDate = (dateValue) => {
                        const date = getSafeDisplayDate(dateValue);
                        if (!date || Number.isNaN(date.getTime())) return null;
                        date.setHours(0, 0, 0, 0);
                        const currentDay = date.getDay();
                        const mondayDiff = date.getDate() - currentDay + (currentDay === 0 ? -6 : 1);
                        date.setDate(mondayDiff);
                        return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
                    };

                    let freshSchedule = rawSchedule.filter(
                        (scheduleItem) => getWeekKeyForDate(scheduleItem?.BookingDate) === weekKey
                    );

                    if (isMonthNavigationRefresh) {
                        // Month navigation returns the full month payload, so replace the
                        // month dataset and clear stale week caches from the previously viewed month.
                        loadedMonthKeyRef.current = `${bookingDate.getFullYear()}-${bookingDate.getMonth()}`;
                        setBookingSpotData(rawSchedule);
                        setWeekData({ [weekKey]: freshSchedule });
                        setLoadingWeeks({});
                    } else {
                        setWeekData((prev) => ({ ...prev, [weekKey]: freshSchedule }));
                        setBookingSpotData((prevData) => {
                            if (!Array.isArray(prevData)) return freshSchedule;

                            const freshScheduleByDate = new Map(
                                freshSchedule.map((scheduleItem) => [scheduleItem.BookingDate, scheduleItem])
                            );

                            const updated = prevData.map((booking) => {
                                const refreshedBooking = freshScheduleByDate.get(booking.BookingDate);
                                return refreshedBooking ? { ...booking, ...refreshedBooking } : booking;
                            });

                            const existingDates = new Set(updated.map((booking) => booking.BookingDate));
                            const missingBookings = freshSchedule.filter(
                                (scheduleItem) => !existingDates.has(scheduleItem.BookingDate)
                            );

                            return missingBookings.length > 0 ? [...updated, ...missingBookings] : updated;
                        });
                    }

                    console.log("API returned schedule for this week only:", freshSchedule);
                    setCalendarRenderKey((prev) => prev + 1);
                }
            } else {
                console.error(
                    "Calendar API response code not 200:",
                    calendarData?.Data?.ResponseCode
                );
            }
        } catch (err) {
            console.error("Error performing calendar API call:", err);
        } finally {
            // setLoadingWeeks((prev) => ({ ...prev, [weekKey]: false }));
            setIsLoading(false);
            setShowBookingProcess(false)
        }
    };

    const getCheckInSummary = (bookingRecords = []) => {
        const totalCount = bookingRecords.length;
        const pendingCheckInCount = bookingRecords.filter((booking) => {
            const flag = Number(booking?.CheckInFlag);
            return flag === 0 || flag === 2;
        }).length;
        const checkedInCount = bookingRecords.filter((booking) => {
            const flag = Number(booking?.CheckInFlag);
            return flag === 1;
        }).length;

        return {
            totalCount,
            pendingCheckInCount,
            checkedInCount,
            shouldShowCheckIn: pendingCheckInCount > 0,
            shouldShowCheckOut: totalCount > 0 && checkedInCount === totalCount,
        };
    };

    const updateCheckInButtonUI = useCallback(() => {
        setTimeout(() => {
            const btn = document.querySelector('.fc-checkInBtn-button');
            if (!btn) return;

            const currentDayBookingRecords = recordsData?.CurrentDayBookingRecords || [];
            const {
                totalCount,
                pendingCheckInCount,
                checkedInCount,
                shouldShowCheckIn,
            } = getCheckInSummary(currentDayBookingRecords);

            if (totalCount === 0) {
                btn.classList.remove("active");
                btn.style.display = 'none';
                return;
            }

            btn.style.display = 'inline-block';

            if (shouldShowCheckIn) {
                btn.classList.remove("active");
                btn.innerHTML = totalCount > 1
                    ? `
                    ${t("react_check_in")}
                    <span class="color-orange">(${pendingCheckInCount})</span>
                `
                    : `${t("react_check_in")}`;
                return;
            }

            btn.innerHTML = totalCount > 1
                ? `
                ${t("react_check_out")}
                <span>(${checkedInCount})</span>
            `
                : `${t("react_check_out")}`;
            btn.classList.add("active");
        }, 0);
    }, [recordsData, t]);

    useEffect(() => {
        const currentDayRecords = Array.isArray(recordsData?.CurrentDayBookingRecords)
            ? recordsData.CurrentDayBookingRecords
            : [];

        setCheckInCheckOutRecords(currentDayRecords);

        if (currentDayRecords.length === 0) {
            setShowModal(false);
        }

        updateCheckInButtonUI();
    }, [recordsData, updateCheckInButtonUI]);

    useEffect(() => {
        activeZoneIdRef.current = selectedCalendarZoneId ?? null;
    }, [selectedCalendarZoneId]);

    useEffect(() => {
        setLoadingDates([]);
    }, [selectedCalendarZoneId]);


    const Calendar_Logic = useCallback(async () => {
        setIsLoading(true);

        try {
            // Read tokens saved by LoginEvent
            const accessToken = getAccessToken();
            console.log("CALENDARAWERAccess Token:", accessToken);
            const guid = getGuId();

            // const accessToken = () => authMemory.getAccessToken();
            // const guid = () => authMemory.getGuId();//reactmemory version

            // If user NOT logged in, redirect to Login screen
            if (!accessToken || !guid) {
                console.warn("No login token found. Redirecting to login...");
                history.push("/");   // redirect to login
                return;
            }

            console.log("User authenticated. Running Calendar logic...");
            const sharedSelections = getSharedSelections();
            const shouldUseMapSharedZone = sessionStorage.getItem(MAP_TO_CALENDAR_SYNC_KEY) === "1";
            const persistedCalendarZoneId = getPersistedCalendarZoneId();
            const effectiveInitialZoneId = shouldUseMapSharedZone
                ? (Number(sharedSelections.zoneId) || persistedCalendarZoneId || selectedCalendarZoneId || null)
                : (persistedCalendarZoneId || selectedCalendarZoneId || null);

            let activeFilters = null;
            if (effectiveInitialZoneId) {
                const storedFilters = getStoredFilters(effectiveInitialZoneId);
                if (Object.keys(storedFilters).length > 0) {
                    activeFilters = serializeFiltersForApi(storedFilters);
                    console.log("Found saved filters for zone reload:", activeFilters);
                }
            }
            setFilters(activeFilters || {});
            const persistedMemberGuid = sharedSelections.teamMemberId || "";
            let memberToFetch = selectedTeamMember || persistedMemberGuid || "";
            let guestFlagToFetch = String(memberToFetch) === "0"
                ? 1
                : (sharedSelections.isGuest ?? 0);

            // Fetch Calendar + Zones + TeamMember
            const { zoneData, calendarData, error } = await FetchCalendarWithZone(
                effectiveInitialZoneId,
                activeFilters,
                memberToFetch,
                guestFlagToFetch
            );
            if (shouldUseMapSharedZone) {
                sessionStorage.removeItem(MAP_TO_CALENDAR_SYNC_KEY);
            }

            const zoneResponseCode = Number(zoneData?.Data?.ResponseCode || 0);
            const zoneHasError = error || (zoneData?.Data && zoneResponseCode !== 200);
            const resetInitialZoneSelection = () => resetDropdownToDefault(zoneData?.Data?.Records?.ZoneList ?? zoneList);

            handleApiUiResponse(zoneData, {
                successToaster: 0,
                errorToaster: 1,
                alertPopup: 1,
                onConfirmByCode: {
                    [zoneResponseCode]: resetInitialZoneSelection
                }
            });

            if (zoneHasError) {
                console.error("Error during initial FetchCalendarWithZone:", error || `ZoneData code ${zoneResponseCode}`);
                setZoneList([]);
                setSelectedCalendarZoneId(0);
                setSelectedZoneName("Error loading zones");
                return;
            }

            handleApiUiResponse(calendarData, {
                successToaster: 0,
                errorToaster: 1,
                alertPopup: 1
            });

            if (error) {
                console.error("Error during initial FetchCalendarWithZone:", error);
                setZoneList([]);
                setSelectedCalendarZoneId(0);
                setSelectedZoneName("Error loading zones");
                return;
            }

            // Process ZONE list
            let fetchedZoneList = zoneData?.Data?.Records?.ZoneList ?? [];
            if (fetchedZoneList.length === 0) {
                const zoneResponse = await ZoneList(memberToFetch);
                fetchedZoneList = zoneResponse?.Data?.Records?.ZoneList ?? [];
            }
            setZoneList(fetchedZoneList);

            let defaultZone = fetchedZoneList.find((z) => z.Id === Number(effectiveInitialZoneId))
                || fetchedZoneList.find((z) => z.Id === Number(sharedSelections.zoneId))
                || fetchedZoneList.find((z) => z.DefaultId === 1);
            if (!defaultZone && fetchedZoneList.length > 0) {
                defaultZone = fetchedZoneList[0];
            }

            if (defaultZone) {
                setSelectedCalendarZoneId(defaultZone.Id);
                setSelectedZoneName(defaultZone.ZoneName);
                setFilters(serializeFiltersForApi(getStoredFilters(defaultZone.Id)));
                saveSharedSelections({
                    zoneId: defaultZone.Id,
                    zoneName: defaultZone.ZoneName,
                });
            } else {
                setSelectedCalendarZoneId(0);
                setSelectedZoneName("No Zones Available");
                setFilters({});
            }

            if (calendarData?.Data?.ResponseCode === 453) {
                if (defaultZone) {
                    const { calendarData: fallbackCalendarData, error: fallbackError } =
                        await FetchCalendarWithZone(defaultZone.Id, activeFilters, memberToFetch);

                    if (!fallbackError && fallbackCalendarData?.Data?.ResponseCode === 200) {
                        const rec = fallbackCalendarData.Data.Records || {};

                        setRecordsData(rec);
                        setMapAvailable(rec?.MapExist ?? 0);
                        setMapAvailableType(rec?.MapType ?? 0);
                        setUserFirstName(rec?.FirstName ?? "");
                        setUserLastName(rec?.LastName ?? "");
                        setMainCurrentDate(rec?.ZoneCurrentDate ?? "");
                        setTeamLeadFlag(rec?.TeamLeadFlag ?? 0);
                        setIsQueue(rec?.QueueUser ?? 0);
                        setSelectedQueueUser(rec?.QueueUser ?? 0);
                        setZoneCreditValue(rec?.ZoneCreditValue ?? 0);
                        setCreditBalance(rec?.CreditBalance ?? 0);
                        setCreditCreditBalance(rec?.CreditBalanceRefillEvery ?? 0);
                        setIsThumbnailPresent(rec?.IsThumbnailPresent ?? 0);
                        setCompanyId(Number(rec?.CompanyId ?? 0));
                        setCheckInCheckOutRecords(rec?.CurrentDayBookingRecords ?? []);
                        setCreditValue(rec?.ZoneCreditValue ?? 0);
                        setIconZoneType(rec?.ZoneType ?? null);
                        const PreBookingQue = rec?.PreBookingQuestion;
                        setPreBookingQuestion(PreBookingQue ? PreBookingQue.replace(/<\/?p>/g, "").trim() : "");

                        if (Array.isArray(rec.Schedule)) {
                            setBookingSpotData(rec.Schedule);
                        } else {
                            setBookingSpotData([]);
                        }
                    } else {
                        setBookingSpotData([]);
                    }
                }
                return;
            }

            // Process Calendar Data
            if (calendarData?.Data?.ResponseCode === 200) {

                const rec = calendarData.Data.Records || {};
                const responseTeamMembers = Array.isArray(rec?.TeamMemberList) ? rec.TeamMemberList : [];
                const resolvedMemberGuid = selectedTeamMember || persistedMemberGuid || "";
                const matchedMember = responseTeamMembers.find((member) => member.GuId === resolvedMemberGuid);
                const fallbackMember = matchedMember || responseTeamMembers[0] || null;

                console.log("API Records:", rec);

                setRecordsData(rec);

                setMapAvailable(rec?.MapExist ?? 0);
                setMapAvailableType(rec?.MapType ?? 0);
                setUserFirstName(rec?.FirstName ?? "");
                setUserLastName(rec?.LastName ?? "")
                setMainCurrentDate(rec?.ZoneCurrentDate ?? "");
                setTeamLeadFlag(rec?.TeamLeadFlag ?? 0);
                setIsQueue(rec?.QueueUser ?? 0);
                setSelectedQueueUser(rec?.QueueUser ?? 0);
                // setPreBookingQuestion(rec?.PreBookingQuestion ? recordsData.PreBookingQuestion.replace(/<\/?p>/g, "").trim() : "");
                // setPreBookingQuestion(rec?.PreBookingQuestion ?? "");
                setZoneCreditValue(rec?.ZoneCreditValue ?? 0);
                setCreditBalance(rec?.CreditBalance ?? 0);
                setCreditCreditBalance(rec?.CreditBalanceRefillEvery ?? 0);
                setIsThumbnailPresent(rec?.IsThumbnailPresent ?? 0);
                setCompanyId(Number(rec?.CompanyId ?? 0));
                setCheckInCheckOutRecords(rec?.CurrentDayBookingRecords ?? []);
                setCreditValue(rec?.ZoneCreditValue ?? 0);
                setIconZoneType(rec?.ZoneType ?? null);
                const PreBookingQue = rec?.PreBookingQuestion;
                setPreBookingQuestion(PreBookingQue ? PreBookingQue.replace(/<\/?p>/g, "").trim() : "");

                if (fallbackMember) {
                    setSelectedTeamMember(fallbackMember.GuId);
                    setSelectedQueueUser(fallbackMember.QueueUser ?? rec?.QueueUser ?? 0);
                    setIsGuest(fallbackMember.GuId === "0" ? 1 : (sharedSelections.isGuest ?? 0));
                    setSelectedName(fallbackMember.FullName || sharedSelections.selectedName || "");

                    saveSharedSelections({
                        teamMemberId: fallbackMember.GuId,
                        isGuest: fallbackMember.GuId === "0" ? 1 : (sharedSelections.isGuest ?? 0),
                        selectedName: fallbackMember.FullName || sharedSelections.selectedName || "",
                    });
                }

                if (Array.isArray(rec.Schedule)) {
                    setBookingSpotData(rec.Schedule);
                } else {
                    setBookingSpotData([]);
                }
            }
            else {
                console.error("Calendar API Response not 200:", calendarData?.Data?.ResponseCode);
                setBookingSpotData([]);
            }
        } catch (err) {
            console.error("Error inside Calendar_Logic:", err);
            setBookingSpotData([]);
            setZoneList([]);
            setSelectedCalendarZoneId(0);
            setSelectedZoneName("Error loading zones");
        } finally {
            setIsLoading(false);
        }
    }, []);

    //     const Calendar_Logic = useCallback(async () => {
    //     setIsLoading(true);

    //     try {
    //         const accessToken = sessionStorage.getItem("accessToken");
    //         const guid = sessionStorage.getItem("guId");

    //         if (!accessToken || !guid) {
    //             history.push("/"); 
    //             return;
    //         }

    //         // 1. 👇 Now `selectedTeamMember` will be the latest selected value!
    //         const { zoneData, calendarData, error } = await FetchCalendarWithZone(
    //             null, // Or whatever your Zone ID param is for initial load
    //             null, // filters
    //             selectedTeamMember 
    //         );

    //         // ... rest of your code stays exactly the same ...
    //         const fetchedZoneList = zoneData?.Data?.Records?.ZoneList ?? [];
    //         setZoneList(fetchedZoneList);

    //         let defaultZone = fetchedZoneList.find((z) => z.DefaultId === 1);
    //         if (!defaultZone && fetchedZoneList.length > 0) {
    //             defaultZone = fetchedZoneList[0];
    //         }

    //         if (defaultZone) {
    //             setSelectedCalendarZoneId(defaultZone.Id);
    //             setSelectedZoneName(defaultZone.ZoneName);
    //         }

    //         if (calendarData?.Data?.ResponseCode === 200) {
    //             const rec = calendarData.Data.Records || {};
    //             setRecordsData(rec);
    //             setMapAvailable(rec?.MapExist ?? 0);
    //             setMapAvailableType(rec?.MapType ?? 0);
    //             setUserFirstName(rec?.FirstName ?? "");
    //             setMainCurrentDate(rec?.ZoneCurrentDate ?? "");
    //             setTeamLeadFlag(rec?.TeamLeadFlag ?? 0);
    //             setIsQueue(rec?.QueueUser ?? 0);
    //             // setPreBookingQuestion(rec?.PreBookingQuestion ? recordsData.PreBookingQuestion.replace(/<\/?p>/g, "").trim() : "");
    //             setPreBookingQuestion(rec?.PreBookingQuestion ?? "");
    //             setZoneCreditValue(rec?.ZoneCreditValue ?? 0);
    //             setCreditBalance(rec?.CreditBalance ?? 0);
    //             setCreditCreditBalance(rec?.CreditBalanceRefillEvery ?? 0);
    //             setCheckInCheckOutRecords(rec?.CurrentDayBookingRecords ?? []);
    //             setCreditValue(rec?.ZoneCreditValue ?? 0);
    //             setIconZoneType(rec?.ZoneType ?? null);

    //             if (Array.isArray(rec.Schedule)) {
    //                 setBookingSpotData(rec.Schedule);
    //             } else {
    //                 setBookingSpotData([]);
    //             }
    //         }
    //     } catch (err) {
    //         console.error("Error inside Calendar_Logic:", err);
    //     } finally {
    //         setIsLoading(false);
    //     }
    // }, [selectedTeamMember]); // ✅ Add selectedTeamMember here!



    const applyFilters = async (
        zoneId,
        currentDate,
        teamMemberId,
        teamId,
        guestFlag,
        activeFilters
    ) => {
        setIsLoading(true);
        try {
            console.log("Applying specific filters to Calendar API:", activeFilters);

            // Fetch calendar data with the active filters payload
            const { calendarData, error } = await FetchCalendarWithZone(
                zoneId,
                activeFilters,
                teamMemberId,
                guestFlag
            );

            if (!error && calendarData?.Data?.ResponseCode === 200) {
                const rec = calendarData.Data.Records || {};
                setRecordsData(rec);

                if (Array.isArray(rec.Schedule)) {
                    setBookingSpotData(rec.Schedule);
                } else {
                    setBookingSpotData([]);
                }
            } else {
                console.error("Failed to filter calendar data.");
            }
        } catch (err) {
            console.error("Error applying filters:", err);
        } finally {
            setIsLoading(false);
        }
    };

    // Zone, Team Member, Session Filters.
    useEffect(() => {
        return;

        const fetchCalendarData = async () => {
            setIsLoading(true);
            try {
                // 📂 1. Check for Saved Session Filters for this SPECIFIC zone
                const savedFiltersStr = sessionStorage.getItem(`mapFilters_${selectedCalendarZoneId}`);
                let activeFilters = {};

                if (savedFiltersStr) {
                    activeFilters = JSON.parse(savedFiltersStr);
                    setFilters(activeFilters); // 🔄 Sync back to React state
                } else {
                    setFilters({}); // 🧹 Clear filters state if zone has no saved filters
                    activeFilters = {};
                }

                console.log("Master Effect Fetching Zone:", selectedCalendarZoneId, "with member:", selectedTeamMember);

                // 🚀 2. Single API Call with correct Zone, Member, and calculated Filters!
                const { calendarData, error } = await FetchCalendarWithZone(
                    selectedCalendarZoneId,
                    activeFilters,
                    selectedTeamMember
                );

                if (!error && calendarData?.Data?.ResponseCode === 200) {
                    const rec = calendarData.Data.Records || {};
                    setRecordsData(rec);

                    if (Array.isArray(rec.Schedule)) {
                        setBookingSpotData(rec.Schedule);
                    } else {
                        setBookingSpotData([]);
                    }
                } else {
                    setBookingSpotData([]);
                }
            } catch (err) {
                console.error("Master Effect API Error:", err);
                setBookingSpotData([]);
            } finally {
                setIsLoading(false);
            }
        };

        fetchCalendarData();

    }, [selectedCalendarZoneId, selectedTeamMember]);


    const handleZoneChange = useCallback(async (zone, teamMemberId, guestFlag = activeGuestFlag) => {
        const newZoneId = zone.Id;
        const newZoneName = zone.ZoneName;
        const zoneSpecificFilters = serializeFiltersForApi(getStoredFilters(newZoneId));
        const applyCalendarZoneData = (rec) => {
            const responseTeamMembers = Array.isArray(rec?.TeamMemberList) ? rec.TeamMemberList : [];
            const resolvedMemberGuid = teamMemberId || selectedTeamMember || "";
            const matchedMember = responseTeamMembers.find((member) => member.GuId === resolvedMemberGuid);
            const fallbackMember = matchedMember || responseTeamMembers[0] || null;

            setRecordsData(rec);
            setMapAvailable(rec?.MapExist);
            setMapAvailableType(rec?.MapType);
            setMainCurrentDate(rec?.ZoneCurrentDate ?? "");
            setTeamLeadFlag(rec?.TeamLeadFlag ?? 0);
            setIsQueue(rec?.QueueUser ?? 0);
            const PreBookingQue = rec?.PreBookingQuestion;
            setPreBookingQuestion(PreBookingQue ? PreBookingQue.replace(/<\/?p>/g, "").trim() : "");
            setCreditInfoJSX(rec?.CreditInfoJSX ?? null);
            setZoneCreditValue(rec?.ZoneCreditValue ?? "");
            setIconZoneType(rec?.ZoneType ?? null);
            setCreditBalance(rec?.CreditBalance);
            setCreditCreditBalance(rec?.CreditBalanceRefillEvery);

            if (fallbackMember) {
                setSelectedTeamMember(fallbackMember.GuId);
                setSelectedQueueUser(fallbackMember.QueueUser ?? rec?.QueueUser ?? 0);
                setIsGuest(fallbackMember.GuId === "0" ? 1 : guestFlag);
                setSelectedName(fallbackMember.FullName || selectedName || "");
                saveSharedSelections({
                    teamMemberId: fallbackMember.GuId,
                    isGuest: fallbackMember.GuId === "0" ? 1 : guestFlag,
                    selectedName: fallbackMember.FullName || selectedName || "",
                });
            } else {
                setSelectedQueueUser(rec?.QueueUser ?? 0);
            }

            setBookingSpotData(Array.isArray(rec?.Schedule) ? rec.Schedule : []);
        };

        setSelectedCalendarZoneId(newZoneId);
        setSelectedZoneName(newZoneName);
        setFilters(zoneSpecificFilters);
        saveSharedSelections({
            zoneId: newZoneId,
            zoneName: newZoneName,
        });
        sessionStorage.setItem(SESSION.selectedZoneIDInCalendarScreen, newZoneId.toString());

        loadedMonthKeyRef.current = "";
        setWeekData({});
        setLoadingWeeks({});

        setIsLoading(true);
        try {
            const { calendarData, error } = await FetchCalendarWithZone(newZoneId, zoneSpecificFilters, teamMemberId, guestFlag);

            if (!error && calendarData?.Data?.ResponseCode === 200) {
                applyCalendarZoneData(calendarData?.Data?.Records);
            } else if (!error && calendarData?.Data?.ResponseCode === 453) {
                const defaultZone = zoneList.find((item) => item.DefaultId === 1) || zoneList[0] || null;

                if (defaultZone && defaultZone.Id !== newZoneId) {
                    setSelectedCalendarZoneId(defaultZone.Id);
                    setSelectedZoneName(defaultZone.ZoneName);
                    saveSharedSelections({
                        zoneId: defaultZone.Id,
                        zoneName: defaultZone.ZoneName,
                    });
                    sessionStorage.setItem(SESSION.selectedZoneIDInCalendarScreen, defaultZone.Id.toString());
                    const fallbackZoneFilters = serializeFiltersForApi(getStoredFilters(defaultZone.Id));
                    setFilters(fallbackZoneFilters);

                    const { calendarData: fallbackCalendarData, error: fallbackError } =
                        await FetchCalendarWithZone(defaultZone.Id, fallbackZoneFilters, teamMemberId, guestFlag);

                    if (!fallbackError && fallbackCalendarData?.Data?.ResponseCode === 200) {
                        applyCalendarZoneData(fallbackCalendarData?.Data?.Records);
                    } else {
                        setBookingSpotData([]);
                    }
                } else {
                    setBookingSpotData([]);
                }
            }
        } catch (err) {
            console.error("Error fetching calendar data for zone change:", err);
        } finally {
            setIsLoading(false);
        }

        if (calendarRef?.current) {
            calendarRef.current.getApi().refetchEvents();
        }
    }, [
        setSelectedCalendarZoneId,
        setSelectedZoneName,
        setWeekData,
        setLoadingWeeks,
        setIsLoading,
        setMapAvailable,
        setMapAvailableType,
        setRecordsData,
        setMainCurrentDate,
        setTeamLeadFlag,
        setIsQueue,
        setPreBookingQuestion,
        setCreditInfoJSX,
        setBookingSpotData,
        calendarRef,
        SESSION.selectedZoneIDInCalendarScreen,
        FetchCalendarWithZone,
        filters,
        zoneList,
        activeGuestFlag
    ]);


    const handleCancelBookingClick = (date) => {
        setBookingToCancelDate(date);
        setShowCancelModal(true);
    };

    const handleShowBookingModal = (date) => {
        setBookingCreateDate(date);
        setShowBookingModal(true);
    };

    // Define your button click handlers here
    // const handleMeetingButtonClick = (date) => {
    //     setSelectedMeetingDate(date);
    //     setShowMeetingModal(true);
    // };

    const ScheduleMeeting = (zoneId, bookingDateStr) => {
        const dateObj = getSafeDisplayDate(bookingDateStr);
        if (!dateObj) {
            console.error("Invalid booking date for schedule meeting:", bookingDateStr);
            return;
        }

        console.log("Schedule Meeting Clicked", zoneId, bookingDateStr);

        setMeetingModalDate(dateObj);
        setShowMeetingModal(false); // Close the current popup
        setShowScheduleMeetingModal(true); // Open the new popup
    };

    const handleJoinQueueModal = (date) => {
        setJoinQueueDate(date);
        setShowJoinQueueModal(true);
    }

    const handleLeaveQueueModal = (date) => {
        setLeaveQueueDate(date);
        setShowLeaveQueueModal(true);
    }

    const handleVehicleNotAvailable = () => {
        setShowNoVehicleModal(true);
    }

    const loadingprocessModal = () => {
        setShowBookingProcess(true)
    }

    const renderDayCellContent = (dayCellInfo) => {
        const currentDate = dayCellInfo.date;
        const cellDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
        const currentDateString = currentDate.toISOString().slice(0, 10);

        const isSelected = currentDateString === selectedDate;

        const today = new Date();
        const todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        const cellDateMidnight = new Date(cellDate.getFullYear(), cellDate.getMonth(), cellDate.getDate());

        const isPastDate = cellDateMidnight < todayMidnight;

        const cellWrapperStyle = isPastDate ? {
            backgroundColor: 'transparent', // Or whatever default FullCalendar background is
            pointerEvents: 'none', // Disable clicks on the entire cell
            opacity: 1, // Ensure the cell itself isn't faded
            // You might need to adjust height/width if your custom content was dictating it
            // height: '100%',
            // width: '100%',
        } : {};

        const firstDayOfWeek = new Date(currentDate);
        const dayOfWeek = firstDayOfWeek.getDay();
        const diff = firstDayOfWeek.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
        const mondayOfWeek = new Date(firstDayOfWeek.setDate(diff));
        const weekKey = `${mondayOfWeek.getFullYear()}-${mondayOfWeek.getMonth()}-${mondayOfWeek.getDate()}`;

        const weekBookings = weekData[weekKey] || bookingSpotData;
        const hasFetchedData = weekData.hasOwnProperty(weekKey);

        const bookingOnDate = weekBookings.find((booking) => {
            return booking.BookingDate === currentDateString; // Direct string comparison

        });

        const dateNumber = currentDate.getDate();
        // Calculate isGuestFlag for this render
        const isGuestFlag = isGuestTeamMember ? 1 : 0;
        return (
            <CalendarLogic
                dayCellInfo={dayCellInfo}
                selectedDate={selectedDate}
                availabilityDays={availabilityDays}
                weekData={weekData}
                bookingSpotData={bookingSpotData}
                formatDateString={formatDateString}

                loadingWeeks={loadingWeeks}
                setLoadingWeeks={setLoadingWeeks}
                ZoneList={ZoneList}
                fetchWithTokenRefresh2={fetchWithTokenRefresh2}
                BASE_URL={BASE_URL}
                Calendar_api={Calendar_api}
                isGuestFlag={isGuestFlag}
                getGuId={getGuId}
                setWeekData={setWeekData}
                setCalendarRenderKey={setCalendarRenderKey}
                zoneList={zoneList}
                selectedZoneName={selectedZoneName}
                selectedCalendarZoneId={selectedCalendarZoneId}
                // onZoneChange={handleZoneChange} // Renamed for clarity: `on` prefix for callbacks
                mainCurrentDate={mainCurrentDate} // Initial current date from global load
                teamLeadFlag={teamLeadFlag}
                isQueue={isQueue}
                selectedQueueUser={selectedQueueUser}
                preBookingQuestion={preBookingQuestion}
                recordsData={recordsData}
                isPastDate={isPastDate}
                performCalendarApiCall={performCalendarApiCall}// Pass the selected zone ID
                creditInfoJSX={creditInfoJSX}
                bookingOnDate={bookingOnDate}
                handleCancelBookingClick={handleCancelBookingClick}
                handleShowBookingModal={handleShowBookingModal}
                handleJoinQueueModal={handleJoinQueueModal}
                handleLeaveQueueModal={handleLeaveQueueModal}
                // selectedZoneId={selectedCalendarZoneId}
                mapAvailable={mapAvailable}
                mapAvailableType={mapAvailableType}
                setMapAvailable={setMapAvailable}
                setMapAvailableType={setMapAvailableType}
                setBookingSpotData={setBookingSpotData}

                loadingDates={loadingDates}
                currentDateString={currentDateString}
                selectedTeamMember={selectedTeamMember}
                iconzoneType={iconzoneType}
                handleVehicleNotAvailable={handleVehicleNotAvailable}
                loadingprocessModal={loadingprocessModal}
                filters={filters}
            />
        );
    };

    // Rest of your utility functions and modal components...
    const formattedDate = currentDate.toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'short',
    });

    const formattedOnlyDate = currentDate.toLocaleDateString('en-US', {
        day: 'numeric',
    });

    const formattedOnlyMonth = currentDate.toLocaleDateString('en-US', {
        month: 'long',
    });
    const formattedOnlyMonthShort = currentDate.toLocaleDateString('en-US', {
        month: 'short',
    });

    const formattedOnlyYear = currentDate.toLocaleDateString('en-US', {
        year: 'numeric'
    });

    const handleEventClick = (clickInfo) => {
        const updatedEvents = events.map((event) => {
            if (event.id === clickInfo.event.id) {
                return {
                    ...event,
                    status: event.status === 'available' ? 'checked-in' : 'available',
                };
            }
            return event;
        });
        setEvents(updatedEvents);
    };

    const handleCheckInButtonClick = async () => {
        const currentDayBookingRecords = recordsData?.CurrentDayBookingRecords || [];
        const { totalCount } = getCheckInSummary(currentDayBookingRecords);

        if (totalCount === 1) {
            setIsLoading(true);
            try {
                const bookingRecord = currentDayBookingRecords[0];
                const recordCheckInFlag = Number(bookingRecord?.CheckInFlag);
                const actionCheckInFlag = recordCheckInFlag === 1 ? 2 : 1;
                const zoneId = selectedCalendarZoneId || bookingRecord?.ZoneId;

                const response = await CheckInOutSingleBtn(
                    zoneId,
                    bookingRecord?.BookingDate,
                    bookingRecord?.SpotId,
                    actionCheckInFlag
                );
                 handleApiUiResponse(response, {
                successToaster: 0,
                errorToaster: 0,
                alertPopup: 1,
                onConfirmByCode: {
                    449: async () => {
                        await Calendar_Logic();;
                    }
                }
            });
                await Calendar_APIforBooking(bookingRecord?.BookingDate, zoneId);
                setIsLoading(false);
            } finally {
                setIsLoading(false);
            }
            return;
        }

        if (totalCount > 1) {
            setShowModal(true);
        }
    };

    const closeModal = () => {
        setShowModal(false);
    };

    const handleViewMount = (info) => {
        setIsLoading(true);
        if (info.view.type === 'timeGridWeek') {
            formatTimeGridWeekHeaders(info.el);
            renderCustomAllDayHTML(info.el);
            renderCustomNavigationButtons(info.el);
            addPercentageData(info.el);
            setIsLoading(false);
        } else {
            setIsLoading(false);
        }
    };

    function generateUniquePercentages(count, min, max) {
        var percentages = new Set();
        while (percentages.size < count) {
            var percentage = Math.floor(Math.random() * (max - min + 1)) + min;
            percentages.add(percentage);
        }
        return Array.from(percentages);
    }

    function formatTimeGridWeekHeaders() {
        var headerEls = document.querySelectorAll(".fc-col-header th");
        headerEls.forEach(function (headerEl) {
            var date = new Date(headerEl.getAttribute("data-date"));
            var dayName = new Intl.DateTimeFormat("en-US", { weekday: "short" }).format(date);
            var dayDate = ("0" + date.getDate()).slice(-2); // Add leading zero
            headerEl.innerHTML = `<div class="name-date-header text-center"><div class="day-name">${dayName}</div><div class="day-date">${dayDate}</div></div>`;
        });
    }

    function renderCustomAllDayHTML() {
        var allDayRow = document.querySelector(".fc-col-header .fc-daygrid-header-row");
        if (allDayRow) {
            var firstCol = allDayRow.querySelector("th:first-child");
            if (firstCol) {
                firstCol.innerHTML = `<div class="custom-all-day">Custom All-Day HTML</div>`;
            }
        }
    }

    function renderCustomNavigationButtons() {
        var timeGridView = document.querySelector(".fc-timeGridWeek-view");
        if (timeGridView) {
            var existingButtons = document.querySelector(".custom-navigation-buttons");
            if (!existingButtons) {
                var buttonContainer = document.createElement("div");
                buttonContainer.className = "custom-navigation-buttons";

                var prevButton = document.createElement("button");
                prevButton.className = "custom-prev-week-button fc-button fc-prev-button";
                prevButton.innerHTML = "<span></span>";
                prevButton.addEventListener("click", function () {
                    // calendar.prev(); // Go to previous week
                });

                var nextButton = document.createElement("button");
                nextButton.className = "custom-next-week-button fc-button fc-next-button";
                nextButton.innerHTML = "<span></span>";
                nextButton.addEventListener("click", function () {
                    // calendar.next(); // Go to next week
                });

                buttonContainer.appendChild(prevButton);
                buttonContainer.appendChild(nextButton);

                timeGridView.insertBefore(buttonContainer, timeGridView.firstChild);
            }
        } else {
            console.error(".fc-timeGridWeek-view not found.");
        }
    }

    function areAllDaysInPast(view) {
        var currentDate = view.currentStart;
        var today = new Date();
        today.setHours(0, 0, 0, 0); // Midnight for accurate comparison

        var allDaysInPast = true;
        for (var i = 0; i < 7; i++) {
            var dateToCheck = new Date(currentDate);
            dateToCheck.setDate(dateToCheck.getDate() + i);
            if (dateToCheck >= today) {
                allDaysInPast = false;
                break;
            }
        }
        return allDaysInPast;
    }

    // This function is defined twice in your original code. Keeping one.
    // function generateUniquePercentages(count, min, max) { ... }

    function addPercentageData() {
        var sectionBody = document.querySelector(".fc-scrollgrid-section-body");
        if (sectionBody) {
            var cells = sectionBody.querySelectorAll(".fc-daygrid-day"); // Adjust selector if needed
            cells.forEach(function (cell, index) {
                if (index < weeklyPercentages.length) {
                    var percentage = weeklyPercentages[index];
                    if (!cell.classList.contains("percentage-added")) {
                        var percentageClass = percentage === 100 ? "percentage-100" : "percentage-data";
                        // This seems to overwrite the entire cell content, including date number.
                        // You might need to append this data to an existing div or create a new one.
                        // For now, I'll comment out this part as it might conflict with CalendarLogicDesign.
                        // cell.innerHTML = `<div class="${percentageClass}">${percentage}%</div>`;
                        cell.classList.add("percentage-added");
                    }
                }
            });
        }
    }

    const handleDatesSet = (info) => {
        visibleCalendarViewRef.current = info.view.type;
        visibleMonthStartRef.current = new Date(
            info.view.currentStart.getFullYear(),
            info.view.currentStart.getMonth(),
            1
        );

        const getMondayForDate = (date) => {
            const monday = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            monday.setDate(monday.getDate() - monday.getDay() + (monday.getDay() === 0 ? -6 : 1));
            monday.setHours(0, 0, 0, 0);
            return monday;
        };

        const getWeekKey = (date) =>
            `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;

        const viewStart = info.view.currentStart;
        const currentMonday = getMondayForDate(viewStart);
        const weekKey = getWeekKey(currentMonday);

        if (info.view.type === 'timeGridWeek') {
            // Only fetch automatically in week view. Month navigation should not trigger
            // a mid-week API call unless the user explicitly refreshes or takes an action.
            if (!weekData.hasOwnProperty(weekKey) && selectedCalendarZoneId !== 0) {
                performCalendarApiCall(currentMonday, selectedCalendarZoneId);
            }

            formatTimeGridWeekHeaders(info.el);
            renderCustomAllDayHTML(info.el);
            renderCustomNavigationButtons(info.el);
            addPercentageData(info.el);

            const prevButton = info.el.querySelector('.custom-prev-week-button');
            if (prevButton) {
                prevButton.disabled = areAllDaysInPast(info.view.currentStart);
                prevButton.classList.toggle('fc-button-disabled', prevButton.disabled);
            }
        } else {
            if (selectedCalendarZoneId !== 0) {
                const firstMonthDate = new Date(
                    info.view.currentStart.getFullYear(),
                    info.view.currentStart.getMonth(),
                    1
                );
                firstMonthDate.setHours(0, 0, 0, 0);

                const visibleMonthKey = `${firstMonthDate.getFullYear()}-${firstMonthDate.getMonth()}`;

                if (loadedMonthKeyRef.current !== visibleMonthKey) {
                    performCalendarApiCall(firstMonthDate, selectedCalendarZoneId, undefined, {
                        source: "month-navigation",
                    });
                }
            }

            const prevButton = document.querySelector('.custom-prev-week-button');
            if (prevButton) {
                prevButton.disabled = false;
                prevButton.classList.remove('fc-button-disabled');
            }
        }

        // --- DISABLE PAST MONTH ARROW LOGIC ---
        const now = new Date();
        const currentCalendarDate = info.view.currentStart;

        // Select the built-in FullCalendar prev button
        const prevButton = document.querySelector('.fc-prev-button');

        if (prevButton) {
            // Disable if the calendar year is earlier than now
            // OR if it's the same year but the month is earlier or equal to now
            const isPast = currentCalendarDate.getFullYear() < now.getFullYear() ||
                (currentCalendarDate.getFullYear() === now.getFullYear() &&
                    currentCalendarDate.getMonth() <= now.getMonth());

            if (isPast) {
                prevButton.disabled = true;
                prevButton.classList.add('fc-button-disabled');
            } else {
                prevButton.disabled = false;
                prevButton.classList.remove('fc-button-disabled');
            }
        }

        updateCheckInButtonUI();
    };

    const handleDateClick = (info) => {
        setSelectedDate(info.dateStr);

        const clickedDate = info.date;
        const clickedDay = clickedDate.getDate();
        const clickedMonth = clickedDate.getMonth() + 1;
        const clickedYear = clickedDate.getFullYear();

        const fullday = `${clickedYear}-${String(clickedMonth).padStart(2, "0")}-${String(clickedDay).padStart(2, "0")}`;

        setSelectedDay(clickedDay);
        setSelectedMonth(clickedMonth);
        setSelectedYear(clickedYear);

        setClickedFullDay(fullday);

        console.log("📅 Clicked Date:", fullday);

        // 🔍 Find matching bookings from bookingSpotData
        const matchedSchedules = bookingSpotData.filter((booking) => {
            const bookingDate = formatDateString(booking.BookingDate);

            console.log(bookingDate, "Matching Schedule bookingDate");

            if (!(bookingDate instanceof Date) || isNaN(bookingDate.getTime())) {
                return false;
            }

            return (
                bookingDate.getFullYear() === clickedYear &&
                bookingDate.getMonth() + 1 === clickedMonth &&
                bookingDate.getDate() === clickedDay
            );
        });

        console.log("📦 Matching Schedule Records:", matchedSchedules);

        const spotidss = matchedSchedules.filter((booking) => {
            const selectedSpotID = booking.SpotId;
            console.log("📦 Sorted Matching samdofsfadm", selectedSpotID);
            return selectedSpotID;
        })

        if (matchedSchedules.length > 0) {
            setCancelBookingSpotId(matchedSchedules[0].SpotId);
            setCheckInFlag(matchedSchedules[0].CheckInFlag);
            console.log("Selected SpotId:", matchedSchedules[0].SpotId);
        } else {
            setCancelBookingSpotId(null);
            console.log("No SpotId found for this date.");
        }
    };

    // The formatDateString function is now a useCallback at the top.
    // const formatDateString = (dateString) => {
    //     const [year, month, day] = dateString.split('-');
    //     return new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));
    // };

    const handleBookButtonClick = (dateStr) => {
        alert(`Book button clicked for: ${dateStr}`);
    };

    // BookingModal and CancellationModal components (keep them as they are, but ensure they receive correct props)
    const BookingModal = ({ date, onClose, zoneId, onBookingSuccess }) => {

        // Helper to get weekKey for a given date
        function getWeekKey(targetDate) {
            console.log("Booking modal target date => ", targetDate);
            const safeDate = getSafeDisplayDate(targetDate);
            const dayOfWeek = safeDate?.getDay();
            console.log("Number of day in week => ", dayOfWeek);
            return getWeekKeyFromDate(targetDate);
        }

        const bookingDate = date || bookingCreateDate || clickedFullDay;
        const weekKey = bookingDate ? getWeekKey(bookingDate) : null;
        const bookingDateStr = getLocalDateString(bookingDate);

        console.log("Booking Date String:", bookingDateStr);
        console.log("Booking Date:", bookingDate);
        console.log("Week Key:", weekKey);
        console.log("Booking Date String:", bookingDateStr);
        
        // Find booking for modal from weekData first, fallback to bookingSpotData
        const bookingForModal =
            (weekKey && weekData && weekData[weekKey] && weekData[weekKey].find(
                (booking) => booking.BookingDate === bookingDateStr
            )) ||
            bookingSpotData.find(
                (booking) => booking.BookingDate === bookingDateStr
            );

        // Display helpers
        console.log("Booking for modal:", bookingForModal);
        const safeBookingDate = getSafeDisplayDate(bookingDate);
        const displayDay = safeBookingDate ? safeBookingDate.getDate() : '';
        const displayMonth = safeBookingDate ? safeBookingDate.toLocaleDateString('en-US', { month: 'long' }) : '';
        const displayYear = safeBookingDate ? safeBookingDate.getFullYear() : '';

        // Vehicle selection logic (copied from MapGridZone)
        const [vehicleOpen, setVehicleOpen] = useState(false);
        const [selectedVehicle, setSelectedVehicle] = useState(null);
        const [selectedVehiclePrimaryKey, setSelectedVehiclePrimaryKey] = useState(null);
        const [requiredFields, setRequiredFields] = useState({ vehicle: "" });
        const [showTags, setShowTags] = useState(false);
        // Example: vehiclesForSpot should come from bookingForModal or props
        const vehiclesForSpot = bookingForModal?.EmployeeVehicleType || [];

        useEffect(() => {
            if (vehiclesForSpot && vehiclesForSpot.length > 0 && !selectedVehiclePrimaryKey) {
                const firstVehicle = vehiclesForSpot[0];
                const firstPk = firstVehicle.VehiclePrimaryKey;

                setSelectedVehiclePrimaryKey(firstPk);
                setSelectedVehicle(firstVehicle);
                setRequiredFields((prev) => ({
                    ...prev,
                    vehicle: ""
                }));

                console.log("Default vehicle selected:", firstVehicle.VehicleRegistrationId);
            }
        }, [vehiclesForSpot, selectedVehiclePrimaryKey]);

        // Helper: should disable Get Random Space button if vehicle required but not selected
        const isVehicleRequired = vehiclesForSpot.length > 0;
        const isVehicleSelected = !!selectedVehicle;

        const varzonecreditvalue = zoneCreditValue
        console.log("varzonecreditvalue", varzonecreditvalue);

        const displayCreditValue = getDisplayRefundCreditValue({
            refundStartDateTime: bookingForModal?.RefundStartDateTime,
            refundEndDateTime: bookingForModal?.RefundEndDateTime,
            zoneCurrentDateTime: recordsData?.ZoneCurrentDateTime,
            fullRefundCredit: bookingForModal?.FullRefundCredit,
            halfRefundCredit: bookingForModal?.HalfRefundCredit,
            noRefundCredit: bookingForModal?.NoRefundCredit
        });

        const isZeroDisplayCredit =
            displayCreditValue === 0 || displayCreditValue === "0";

        const CreditValueGrey =
            zoneCreditValue > 0 &&
            (bookingForModal?.IndividualDayCost == 0 || bookingForModal?.IndividualDayCost == "0");

        const CreditValueAdd =
            (zoneCreditValue > 0 && bookingForModal?.IndividualDayCost == 1)
        console.log("CreditValueGrey", CreditValueGrey);
        console.log("CreditValueAdd", CreditValueAdd);

        const safeHtml = DOMPurify
            .sanitize(preBookingQuestion)
            .replace(/<a /g, '<a target="_blank" rel="noopener noreferrer" ');

        const samevalue = getGuId() == selectedTeamMember
        const teamMemberID = samevalue ? selectedTeamMember : ""
        const isGuestRandomAllocation =
            selectedTeamId === null && String(selectedTeamMember) === "0";
        const isVehicleRequiredForRandomSpace =
            !isGuestRandomAllocation && isVehicleRequired;
        const isVehicleSelectedForRandomSpace =
            isGuestRandomAllocation || isVehicleSelected;
        const randomSpaceVehicleTypeId = isGuestRandomAllocation ? 0 : selectedVehicle?.Id || 0;
        const randomSpaceFuelId = isGuestRandomAllocation ? 0 : selectedVehicle?.FuelId || 0;
        const randomSpaceShareableId = isGuestRandomAllocation ? 0 : selectedVehicle?.ShareableId || 0;
        const randomSpaceAccessibleId = isGuestRandomAllocation ? 0 : selectedVehicle?.AccessibleId || 0;
        const randomSpaceRegistrationId = isGuestRandomAllocation ? 0 : selectedVehicle?.VehicleRegistrationId || 0;
        const isDisabled =
            isLoading ||
            (isVehicleRequiredForRandomSpace && !isVehicleSelectedForRandomSpace) ||
            (!!preBookingQuestion && !checkedPreBookingQue);

        const handleRandomSpaceRequest = () => {
            if (isDisabled) return;

            if (isVehicleRequiredForRandomSpace && !isVehicleSelectedForRandomSpace) {
                setRequiredFields(prev => ({ ...prev, vehicle: "" }));
                return;
            }

            if (isGuestRandomAllocation) {
                setPendingGuestBooking({
                    zoneId,
                    bookingDateStr,
                    VehicleTypeId: randomSpaceVehicleTypeId,
                    fuelId: randomSpaceFuelId,
                    vehicleShareableId: randomSpaceShareableId,
                    vehicleAccessibleId: randomSpaceAccessibleId,
                    vehicleRegistrationId: randomSpaceRegistrationId,
                    isGuestFlag: 1,
                    spotName: bookingForModal?.SpotName || bookingForModal?.Schedules?.[0]?.SpotName || "",
                    startTime: bookingForModal?.BookingStartTime || bookingForModal?.StartTime || "",
                    endTime: bookingForModal?.BookingEndTime || bookingForModal?.EndTime || "",
                });
                setshowGuestPopupFullday(true);
                return;
            }

            GetRandomSpace(
                zoneId,
                bookingDateStr,
                randomSpaceVehicleTypeId,
                randomSpaceFuelId,
                randomSpaceShareableId,
                randomSpaceAccessibleId,
                randomSpaceRegistrationId,
                0
            );

            onClose();
        };

        // const CreditValueCut  = 
        //     (creditValue == 1 && bookingForModal?.IndividualDayCost > 0)
        const bookingModalMemberName = isGuestRandomAllocation
            ? t("guest")
            : selectedMemberData?.FullName
            || selectedName
            || `${sessionStorage.getItem("firstname")} ${sessionStorage.getItem("lastname")}`;
        return (
            <div>
                <div className="modal modalscroll" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                    id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                        <div className="modal-content modal-radius">
                            <div className="modal-body">
                                <div className="close-modal">
                                    <a onClick={resetForm}>
                                        <img src={Close} aria-label="Close" />
                                    </a>
                                </div>
                                <div className="pt-4">
                                    <h5 className="popup-title">{t("react_calendar_new_booking")}</h5>
                                </div>
                                <div className="date-with-credit d-flex align-items-center justify-content-between pt-2">
                                    <div id="selectedDate" className="selected-current-date">
                                        <span>{selectedDay}</span>
                                        <span>{t(displayMonth)} {displayYear}</span>
                                    </div>

                                    {varzonecreditvalue > 0 && (
                                        <div className="credit-info">
                                            {/* {creditInfoJSX} */}
                                            <a href="#"
                                                className="orange-outline-with-icon"
                                            >
                                                {CreditValueGrey ?
                                                    (
                                                        <>
                                                            <img src={GrayStar} alt="star" />
                                                            <span>{bookingForModal?.IndividualDayCost}</span>
                                                        </>
                                                    )
                                                    :
                                                    <>
                                                        <img src={Images.OrangeStar} alt="" />
                                                        <span>{Number(bookingForModal?.IndividualDayCost) > 0
                                                            ? `-${bookingForModal?.IndividualDayCost}`
                                                            : bookingForModal?.IndividualDayCost}</span>
                                                    </>
                                                }
                                            </a>
                                            {/* <div className="date-with-credit d-flex align-items-start justify-content-end pe-3">
                                                    <a
                                                        className="orange-outline-with-icon"
                                                    >
                                                        {CreditValueGrey ? <img src={GrayStar} alt="star" /> :
                                                            CreditValueAdd ? "-" : ""
                                                        }
                                                        <span>{bookingForModal?.IndividualDayCost}</span>
                                                    </a>
                                                </div> */}
                                        </div>
                                    )}
                                </div>

                                <div className="divider-line mt-3"></div>
                                <div className="modal-des">
                                    <div className="modal-scroll-inner me-4">
                                        <div className="icon-with-list mb-3">

                                            <div className="icon-wrap">
                                                <img src={Images.Participant} />

                                                {/* <h4 className="ps-1 ms-1">{selectedMemberData?.FullName || selectedName || sessionStorage.getItem("firstname") + " " + sessionStorage.getItem("lastname")}</h4> */}
                                                <h4 className="ps-1 ms-1">{bookingModalMemberName}</h4>
                                            </div>
                                        </div>
                                        {/* <div className="icon-with-list mb-3"></div>
                                        <div className="modal-tag"></div> */}

                                        {vehiclesForSpot.length > 0 && bookingForModal.DeskAvailable === 1 &&
                                            !isGuestRandomAllocation && (
                                                <div className="custom-dropdown modal-dropdown mb-3">
                                                    <CustomSearchableDropdown
                                                        items={vehiclesForSpot}
                                                        // The current selected Primary Key ID
                                                        value={selectedVehiclePrimaryKey}
                                                        // The key from your data to show in the list (e.g., "GJ 06 XX 1234")
                                                        labelKey="VehicleRegistrationId"
                                                        // The key from your data used as the unique ID for logic
                                                        valueKey="VehiclePrimaryKey"
                                                        searchable={false}
                                                        // placeholder="Select Vehicle"
                                                        disabled={!vehiclesForSpot.length}
                                                        onChange={(pk) => {
                                                            // 1. Update the Primary Key state for the radio/selection logic
                                                            setSelectedVehiclePrimaryKey(pk);

                                                            // 2. Find the full vehicle object from the list to update the main state
                                                            const vehicleObj = vehiclesForSpot.find(v => v.VehiclePrimaryKey === pk);
                                                            if (vehicleObj) {
                                                                setSelectedVehicle(vehicleObj);

                                                                // Optional: Debugging logs for your development
                                                                console.log("Vehicle Selected:", vehicleObj.VehicleRegistrationId);
                                                                console.log("PK:", pk);
                                                            }

                                                            // 3. Clear any existing validation errors for the 'vehicle' field
                                                            setRequiredFields(prev => ({
                                                                ...prev,
                                                                vehicle: ""
                                                            }));
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        {/* {requiredFields.vehicle && (
                                    <div style={{ color: 'red', marginTop: 8, fontSize: 14 }}>{requiredFields.vehicle}</div>
                                )} */}
                                        {/* </div> */}


                                        {/* <div className="modal-details">
                                    <div className="booking-name d-flex align-items-center gap-2">
                                        <img src={Images.UserIcon} />
                                        <h4>{UserName}</h4>
                                    </div> */}
                                        {/* PreBookingQuestion */}
                                        <div className="participants-list ctm-checklist">
                                            {!!preBookingQuestion && (
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`preBookingQuestion`}
                                                        checked={checkedPreBookingQue}
                                                        onChange={(e) => setCheckedPreBookingQue(e.target.checked)}
                                                    />

                                                    <label
                                                        className="form-check-label ms-2"
                                                        htmlFor={`preBookingQuestion`}
                                                    >
                                                        <span dangerouslySetInnerHTML={{ __html: safeHtml }} />

                                                    </label>
                                                </div>
                                            )}
                                        </div>
                                        <div className="text-center my-34">
                                            {iconzoneType === 1 ? (
                                                <img src={ParkingIcon} className="img-fluid" alt="Parking Booking" />
                                            ) : iconzoneType === 2 &&
                                                bookingForModal?.MeetingRoomAvailable === 1 &&
                                                bookingForModal?.HourlySpotAvailable === 0 &&
                                                bookingForModal?.DeskAvailable === 0 ? (
                                                <img src={MeetingIcon} className="img-fluid" alt="Meeting Room Booking" />
                                            ) : iconzoneType === 2 ? (
                                                <img src={DeskIcon} className="img-fluid" alt="Desk Booking" />
                                            ) : null}
                                        </div>
                                    </div></div>
                                {/* </div> */}
                                {/* This is inside your modal's JSX, where you are rendering the booking options */}
                                {(() => {
                                    if (!bookingForModal) return null;

                                    // Case: Map is available and not of type 1 (meaning it offers both Desk and Meeting Room or other types)
                                    if (mapAvailable === 1 && mapAvailableType !== 1) {
                                        // Sub-case: Both Desk and Meeting Room are available
                                        if (bookingForModal.DeskAvailable === 1 && bookingForModal.MeetingRoomAvailable === 1) {
                                            return (
                                                <>
                                                    <div className="me-4 mt-3">
                                                        <a
                                                            onClick={() => GotoMapClick(zoneId, bookingDateStr)}
                                                            
                                                            className="green-outline-with-icon w-100 mw-100 min-height-56 selected"
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            <img src={GreenMap} alt="Map" />
                                                            <span>{t("gotomap")}</span>
                                                        </a>
                                                    </div>
                                                    <div className="me-4 mt-3">
                                                        <a
                                                            href="#"
                                                            onClick={(e) => {
                                                                // 🚫 Block if disabled
                                                                if (
                                                                    isLoading ||
                                                                    (isVehicleRequiredForRandomSpace && !isVehicleSelectedForRandomSpace) ||
                                                                    (!!preBookingQuestion && !checkedPreBookingQue)
                                                                ) {
                                                                    return;
                                                                }

                                                                // Vehicle validation
                                                                if (isVehicleRequiredForRandomSpace && !isVehicleSelectedForRandomSpace) {
                                                                    setRequiredFields(prev => ({ ...prev, vehicle: "" }));
                                                                    return;
                                                                }

                                                                // Proceed
                                                                handleRandomSpaceRequest();
                                                            }}
                                                            className={`green-outline-with-icon w-100 mw-100 min-height-56 ${isLoading ||
                                                                (isVehicleRequiredForRandomSpace && !isVehicleSelectedForRandomSpace) ||
                                                                (!!preBookingQuestion && !checkedPreBookingQue)
                                                                ? "disabled"
                                                                : ""
                                                                }`}
                                                            disabled={
                                                                isLoading ||
                                                                (isVehicleRequiredForRandomSpace && !isVehicleSelectedForRandomSpace) ||
                                                                (!!preBookingQuestion && !checkedPreBookingQue)
                                                            }
                                                            style={{
                                                                opacity:
                                                                    isLoading ||
                                                                        (!!preBookingQuestion && !checkedPreBookingQue)
                                                                        ? 0.5
                                                                        : 1,
                                                                cursor:
                                                                    isLoading ||
                                                                        (!!preBookingQuestion && !checkedPreBookingQue)
                                                                        ? "not-allowed"
                                                                        : "pointer"
                                                            }}
                                                        >
                                                            {isLoading ? (
                                                                <>
                                                                    <div className="animate-spin h-5 w-5 mr-3 border-t-2 border-b-2 border-green-500 rounded-full"></div>
                                                                    <span>{t("loading")}</span>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <img src={EditSquare} alt="Edit" />
                                                                    <span>{t("get_random_space")}</span>
                                                                </>
                                                            )}
                                                        </a>
                                                    </div>
                                                    {
                                                        // teamMemberID
                                                        (teamMemberList.length == 0 || samevalue) &&
                                                        !isGuestRandomAllocation
                                                        && (
                                                            <div className="me-4 mt-3">
                                                                <a onClick={(e) => {
                                                                    e.preventDefault();
                                                                    if (!isLoading) {
                                                                        ScheduleMeeting(zoneId, bookingDateStr);
                                                                        onClose();
                                                                    }
                                                                }}
                                                                    href="#" className="green-outline-with-icon w-100 mw-100 min-height-56">
                                                                    <img src={ScheduleMeetingicon} alt="Edit" />
                                                                    <span>{t("react_schedule_meeting")}</span>
                                                                </a>
                                                            </div>
                                                        )
                                                    }
                                                </>
                                            );
                                        }
                                        // Sub-case: Only Desk available
                                        if (bookingForModal.DeskAvailable === 1) {
                                            return (
                                                <>
                                                    <div className="me-4 mt-3">
                                                        <a
                                                            onClick={() => GotoMapClick(zoneId, bookingDateStr)}
                                                             
                                                            className="green-outline-with-icon w-100 mw-100 min-height-56 selected"
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            <img src={GreenMap} alt="Map" />
                                                            <span>{t("gotomap")}</span>
                                                        </a>
                                                    </div>
                                                    <div className="me-4 mt-3">
                                                        <a
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();

                                                                // 🚫 Block if disabled
                                                                if (isDisabled) return;

                                                                // Vehicle validation
                                                                if (isVehicleRequiredForRandomSpace && !isVehicleSelectedForRandomSpace) {
                                                                    setRequiredFields(prev => ({ ...prev, vehicle: "" }));
                                                                    return;
                                                                }

                                                                // Proceed
                                                                handleRandomSpaceRequest();
                                                            }}
                                                            className={`green-outline-with-icon w-100 mw-100 min-height-56 ${isDisabled ? "disabled" : ""
                                                                }`}
                                                            style={{
                                                                opacity: isDisabled ? 0.5 : 1,
                                                                cursor: isDisabled ? "not-allowed" : "pointer",
                                                                //   pointerEvents: isDisabled ? "none" : "auto" // 🔥 important
                                                            }}
                                                        >
                                                            {isLoading ? (
                                                                <>
                                                                    <div className="animate-spin h-5 w-5 mr-3 border-t-2 border-b-2 border-green-500 rounded-full"></div>
                                                                    <span>{t("loading")}</span>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <img src={EditSquare} alt="Edit" />
                                                                    <span>{t("get_random_space")}</span>
                                                                </>
                                                            )}
                                                        </a>
                                                    </div>
                                                </>
                                            );
                                        }
                                        // Sub-case: Only Meeting Room available
                                        if (bookingForModal.MeetingRoomAvailable === 1) {
                                            return (
                                                <>
                                                    <div className="me-4 mt-3">
                                                        <a
                                                            onClick={() => GotoMapClick(zoneId, bookingDateStr)}
                                                            
                                                            className="green-outline-with-icon w-100 mw-100 min-height-56 selected"
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            <img src={GreenMap} alt="Map" />
                                                            <span>{t("gotomap")}</span>
                                                        </a>
                                                    </div>
                                                    {
                                                        // teamMemberID
                                                        (teamMemberList.length == 0 || samevalue) &&
                                                        !isGuestRandomAllocation
                                                        && (
                                                            <div className="me-4 mt-3">
                                                                <a
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        if (!isLoading) {
                                                                            ScheduleMeeting(zoneId, bookingDateStr);
                                                                            onClose();
                                                                        }
                                                                    }}
                                                                    href="#" className="green-outline-with-icon w-100 mw-100 min-height-56">
                                                                    <img src={ScheduleMeetingicon} alt="Edit" />
                                                                    <span>{t("react_schedule_meeting")}</span>
                                                                </a>
                                                            </div>
                                                        )
                                                    }
                                                </>
                                            );
                                        }
                                        // Sub-case: DeskCount === 1 and DeskAvailable === 0 (if only hourly booking is available)
                                        if (bookingForModal.DeskCount === 1 && bookingForModal.DeskAvailable === 0) {
                                            return (
                                                <div className="me-4 mt-3">
                                                    <a
                                                        onClick={() => GotoMapClick(zoneId, bookingDateStr)}
                                                        
                                                        className="green-outline-with-icon w-100 mw-100 min-height-56 selected"
                                                        style={{ cursor: "pointer" }}
                                                    >
                                                        <img src={GreenMap} alt="Map" />
                                                        <span>{t("gotomap")}</span>
                                                    </a>
                                                </div>
                                            );
                                        }
                                        // Fallback: just show map if available
                                        return (
                                            <div className="me-4 mt-3">
                                                <a
                                                    onClick={() => GotoMapClick(zoneId, bookingDateStr)}
                                                    
                                                    className="green-outline-with-icon w-100 mw-100 min-height-56 selected"
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <img src={GreenMap} alt="Map" />
                                                    <span>{t("gotomap")}</span>
                                                </a>
                                            </div>
                                        );
                                    }

                                    // Case: If mapAvailable === 0, show only Get Random Space
                                    if (mapAvailable === 0) {
                                        return (
                                            <div className="me-4 mt-3">
                                                <a
                                                    href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();

                                                        // 🚫 Block if disabled
                                                        if (isDisabled) return;

                                                        // Vehicle validation (extra safety)
                                                        if (isVehicleRequiredForRandomSpace && !isVehicleSelectedForRandomSpace) {
                                                            setRequiredFields(prev => ({ ...prev, vehicle: "" }));
                                                            return;
                                                        }

                                                        // Proceed
                                                        handleRandomSpaceRequest();
                                                    }}
                                                    className={`green-outline-with-icon w-100 mw-100 min-height-56 ${isDisabled ? "disabled" : ""
                                                        }`}
                                                    style={{
                                                        opacity: isDisabled ? 0.5 : 1,
                                                        cursor: isDisabled ? "not-allowed" : "pointer",
                                                        //   pointerEvents: isDisabled ? "none" : "auto" // 🔥 key fix
                                                    }}
                                                >
                                                    {isLoading ? (
                                                        <>
                                                            <div className="animate-spin h-5 w-5 mr-3 border-t-2 border-b-2 border-green-500 rounded-full"></div>
                                                            <span>{t("loading")}</span>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <img src={EditSquare} alt="Edit" />
                                                            <span>{t("get_random_space")}</span>
                                                        </>
                                                    )}
                                                </a>
                                            </div>
                                        );
                                    }
                                    return null;
                                })()
                                }
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const CancellationModal = ({ date, onClose, zoneId, SpotId, checkInFlag }) => {

        console.log("CancellationModal - SpotId:", zoneId, SpotId, checkInFlag);
        // Helper to get weekKey for a given date
        function getWeekKey() {
            const date = clickedFullDay
            // console.log("click on date clickedFullDay => ", date);
            const safeDate = getSafeDisplayDate(date);
            const dayOfWeek = safeDate?.getDay();
            // console.log("Number of day in week => ", dayOfWeek);
            return getWeekKeyFromDate(date);
        }

        const bookingDate = clickedFullDay;
        const weekKey = bookingDate ? getWeekKey(bookingDate) : null;
        const bookingDateStr = getLocalDateString(bookingDate);

        // console.log("Booking Date String:", bookingDateStr);

        // console.log("Booking Date:", bookingDate);
        // console.log("Week Key:", weekKey);
        // console.log("Booking Date String:", bookingDateStr);

        // Find booking for modal from weekData first, fallback to bookingSpotData
        const bookingForModal =
            (weekKey && weekData && weekData[weekKey] && weekData[weekKey].find(
                (booking) => booking.BookingDate === bookingDateStr
            )) ||
            bookingSpotData.find(
                (booking) => booking.BookingDate === bookingDateStr
            );

        // Compute SpotId for this booking
        const computedSpotId = bookingForModal && bookingForModal.Schedules && bookingForModal.Schedules.length > 0
            ? bookingForModal.Schedules[0].SpotId
            : null;
        console.log("CancellationModal - computedSpotId:", computedSpotId);

        // Display helpers
        const safeBookingDate = getSafeDisplayDate(bookingDate);
        const displayDay = safeBookingDate ? safeBookingDate.getDate() : '';
        const displayMonth = safeBookingDate ? safeBookingDate.toLocaleDateString('en-US', { month: 'long' }) : '';
        const displayYear = safeBookingDate ? safeBookingDate.getFullYear() : '';
        const [showTags, setShowTags] = useState(false);

        const samevalue = getGuId() == selectedTeamMember
        const teamMemberID = samevalue ? selectedTeamMember : ""

        // Vehicle selection logic (copied from MapGridZone)
        const [vehicleOpen, setVehicleOpen] = useState(false);
        const [selectedVehicle, setSelectedVehicle] = useState(null);
        const [selectedVehiclePrimaryKey, setSelectedVehiclePrimaryKey] = useState(null);
        const [requiredFields, setRequiredFields] = useState({ vehicle: "" });
          const vehiclesForSpot = bookingForModal?.EmployeeVehicleType || [];

        useEffect(() => {
            if (vehiclesForSpot && vehiclesForSpot.length > 0 && !selectedVehiclePrimaryKey) {
                const firstVehicle = vehiclesForSpot[0];
                const firstPk = firstVehicle.VehiclePrimaryKey;

                setSelectedVehiclePrimaryKey(firstPk);
                setSelectedVehicle(firstVehicle);
                setRequiredFields((prev) => ({
                    ...prev,
                    vehicle: ""
                }));

                console.log("Default vehicle selected:", firstVehicle.VehicleRegistrationId);
            }
        }, [vehiclesForSpot, selectedVehiclePrimaryKey]);

        // Helper: should disable Get Random Space button if vehicle required but not selected
        const isVehicleRequired = vehiclesForSpot.length > 0;
        const isVehicleSelected = !!selectedVehicle;


        const safeHtml = DOMPurify
            .sanitize(preBookingQuestion)
            .replace(/<a /g, '<a target="_blank" rel="noopener noreferrer" ');

        const isDisabled =
            isLoading ||
            (isVehicleRequired && !isVehicleSelected) ||
            (!!preBookingQuestion && !checkedPreBookingQue);

        // const CreditValueCut  = 
        //     (creditValue == 1 && bookingForModal?.IndividualDayCost > 0)
        const bookingModalMemberName = activeGuestFlag === 1
            ? t("guest")
            : selectedMemberData?.FullName
            || selectedName
            || `${sessionStorage.getItem("firstname")} ${sessionStorage.getItem("lastname")}`;
       

        const MapButton = ({ onClick }) => (
            <div className="mb-3">
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        onClick();
                    }}
                    className="green-outline-with-icon w-100 mw-100 min-height-56 selected"
                >
                    <img src={GreenMap} alt="Map" />
                    <span>{t("gotomap")}</span>
                </a>
            </div>
        );

        const CancelButton = ({ label = "cancel_booking", onClick }) => (
            <a
                href="#"
                onClick={(e) => {
                    e.preventDefault();
                    onClick();
                }}
                className="main-btn cancel-btn"
            >
                {/* <img src={closeIcon} alt="" />
                &nbsp; */}
                <span>{t(label)}</span>
            </a>
        );

        const ScheduleMeetingButton = ({ onClick }) => (
            <div className="mb-3">
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        onClick();
                    }}
                    className="green-outline-with-icon w-100 mw-100 min-height-56"
                >
                    <img src={ScheduleMeetingicon} alt="Edit" />
                    <span>{t("react_schedule_meeting")}</span>
                </a>
            </div>
        );

        const CheckInButton = ({ onClick }) => (

            <div className="d-block w-100 mb-3">
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        onClick();
                    }}
                    className="fc-checkInBtn-button w-100 fc-checkInBtn-img">
                    <img src={CheckInIcon} className="img-fluid"></img>
                    <span>{t("react_check_in")}</span>
                </a>
            </div>

        );

        const CheckOutButton = ({ onClick }) => (
            <div >
                <div className="d-block w-100 mb-3">
                    <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            onClick();
                        }}
                        className="fc-checkInBtn-button fc-button fc-button-primary active w-100 fc-checkInBtn-img">
                        <img src={CheckInIcon} className="img-fluid"></img>
                        <span>{t("react_check_out")}</span>
                    </a>
                </div>
            </div>
        );

        const showMap =
            mapAvailable === 1 && mapAvailableType !== 1;

        const deskBooked =
            bookingForModal?.DeskAvailable === 0 &&
            bookingForModal?.DeskCount === 1;

        const meetingBooked =
            bookingForModal?.MeetingCount === 0
            && bookingForModal?.MeetingRoomAvailable === 1;
        // && bookingForModal?.MeetingCount === 1;

        const canScheduleMeeting =
            bookingForModal?.MeetingRoomAvailable === 1;

        const canCancelDesk =
            bookingForModal?.DeskCount === 1 ||
            bookingForModal?.HourlyBookingCount !== 0;
        // deskBooked && !meetingBooked;

        const canCancelMeeting =
            meetingBooked;

        const cancelModalParticipantName =
            activeGuestFlag === 1
                ? bookingForModal?.GuestName || selectedName || t("guest")
                : selectedMemberData?.FullName || selectedName || (UserFirstName + " " + userLastName) || t("name");

        const checkInTypesAPI = Array.isArray(bookingForModal?.CheckInType)
            ? bookingForModal.CheckInType
            : bookingForModal?.CheckInType != null
                ? [bookingForModal.CheckInType]
                : [];

        const checkInTypes = checkInTypesAPI.includes(2);

        const showcheckOutButton = checkInTypesAPI.includes(0) ? false : true;

        const checkInButton =
            checkInTypes && (bookingForModal?.CheckInFlag === 0 || bookingForModal?.CheckInFlag === 2) && activeGuestFlag == 0;

        const checkOutButton =
            showcheckOutButton &&
            bookingForModal?.CheckInFlag === 1;

        const isParkingBooking = Number(iconzoneType) === 1;

        const getrandomspace = bookingForModal?.DeskAvailable == 1 && bookingForModal?.DeskCount == 0

        const SpotTakenButton = ({ onClick }) => (
            <div className="d-flex justify-content-between align-items-center mb-3">
                <button
                    type="button"
                    className="main-btn fill-red-btn w-100"
                    onClick={(e) => {
                        e.preventDefault();
                        onClick();
                    }}
                >
                    <img src={Images.ExclamationCircle} alt="" />
                    <span>{t("react_spot_taken")}?</span>
                </button>
            </div>
        );

        const varzonecreditvalue = zoneCreditValue
        console.log("varzonecreditvalue", varzonecreditvalue);

        const displayCreditValue = getDisplayRefundCreditValue({
            refundStartDateTime: bookingForModal?.RefundStartDateTime,
            refundEndDateTime: bookingForModal?.RefundEndDateTime,
            zoneCurrentDateTime: recordsData?.ZoneCurrentDateTime,
            fullRefundCredit: bookingForModal?.FullRefundCredit,
            halfRefundCredit: bookingForModal?.HalfRefundCredit,
            noRefundCredit: bookingForModal?.NoRefundCredit
        });

        const isZeroDisplayCredit =
            displayCreditValue === 0 || displayCreditValue === "0";

        const CreditValueGrey =
            (zoneCreditValue == 1 && bookingForModal?.IndividualDayCost == 0)

        const CreditValueAdd =
            (zoneCreditValue == 1 && bookingForModal?.IndividualDayCost == 1)

        const spotName = bookingForModal?.SpotName || "";

        const assignTitle = formatReactString(t("YourBookingForSpace"), [spotName], {
            defaultRenderer: (val) => (
                <span className="color-dark-black">{val}</span>
            )
        });

        const book_space_s = formatReactString(t("book_space_s"), [spotName], {
            defaultRenderer: (val) => (
                <span className="color-dark-black">{val}</span>
            )
        });
        console.log("LOADER STATUS - loadingDates, isLoading", loadingDates, isLoading);
        return (
            <div>
                <div className="modal modalscroll" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                    id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                        <div className="modal-content modal-radius">
                            <div className="modal-body">
                                <div className="close-modal">
                                    <a onClick={onClose}>
                                        <img src={Close} aria-label="Close" />
                                    </a>
                                </div>
                                <div className="pt-4">
                                    {/* <h5 className="popup-title">{t("react_manage_booking_for")} {bookingForModal?.SpotName} </h5> */}
                                    <h5 className="popup-title">{assignTitle}</h5>
                                    {/* {
                                            CreditValueGrey ? "" :
                                                CreditValueAdd ? "+" : ""
                                        }
                                        {bookingForModal?.IndividualDayCost} */}

                                </div>
                                <div className="date-with-credit d-flex align-items-center justify-content-between pt-2">
                                    <div id="selectedDate" className="selected-current-date">
                                        <span>{selectedDay}</span>
                                        <span>{t(displayMonth)} {displayYear}</span>
                                    </div>
                                    {varzonecreditvalue > 0 && (
                                        <div className="credit-info">
                                            <a
                                                className="orange-outline-with-icon"
                                            >
                                                {/* {CreditValueGrey ?
                                                    (
                                                        <>
                                                            <img src={GrayStar} alt="star" />
                                                            <span>{bookingForModal?.IndividualDayCost}</span>
                                                        </>
                                                    )
                                                    :
                                                    <>
                                                        <img src={Images.OrangeStar} alt="" />
                                                        <span>
                                                            {Number(bookingForModal?.IndividualDayCost) > 0
                                                                ? `+${bookingForModal?.IndividualDayCost}`
                                                            : bookingForModal?.IndividualDayCost}
                                                        </span>
                                                    </>
                                                } */}
                                                {isZeroDisplayCredit ? (
                                                    <>
                                                        <img src={GrayStar} alt="star" className="img-fluid" />
                                                        <span>{displayCreditValue}</span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <img src={Images.OrangeStar} alt="star" className="img-fluid" />
                                                        <span>
                                                            {`+${displayCreditValue}`}
                                                        </span>
                                                    </>
                                                )}
                                            </a>
                                        </div>
                                    )
                                    }
                                </div>
                                <div className="divider-line mt-3"></div>
                                <div className="modal-des">
                                    <div className="modal-scroll-inner me-4">
                                        <div className="icon-with-list mb-3">
                                            <div className="icon-wrap">
                                                <img src={Images.ZoneMap} alt="map" />
                                                <h4 className="ps-1 ms-1">{zoneList?.find((z) => z.Id === selectedCalendarZoneId)?.ZoneName}</h4>
                                            </div>
                                            {(bookingForModal?.DeskCount) > 0 && (
                                                <div className="icon-wrap">
                                                    <img src={Images.TimeIcon} alt="repeat" />
                                                    <h4 className="ps-1 ms-1">
                                                        {t("all_day")} <span> {formatDateToEEEddMMM(bookingDate)}</span>
                                                    </h4>
                                                </div>
                                            )}
                                            <div className="icon-wrap">
                                                <img src={Images.Participant} />
                                                <h4 className="ps-1 ms-1">{cancelModalParticipantName}</h4>
                                            </div>
                                        </div>
                                        <div className="modal-tag">
                                            {bookingForModal?.SpotTagList && bookingForModal.SpotTagList.length > 0 && (
                                                <div className="modal-tag">
                                                    <button
                                                        type="button"
                                                        id="show-tag-tab"
                                                        className={showTags ? "active" : ""}
                                                        //onClick={() => setShowTags(!showTags)}
                                                        onClick={() => setShowTags(prev => !prev)}             
                                                    >
                                                        <img src={Images.ModalTag} className="img-fluid" alt="Tags" />
                                                        <span className="show-link">{t("show_tags")}</span>
                                                        <span className="hide-link">{t("react_hide_tags")}</span>
                                                    </button>
                                                </div>
                                            )}

                                            {showTags && bookingForModal?.SpotTagList && (
                                                <div id="all-tags" className={showTags ? "show" : ""}>
                                                    {bookingForModal.SpotTagList.map((tag, index) => (
                                                        <button type="button" key={index}>
                                                            {tag.TagName}
                                                        </button>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                        {/* <div className="text-center my-34">
                                    {iconzoneType === 1 ? (
                                        <img src={ParkingIcon} className="img-fluid" alt="Parking Booking" />
                                    ) : iconzoneType === 2 &&
                                        bookingForModal?.MeetingRoomAvailable === 1 &&
                                        bookingForModal?.HourlySpotAvailable === 0 &&
                                        bookingForModal?.DeskAvailable === 0 ? (
                                        <img src={MeetingIcon} className="img-fluid" alt="Meeting Room Booking" />
                                    ) : iconzoneType === 2 ? (
                                        <img src={DeskIcon} className="img-fluid" alt="Desk Booking" />
                                    ) : null}
                                </div> */}
                                    </div>
                                </div>

                                <div className='modalscroll-btn'>
                                    {
                                        (() => {
                                            if (!bookingForModal) return null;
                                            if (!showMap) {
                                                console.log("inside showMap", showMap)
                                                return (

                                                    <div>

                                                        {checkInButton &&
                                                            <CheckInButton onClick={() => {
                                                                console.log("CheckInButton clicked - loadingDates, isLoading", loadingDates, isLoading);
                                                                if (!loadingDates.includes(bookingDateStr)) {
                                                                    setShowCancelModal(false);
                                                                    setLoadingDates((prev) => [...prev, bookingDateStr]);
                                                                    CheckInOutAPI(zoneId, bookingDateStr, cancelBookingSpotId, 1)
                                                                        .then(() => fetchBookings(zoneId, formatDate(bookingDateStr)))
                                                                        .then(() => {
                                                                            onClose();
                                                                        })
                                                                        .finally(() => {
                                                                            setLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
                                                                        });
                                                                }
                                                            }} />}

                                                        {checkOutButton &&
                                                            <CheckOutButton onClick={() => {
                                                                console.log("CheckOutButton clicked - loadingDates, isLoading", loadingDates, isLoading);
                                                                if (!loadingDates.includes(bookingDateStr)) {
                                                                    setShowCancelModal(false);
                                                                    setLoadingDates((prev) => [...prev, bookingDateStr]);
                                                                    CheckOutAPI(zoneId, bookingDateStr, cancelBookingSpotId, 2)
                                                                        .then(() => fetchBookings(zoneId, formatDate(bookingDateStr)))
                                                                        .then(() => {
                                                                            onClose();
                                                                        })
                                                                        .finally(() => {
                                                                            setLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
                                                                        });
                                                                }
                                                            }} />}

                                                        {getrandomspace && (
                                                            <div className="mb-3">
                                                <a
                                                    href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();

                                                        // 🚫 Block if disabled
                                                        if (isDisabled) return;

                                                        // Vehicle validation (extra safety)
                                                        if (isVehicleRequired && !isVehicleSelected) {
                                                            setRequiredFields(prev => ({ ...prev, vehicle: "" }));
                                                            return;
                                                        }

                                                        // Proceed
                                                        const VehicleTypeId = selectedVehicle?.Id || 0;
                                                        const fuelId = selectedVehicle?.FuelId || 0;
                                                        const vehicleShareableId = selectedVehicle?.ShareableId || 0;
                                                        const vehicleAccessibleId = selectedVehicle?.AccessibleId || 0;
                                                        const vehicleRegistrationId = selectedVehicle?.VehicleRegistrationId || 0;

                                                        GetRandomSpace(
                                                            zoneId,
                                                            bookingDateStr,
                                                            VehicleTypeId,
                                                            fuelId,
                                                            vehicleShareableId,
                                                            vehicleAccessibleId,
                                                            vehicleRegistrationId,
                                                            selectedTeamMember === "0" ? 1 : 0
                                                        );

                                                        console.log("Get Random Space clicked", vehicleShareableId);

                                                        onClose();
                                                    }}
                                                    className={`green-outline-with-icon w-100 mw-100 min-height-56 ${isDisabled ? "disabled" : ""
                                                        }`}
                                                    style={{
                                                        opacity: isDisabled ? 0.5 : 1,
                                                        cursor: isDisabled ? "not-allowed" : "pointer",
                                                        //   pointerEvents: isDisabled ? "none" : "auto" // 🔥 key fix
                                                    }}
                                                >
                                                    {isLoading ? (
                                                        <>
                                                            <div className="animate-spin h-5 w-5 mr-3 border-t-2 border-b-2 border-green-500 rounded-full"></div>
                                                            <span>{t("loading")}</span>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <img src={EditSquare} alt="Edit" />
                                                            <span>{t("get_random_space")}</span>
                                                        </>
                                                    )}
                                                </a>
                                            </div>
                                                        )
                                                        }
                                                        <CancelButton
                                                            onClick={() => {
                                                                setShowCancelModal(true);
                                                                CancelBooking(zoneId, bookingDateStr, bookingForModal?.SpotId, checkInFlag);
                                                                onClose();
                                                            }}
                                                        />
                                                        {/* <a
                                                        href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            CancelBooking(zoneId, bookingDateStr, cancelBookingSpotId);
                                                            onClose();
                                                        }}
                                                        className="main-btn outline-gray-btn w-100 mw-100 min-height-56"
                                                    >
                                                        <span>Cancel Booking nomap</span>
                                                    </a> */}
                                                    </div>
                                                );
                                            }

                                            return (
                                                <>
                                                    {checkInButton && <CheckInButton onClick={async () => {
                                                        if (!loadingDates.includes(bookingDateStr)) {
                                                            setShowCancelModal(false)
                                                            console.log("CheckInButton2 clicked - loadingDates, isLoading", loadingDates, isLoading);
                                                            setLoadingDates((prev) => [...prev, bookingDateStr]);
                                                            try {
                                                                await CheckInOutAPI(zoneId, bookingDateStr, cancelBookingSpotId, checkInFlag);
                                                                await fetchBookings(zoneId, formatDate(bookingDateStr));
                                                                onClose();
                                                            } finally {
                                                                setLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
                                                            }
                                                        }
                                                    }} />}

                                                    {checkOutButton && <CheckOutButton onClick={async () => {
                                                        if (!loadingDates.includes(bookingDateStr)) {
                                                            setShowCancelModal(false)
                                                            console.log("CheckOutButton2 clicked - loadingDates, isLoading", loadingDates, isLoading);
                                                            setLoadingDates((prev) => [...prev, bookingDateStr]);
                                                            try {
                                                                await CheckOutAPI(zoneId, bookingDateStr, cancelBookingSpotId, checkInFlag);
                                                                await fetchBookings(zoneId, formatDate(bookingDateStr));
                                                                onClose();
                                                            } finally {
                                                                setLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
                                                            }
                                                        }
                                                    }} />}

                                                    <MapButton
                                                        onClick={() => GotoMapClick(zoneId, bookingDateStr)}
                                                    />

                                                    {/* //Parking Violation Button */}
                                                    {/* {isParkingBooking && bookingForModal?.SpotId && (
                                                    <SpotTakenButton
                                                        onClick={() => {
                                                            setShowCancelModal(false);
                                                            setShowReportParkingViolationModal(true);
                                                        }}
                                                    />
                                                )} */}

                                                    {canScheduleMeeting &&
                                                        (teamMemberList.length == 0 || samevalue) &&
                                                        activeGuestFlag === 0
                                                        && (
                                                            <ScheduleMeetingButton
                                                                onClick={() => {
                                                                    if (!isLoading) {
                                                                        setShowCancelModal(true);
                                                                        ScheduleMeeting(zoneId, bookingDateStr);
                                                                        onClose();
                                                                    }
                                                                }}
                                                            />)}

                                                    {/* {canScheduleMeeting && (
                                                    <>
                                                        <ScheduleMeetingButton
                                                            onClick={() => {
                                                                if (!isLoading) {
                                                                    ScheduleMeeting(zoneId, bookingDateStr);
                                                                    onClose();
                                                                }
                                                            }}
                                                        />

                                                        {bookingForModal.MeetingCount === 0 && (
                                                            <CancelButton
                                                                onClick={() => {
                                                                    CancelBooking(zoneId, bookingDateStr, cancelBookingSpotId);
                                                                    onClose();
                                                                }}
                                                            />
                                                        )}
                                                    </>
                                                )} */}
                                                 {getrandomspace && (
                                                            <div className="mb-3">
                                                <a
                                                    href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();

                                                        // 🚫 Block if disabled
                                                        if (isDisabled) return;

                                                        // Vehicle validation (extra safety)
                                                        if (isVehicleRequired && !isVehicleSelected) {
                                                            setRequiredFields(prev => ({ ...prev, vehicle: "" }));
                                                            return;
                                                        }

                                                        // Proceed
                                                        const VehicleTypeId = selectedVehicle?.Id || 0;
                                                        const fuelId = selectedVehicle?.FuelId || 0;
                                                        const vehicleShareableId = selectedVehicle?.ShareableId || 0;
                                                        const vehicleAccessibleId = selectedVehicle?.AccessibleId || 0;
                                                        const vehicleRegistrationId = selectedVehicle?.VehicleRegistrationId || 0;

                                                        GetRandomSpace(
                                                            zoneId,
                                                            bookingDateStr,
                                                            VehicleTypeId,
                                                            fuelId,
                                                            vehicleShareableId,
                                                            vehicleAccessibleId,
                                                            vehicleRegistrationId,
                                                            selectedTeamMember === "0" ? 1 : 0
                                                        );

                                                        console.log("Get Random Space clicked", vehicleShareableId);

                                                        onClose();
                                                    }}
                                                    className={`green-outline-with-icon w-100 mw-100 min-height-56 ${isDisabled ? "disabled" : ""
                                                        }`}
                                                    style={{
                                                        opacity: isDisabled ? 0.5 : 1,
                                                        cursor: isDisabled ? "not-allowed" : "pointer",
                                                        //   pointerEvents: isDisabled ? "none" : "auto" // 🔥 key fix
                                                    }}
                                                >
                                                    {isLoading ? (
                                                        <>
                                                            <div className="animate-spin h-5 w-5 mr-3 border-t-2 border-b-2 border-green-500 rounded-full"></div>
                                                            <span>{t("loading")}</span>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <img src={EditSquare} alt="Edit" />
                                                            <span>{t("get_random_space")}</span>
                                                        </>
                                                    )}
                                                </a>
                                            </div>
                                                        )
                                                        }



                                                    {canCancelDesk && (
                                                        <CancelButton
                                                            onClick={() => {
                                                                setShowCancelModal(true);
                                                                CancelBooking(zoneId, bookingDateStr, bookingForModal?.SpotId);
                                                                onClose();
                                                            }}
                                                        />
                                                    )}

                                                    {/* {canCancelMeeting && (
                                                    <CancelButton
                                                        label="Cancel Meeting"
                                                        onClick={() => {
                                                            CancelBooking(zoneId, bookingDateStr, cancelBookingSpotId);
                                                            onClose();
                                                        }}
                                                    />
                                                )} */}
                                                </>
                                            );


                                            // If mapAvailable === 0, show only Cancel Booking
                                            if (mapAvailable === 0) {
                                                // if (bookingForModal.DeskCount == 1) {
                                                return (
                                                    <div className="">
                                                        <a
                                                            onClick={() => {
                                                                // console.log("Passing spotId to CancelBooking:", cancelBookingSpotId);
                                                                CancelBooking(zoneId, bookingDateStr, cancelBookingSpotId);
                                                                onClose();
                                                            }}
                                                            href="#" className="main-btn outline-gray-btn w-100 mw-100 min-height-56">
                                                            {/* <img src={EditSquare} alt="Edit" /> */}
                                                            <span>Cancel Booking</span>
                                                        </a>
                                                    </div>
                                                );
                                                // }
                                            }
                                            return null;
                                        })()
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const LoadingProcessModal = () => {
        return (
            <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
            >
                <div className="modal fade show alertpopup d-block">
                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                        <div className="modal-content modal-radius">
                            <div className="modal-body">
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <h5 className="popup-title">{t("warning")}</h5>
                                    <div className="close-modal">
                                        <a onClick={() => setShowBookingProcess(false)}>
                                            <img src={WarningcloseIcon} aria-label="Close" />
                                        </a>
                                    </div>
                                </div>
                                <div className="modal-des mt-35">
                                    <p>
                                        {t("calender_request_pending_will_processed")}
                                    </p>
                                    <div className="modal-img text-center"><img className="warning-icon" src={WarningIcon} alt="Warning Icon" /></div>

                                    <div className="d-flex justify-content-end gap-3 mt-4">
                                        <button
                                            type="button"
                                            className="main-btn outline-alert-btn w-full"
                                            onClick={() => setShowBookingProcess(false)}
                                        >
                                            {t("confirm")}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const ReportParkingViolationModal = ({ zoneId, onClose }) => {
        const [plateNo, setPlateNo] = useState("");
        const bookingDate = clickedFullDay;
        const bookingDateStr = getLocalDateString(bookingDate);

        const bookingForModal =
            bookingSpotData.find((booking) => booking.BookingDate === bookingDateStr) ||
            Object.values(weekData).flat().find((booking) => booking.BookingDate === bookingDateStr);

        const spotId = bookingForModal?.SpotId || bookingForModal?.Schedules?.[0]?.SpotId || 0;
        const spotName = bookingForModal?.SpotName || bookingForModal?.Schedules?.[0]?.SpotName || "";
        const bookingPeriod = 2;

        return (
            <div id="divReportParkingViolationModal">
                <div
                    className="modal"
                    style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
                    id="dateModal"
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                >
                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                        <div className="modal-content modal-radius">
                            <div className="modal-body">
                                <div className="close-modal">
                                    <a onClick={(e) => {
                                        e.preventDefault();
                                        onClose();
                                    }}>
                                        <img src={Close} aria-label="Close" />
                                    </a>
                                </div>

                                <div className="pt-4 text-center px-4">
                                    <h5 className="popup-title text-red">
                                        {t("react_is_someone_already_parked")} <span>{spotName}?</span>
                                    </h5>
                                </div>

                                <div className="divider-line mt-3"></div>
                                <div className="text-center">
                                    <p>{t("react_enter_license_plate_number")}</p>
                                </div>
                                <div className="modal-details">
                                    <div className="form-row">
                                        <label className="popup-inner-title m-0">{t("license_plate_number")}</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            autoComplete="off"
                                            value={plateNo}
                                            onChange={(e) => setPlateNo(e.target.value)}
                                        />
                                    </div>
                                    <p>{t("react_parking_violation_notification")}</p>
                                </div>
                                <div className="mt-3 pt-3">
                                    <button
                                        className="main-btn fill-red-btn w-100"
                                        onClick={async (e) => {
                                            e.preventDefault();
                                            onClose();
                                            if (!isLoading) {
                                                await ParkingViolationReporting(zoneId, plateNo, spotId, spotName, bookingPeriod, bookingDateStr);
                                            }
                                        }}
                                    >
                                        {t("react_send_to_parking_management")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const AlternateParkingSpotModal = ({ zoneId, onClose }) => {
        if (!parkingViolationReportingData) return null;

        let titleText = `${t("react_parking_violation_reported")}`;
        let topContainerText = "";
        let bottomContainerText = "";
        let btnTxt = "";
        let availableSpotName = "";

        if (parkingViolationReportingData?.Screen === 1) {
            topContainerText = `${t("react_vehicle_parked_wrong_space")}`;
            bottomContainerText = `${t("react_parking_violation_reported")}`;
            availableSpotName = parkingViolationReportingData?.Records?.SpotName;
            btnTxt = `${t("react_yes_take_this_space")}`;
        } else if (parkingViolationReportingData?.Screen === 2) {
            topContainerText = `${t("react_parking_violation_reported")}`;
            bottomContainerText = `${t("no_parking_space_available")}`;
            btnTxt = t("confirm");
        } else if (parkingViolationReportingData?.Screen === 3) {
            if (parkingViolationReportingData?.Records?.SpotId === 0) {
                topContainerText = `${t("react_vehicle_not_registered")}`;
                bottomContainerText = `${t("no_parking_space_available")}`;
                btnTxt = t("confirm");
            } else if (parkingViolationReportingData?.Records?.SpotId > 0) {
                topContainerText = `${t("react_vehicle_not_registered")}`;
                bottomContainerText = `${t("react_found_alternate_space")}`;
                btnTxt = `${t("react_yes_take_this_space")}`;
                availableSpotName = parkingViolationReportingData?.Records?.SpotName;
            }
        }

        return (
            <div id="divAlternateParkingSpotModal">
                <div
                    className="modal"
                    style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
                    id="dateModal"
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                >
                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                        <div className="modal-content modal-radius">
                            <div className="modal-body">
                                <div className="close-modal">
                                    <a
                                        onClick={(e) => {
                                            e.preventDefault();
                                            onClose();
                                        }}
                                    >
                                        <img src={Close} aria-label="Close" />
                                    </a>
                                </div>

                                <div className="pt-4 text-center">
                                    <h5 className="popup-title pe-3">{titleText}</h5>
                                    <div className="d-flex align-items-center justify-content-center gap-2">
                                        <img src={Images.Participant} />
                                        <h4>{parkingViolationReportingData?.Records?.PlateNo}</h4>
                                    </div>
                                </div>

                                <div className="pt-4 text-center">
                                    <p>{topContainerText}</p>
                                </div>
                                <div className="divider-line mt-3"></div>
                                <div className="text-center my-34">
                                    <img src={ParkingIcon} className="img-fluid" alt="Parking Booking" />
                                </div>

                                <div className="modal-details text-center">
                                    <p>
                                        {bottomContainerText}
                                        <h5 className="color-green d-block mt-2 mb-0">{availableSpotName || ""}</h5>
                                    </p>
                                </div>

                                <button
                                    className="main-btn fill-green-btn w-100"
                                    onClick={async (e) => {
                                        e.preventDefault();
                                        onClose();
                                        if (!isLoading && parkingViolationReportingData?.Records?.SpotId > 0) {
                                            await AlternateParkingSpotBooking(zoneId, formatDate(selectedDate));
                                        }
                                    }}
                                >
                                    {btnTxt}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const JoinQueueModal = ({ date, onClose, zoneId }) => {
        // Helper to get weekKey for a given date
        function getWeekKey() {
            const date = clickedFullDay
            console.log("click on date clickedFullDay => ", date);
            const safeDate = getSafeDisplayDate(date);
            const dayOfWeek = safeDate?.getDay();
            console.log("Number of day in week => ", dayOfWeek);
            return getWeekKeyFromDate(date);
        }

        const bookingDate = clickedFullDay;
        const weekKey = bookingDate ? getWeekKey(bookingDate) : null;
        const bookingDateStr = getLocalDateString(bookingDate);

        // Find booking for modal from weekData first, fallback to bookingSpotData
        const bookingForModal =
            (weekKey && weekData && weekData[weekKey] && weekData[weekKey].find(
                (booking) => booking.BookingDate === bookingDateStr
            )) ||
            bookingSpotData.find(
                (booking) => booking.BookingDate === bookingDateStr
            );

        // Display helpers
        const safeBookingDate = getSafeDisplayDate(bookingDate);
        const displayDay = safeBookingDate ? safeBookingDate.getDate() : '';
        const displayMonth = safeBookingDate ? safeBookingDate.toLocaleDateString('en-US', { month: 'long' }) : '';
        const displayYear = safeBookingDate ? safeBookingDate.getFullYear() : '';

        // Vehicle selection logic (copied from MapGridZone)
        const [vehicleOpen, setVehicleOpen] = useState(false);
        const [selectedVehicle, setSelectedVehicle] = useState(null);
        const [selectedVehiclePrimaryKey, setSelectedVehiclePrimaryKey] = useState(null);
        const [requiredFields, setRequiredFields] = useState({ vehicle: "" });
        // Example: vehiclesForSpot should come from bookingForModal or props
        const vehiclesForSpot = bookingForModal?.EmployeeVehicleType || [];

        useEffect(() => {
            if (vehiclesForSpot && vehiclesForSpot.length > 0 && !selectedVehiclePrimaryKey) {
                const firstVehicle = vehiclesForSpot[0];
                const firstPk = firstVehicle.VehiclePrimaryKey;

                setSelectedVehiclePrimaryKey(firstPk);
                setSelectedVehicle(firstVehicle);
                setRequiredFields((prev) => ({
                    ...prev,
                    vehicle: ""
                }));

                console.log("Default vehicle selected:", firstVehicle.VehicleRegistrationId);
            }
        }, [vehiclesForSpot, selectedVehiclePrimaryKey]);

        // Helper: should disable Get Random Space button if vehicle required but not selected
        const isVehicleRequired = vehiclesForSpot.length > 0;
        const isVehicleSelected = !!selectedVehicle;

        const varzonecreditvalue = zoneCreditValue

        const CreditValueGrey =
            (zoneCreditValue == 1 && bookingForModal?.IndividualDayCost == 0)

        const CreditValueAdd =
            (zoneCreditValue == 1 && bookingForModal?.IndividualDayCost == 1)
        console.log("CreditValueGrey", CreditValueGrey);
        console.log("CreditValueAdd", CreditValueAdd);

        const MapButton = ({ onClick }) => (
            <div className="mb-3">
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        onClick();
                    }}
                    className="green-outline-with-icon w-100 mw-100 min-height-56 selected"
                    style={{ cursor: "pointer" }}
                >
                    <img src={GreenMap} alt="Map" />
                    <span>{t("gotomap")}</span>
                </a>
            </div>
        );

        const ScheduleMeetingButton = ({ onClick }) => (
            <div className="mb-4">
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        onClick();
                    }}
                    className="green-outline-with-icon w-100 mw-100 min-height-56"
                    style={{ cursor: "pointer" }}
                >
                    <img src={ScheduleMeetingicon} alt="Edit" />
                    <span>{t("react_schedule_meeting")}</span>
                </a>
            </div>
        );

        const showMap =
            mapAvailable === 1
        const canScheduleMeeting =
            bookingForModal?.MeetingRoomAvailable === 1;
        const safeHtml = DOMPurify
            .sanitize(preBookingQuestion)
            .replace(/<a /g, '<a target="_blank" rel="noopener noreferrer" ');

        const samevalue = getGuId() == selectedTeamMember

        return (
            <div>
                <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                    id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                        <div className="modal-content modal-radius">
                            <div className="modal-body">
                                <div className="close-modal">
                                    <a onClick={onClose}>
                                        <img src={Close} aria-label="Close" />
                                    </a>
                                </div>
                                <div className="pt-4">
                                    <h5 className="popup-title">{t("react_no_space_left")} </h5>
                                </div>
                                <div className="date-with-credit d-flex align-items-center justify-content-between pt-2">
                                    <div id="selectedDate" className="selected-current-date">
                                        <span>{selectedDay}</span>
                                        <span>{t(displayMonth)} {displayYear}</span>
                                    </div>
                                    {varzonecreditvalue > 0 && (
                                        <div className="credit-info">
                                            <a
                                                className="orange-outline-with-icon"
                                            >
                                                {CreditValueGrey ?
                                                    (
                                                        <>
                                                            <img src={GrayStar} alt="star" />
                                                            <span>{bookingForModal?.IndividualDayCost}</span>
                                                        </>
                                                    )
                                                    :
                                                    <>
                                                        <img src={Images.OrangeStar} alt="" />
                                                        {/* <span>{(`-${bookingForModal?.IndividualDayCost}`)}</span> */}
                                                        {Number(bookingForModal?.IndividualDayCost) > 0
                                                            ? `-${bookingForModal?.IndividualDayCost}`
                                                            : bookingForModal?.IndividualDayCost}
                                                    </>
                                                }
                                            </a>
                                        </div>
                                    )}
                                </div>
                                <div className="divider-line mt-3"></div>
                                <div className="participants-list ctm-checklist">
                                    {!!preBookingQuestion && (
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id={`preBookingQuestion`}
                                                checked={checkedPreBookingQue}
                                                onChange={(e) => setCheckedPreBookingQue(e.target.checked)}
                                            />

                                            <label
                                                className="form-check-label ms-2"
                                                htmlFor={`preBookingQuestion`}
                                            >
                                                <span dangerouslySetInnerHTML={{ __html: safeHtml }} />

                                            </label>
                                        </div>
                                    )}
                                </div>
                                <div className="text-center my-34">
                                    {iconzoneType === 1 ? (
                                        <img src={ParkingIcon} className="img-fluid" alt="Parking Booking" />
                                    ) : iconzoneType === 2 &&
                                        bookingForModal?.MeetingRoomAvailable === 1 &&
                                        bookingForModal?.HourlySpotAvailable === 0 &&
                                        bookingForModal?.DeskAvailable === 0 ? (
                                        <img src={MeetingIcon} className="img-fluid" alt="Meeting Room Booking" />
                                    ) : iconzoneType === 2 ? (
                                        <img src={DeskIcon} className="img-fluid" alt="Desk Booking" />
                                    ) : null}
                                </div>

                                {
                                    (() => {
                                        // if (!bookingForModal) return null;
                                        // if (isQueue === 1) {
                                        //     // Both Desk and Meeting Room available
                                        //     if (bookingForModal.DisplayQueue === 1) {
                                        if (!showMap) {
                                            return (
                                                <>
                                                    <div className="mb-3">
                                                        <button
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                if (!isLoading) {
                                                                    const VehicleTypeId = selectedVehicle?.Id || 0;
                                                                    const fuelId = selectedVehicle?.FuelId || 0;
                                                                    const vehicleShareableId = selectedVehicle?.ShareableId || 0;
                                                                    const vehicleAccessibleId = selectedVehicle?.AccessibleId || 0;
                                                                    const vehicleRegistrationId = selectedVehicle?.VehicleRegistrationId || 0;

                                                                    GetRandomSpace(zoneId, bookingDateStr, VehicleTypeId, fuelId, vehicleShareableId, vehicleAccessibleId, vehicleRegistrationId, isGuestTeamMember ? 1 : 0);
                                                                    onClose();
                                                                }
                                                            }}
                                                            href="#" className="green-outline-with-icon w-100 mw-100 min-height-56 selected"
                                                            disabled={
                                                                isLoading ||
                                                                (!!preBookingQuestion && !checkedPreBookingQue)
                                                            }
                                                            style={{
                                                                opacity:
                                                                    isLoading ||
                                                                        (!!preBookingQuestion && !checkedPreBookingQue)
                                                                        ? 0.5
                                                                        : 1,
                                                                cursor:
                                                                    isLoading ||
                                                                        (!!preBookingQuestion && !checkedPreBookingQue)
                                                                        ? "not-allowed"
                                                                        : "pointer"
                                                            }}>
                                                            <img src={userQueIcon} alt="Map" /><span>{t("react_join_to_queue")}</span>
                                                        </button>
                                                    </div>
                                                    <div className="mb-3">
                                                        {canScheduleMeeting &&
                                                            (teamMemberList.length == 0 || samevalue) &&
                                                            activeGuestFlag === 0 && (
                                                                <ScheduleMeetingButton
                                                                    onClick={() => {
                                                                        if (!isLoading) {
                                                                            ScheduleMeeting(zoneId, bookingDateStr);
                                                                            onClose();
                                                                        }
                                                                    }}
                                                                />
                                                            )}
                                                    </div>
                                                </>
                                            );
                                        }
                                        return (
                                            <>

                                                <MapButton
                                                    onClick={() => GotoMapClick(zoneId, bookingDateStr)}
                                                />
                                                <div className="mb-3">
                                                <button
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        if (!isLoading) {
                                                            const VehicleTypeId = selectedVehicle?.Id || 0;
                                                            const fuelId = selectedVehicle?.FuelId || 0;
                                                            const vehicleShareableId = selectedVehicle?.ShareableId || 0;
                                                            const vehicleAccessibleId = selectedVehicle?.AccessibleId || 0;
                                                            const vehicleRegistrationId = selectedVehicle?.VehicleRegistrationId || 0;

                                                            GetRandomSpace(zoneId, bookingDateStr, VehicleTypeId, fuelId, vehicleShareableId, vehicleAccessibleId, vehicleRegistrationId, isGuestTeamMember ? 1 : 0);
                                                            onClose();
                                                        }
                                                    }}
                                                    href="#" className="green-outline-with-icon w-100 mw-100 min-height-56"
                                                    disabled={
                                                        isLoading ||
                                                        (!!preBookingQuestion && !checkedPreBookingQue)
                                                    }
                                                    style={{
                                                        opacity:
                                                            isLoading ||
                                                                (!!preBookingQuestion && !checkedPreBookingQue)
                                                                ? 0.5
                                                                : 1,
                                                        cursor:
                                                            isLoading ||
                                                                (!!preBookingQuestion && !checkedPreBookingQue)
                                                                ? "not-allowed"
                                                                : "pointer"
                                                    }}>
                                                    <img src={userQueIcon} alt="Map" /><span>{t("react_join_to_queue")}</span>
                                                </button>
                                                </div>
                                                {canScheduleMeeting &&
                                                    (teamMemberList.length == 0 || samevalue) &&
                                                    activeGuestFlag === 0 && (
                                                        <ScheduleMeetingButton
                                                            onClick={() => {
                                                                if (!isLoading) {
                                                                    ScheduleMeeting(zoneId, bookingDateStr);
                                                                    onClose();
                                                                }
                                                            }}
                                                        />
                                                    )}
                                            </>
                                        );
                                    })()
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const LeaveQueueModal = ({ date, onClose, zoneId }) => {
        // Helper to get weekKey for a given date
        function getWeekKey() {
            const date = clickedFullDay
            // console.log("click on date clickedFullDay => ", date);
            const safeDate = getSafeDisplayDate(date);
            const dayOfWeek = safeDate?.getDay();
            // console.log("Number of day in week => ", dayOfWeek);
            return getWeekKeyFromDate(date);
        }

        // Use bookingCreateDate from parent state
        const bookingDate = clickedFullDay;
        const weekKey = bookingDate ? getWeekKey(bookingDate) : null;
        const bookingDateStr = getLocalDateString(bookingDate);

        // Find booking for modal from weekData first, fallback to bookingSpotData
        const bookingForModal =
            (weekKey && weekData && weekData[weekKey] && weekData[weekKey].find(
                (booking) => booking.BookingDate === bookingDateStr
            )) ||
            bookingSpotData.find(
                (booking) => booking.BookingDate === bookingDateStr
            );

        // Display helpers
        const safeBookingDate = getSafeDisplayDate(bookingDate);
        const displayDay = safeBookingDate ? safeBookingDate.getDate() : '';
        const displayMonth = safeBookingDate ? safeBookingDate.toLocaleDateString('en-US', { month: 'long' }) : '';
        const displayYear = safeBookingDate ? safeBookingDate.getFullYear() : '';

        const varzonecreditvalue = zoneCreditValue

        const displayCreditValue = getDisplayRefundCreditValue({
            refundStartDateTime: bookingForModal?.RefundStartDateTime,
            refundEndDateTime: bookingForModal?.RefundEndDateTime,
            zoneCurrentDateTime: recordsData?.ZoneCurrentDateTime,
            fullRefundCredit: bookingForModal?.FullRefundCredit,
            halfRefundCredit: bookingForModal?.HalfRefundCredit,
            noRefundCredit: bookingForModal?.NoRefundCredit
        });

        const isZeroDisplayCredit =
            displayCreditValue === 0 || displayCreditValue === "0";

        const CreditValueGrey =
            (zoneCreditValue == 1 && bookingForModal?.IndividualDayCost == 0)

        const CreditValueAdd =
            (zoneCreditValue == 1 && bookingForModal?.IndividualDayCost == 1)
        console.log("CreditValueGrey", CreditValueGrey);
        console.log("CreditValueAdd", CreditValueAdd);

        const MapButton = ({ onClick }) => (
            <div className="mb-3">
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        onClick();
                    }}
                    className="green-outline-with-icon w-100 mw-100 min-height-56 selected"
                >
                    <img src={GreenMap} alt="Map" />
                    <span>{t("gotomap")}</span>
                </a>
            </div>
        );

        const ScheduleMeetingButton = ({ onClick }) => (
            <div className="mb-3">
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        onClick();
                    }}
                    className="green-outline-with-icon w-100 mw-100 min-height-56"
                    style={{ cursor: "pointer" }}
                >
                    <img src={ScheduleMeetingicon} alt="Edit" />
                    <span>{t("react_schedule_meeting")}</span>
                </a>
            </div>
        );

        const CancelButton = ({ onClick }) => (
            <a
                href="#"
                onClick={(e) => {
                    e.preventDefault();
                    onClick();
                }}
                className="green-outline-with-icon w-100 mw-100 min-height-56"
            >
                <img src={userInQueIcon} alt="Leave Queue" className="me-2" />
                <span>{t("react_leave_waitlist")}</span>
            </a>
        );

        const showMap =
            mapAvailable === 1
        const canScheduleMeeting =
            bookingForModal?.MeetingRoomAvailable === 1;
        const samevalue = getGuId() == selectedTeamMember

        return (
            <div>
                <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                    id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                        <div className="modal-content modal-radius">
                            <div className="modal-body">
                                <div className="close-modal">
                                    <a onClick={onClose}>
                                        <img src={Close} aria-label="Close" />
                                    </a>
                                </div>
                                <div className="pt-4">
                                    {bookingForModal?.QueuePosition == 0 &&
                                        <h5 className="popup-title">{t("react_you_are_on_waitlist")} </h5>
                                    }
                                    {bookingForModal?.QueuePosition > 0 &&
                                        <h5 className="popup-title">{t("react_waitlist_position")}
                                            <span style={{ color: "black" }}> {bookingForModal?.QueuePosition} </span>
                                            {t("react_on_the_waitlist")}
                                        </h5>
                                    }
                                </div>

                                <div className="date-with-credit d-flex align-items-center justify-content-between pt-2">
                                    <div id="selectedDate" className="selected-current-date">
                                        <span>{selectedDay}</span>
                                        <span>{t(displayMonth)} {displayYear}</span>
                                    </div>
                                    {varzonecreditvalue > 0 && (
                                        <div className="credit-info">
                                            <a
                                                className="orange-outline-with-icon"
                                            >
                                                {/* {CreditValueGrey ?
                                                    (
                                                        <>
                                                            <img src={GrayStar} alt="star" />
                                                            <span>{bookingForModal?.IndividualDayCost}</span>
                                                        </>
                                                    )
                                                    :
                                                    <>
                                                        <img src={Images.OrangeStar} alt="" />
                                                        <span>
                                                            {Number(bookingForModal?.IndividualDayCost) > 0
                                                                ? `+${bookingForModal?.IndividualDayCost}`
                                                            : bookingForModal?.IndividualDayCost}
                                                        </span>
                                                    </>
                                                } */}
                                                {isZeroDisplayCredit ? (
                                                    <>
                                                        <img src={GrayStar} alt="star" className="img-fluid" />
                                                        <span>{displayCreditValue}</span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <img src={Images.OrangeStar} alt="star" className="img-fluid" />
                                                        <span>
                                                            {`+${displayCreditValue}`}
                                                        </span>
                                                    </>
                                                )}
                                            </a>
                                        </div>
                                    )}
                                </div>
                                <div className="divider-line mt-3"></div>
                                <div className="text-center my-34">
                                    {iconzoneType === 1 ? (
                                        <img src={ParkingIcon} className="img-fluid" alt="Parking Booking" />
                                    ) : iconzoneType === 2 &&
                                        bookingForModal?.MeetingRoomAvailable === 1 &&
                                        bookingForModal?.HourlySpotAvailable === 0 &&
                                        bookingForModal?.DeskAvailable === 0 ? (
                                        <img src={MeetingIcon} className="img-fluid" alt="Meeting Room Booking" />
                                    ) : iconzoneType === 2 ? (
                                        <img src={DeskIcon} className="img-fluid" alt="Desk Booking" />
                                    ) : null}
                                </div>
                                {/* <CancelButton
                                    onClick={() => {
                                        CancelBooking(zoneId, bookingDateStr, bookingForModal?.SpotId);
                                        onClose();
                                    }} /> */}

                                {
                                    (() => {
                                        // if (!bookingForModal) return null;
                                        // Both Desk and Meeting Room available
                                        // if (isQueue === 1 && bookingForModal.JoinedQueue === 1)
                                        // if ((zoneType === 1 && spotType === 1) || (zoneType === 2 && spotType === 2))
                                        if (!showMap) {
                                            return (
                                                <div className="">
                                                    <CancelButton
                                                        onClick={() => {
                                                            CancelBooking(zoneId, bookingDateStr, bookingForModal?.SpotId);
                                                            onClose();
                                                        }} />

                                                    <div className="mb-3">
                                                        {canScheduleMeeting &&
                                                            (teamMemberList.length == 0 || samevalue) &&
                                                            activeGuestFlag === 0 && (
                                                                <ScheduleMeetingButton
                                                                    onClick={() => {
                                                                        if (!isLoading) {
                                                                            ScheduleMeeting(zoneId, bookingDateStr);
                                                                            onClose();
                                                                        }
                                                                    }}
                                                                />
                                                            )}
                                                    </div>
                                                </div>
                                            )
                                        }
                                        //     return (()=> {
                                        //         <>
                                        //             <CancelButton
                                        //                 onClick={() => {
                                        //                     CancelBooking(zoneId, bookingDateStr, bookingForModal?.SpotId);
                                        //                     onClose();
                                        //     }}
                                        // />
                                        //             <div className="mb-4">
                                        //                 <a
                                        //                     onClick={() => GotoMapClick(zoneId, bookingDateStr)}
                                        //                     href="#" className="green-outline-with-icon w-100 mw-100 min-height-56 selected">
                                        //                     <img src={GreenMap} alt="Map" /><span>Go to map</span>
                                        //                 </a>
                                        //             </div>
                                        //             <div className='mb-3'>
                                        //                 <a
                                        //                     onClick={() => LeaveQueueModal(zoneId, bookingDateStr)}
                                        //                     href="#" className="green-outline-with-icon w-100 mw-100 min-height-56 selected">
                                        //                     <img src={GreenMap} alt="Map" /><span>Leave the queue</span>
                                        //                 </a>
                                        //             </div>

                                        //         </>
                                        // });
                                        return (
                                            <>
                                                {/* {showMap && */}
                                                <MapButton
                                                    onClick={() => GotoMapClick(zoneId, bookingDateStr)}
                                                />
                                                {/* && */}
                                                <div className="mb-3">
                                                    {canScheduleMeeting &&
                                                        (teamMemberList.length == 0 || samevalue) &&
                                                        activeGuestFlag === 0 && (
                                                            <ScheduleMeetingButton
                                                                onClick={() => {
                                                                    if (!isLoading) {
                                                                        ScheduleMeeting(zoneId, bookingDateStr);
                                                                        onClose();
                                                                    }
                                                                }}
                                                            />
                                                        )}
                                                </div>
                                                <CancelButton
                                                    onClick={() => {
                                                        CancelBooking(zoneId, bookingDateStr, bookingForModal?.SpotId);
                                                        onClose();
                                                    }} />
                                                {/* } */}
                                            </>
                                        )

                                        return null;
                                    })()
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const GuestModal = ({ onClose }) => {
        function getWeekKey() {
            const date = clickedFullDay
            console.log("click on date clickedFullDay => ", date);
            const safeDate = getSafeDisplayDate(date);
            const dayOfWeek = safeDate?.getDay();
            console.log("Number of day in week => ", dayOfWeek);
            return getWeekKeyFromDate(date);
        }
        const bookingDate = clickedFullDay;
        const weekKey = bookingDate ? getWeekKey(bookingDate) : null;
        const bookingDateStr = getLocalDateString(bookingDate);

        console.log("Booking Date String:", bookingDateStr);
        console.log("Booking Date:", bookingDate);
        console.log("Week Key:", weekKey);
        console.log("Booking Date String:", bookingDateStr);

        // Find booking for modal from weekData first, fallback to bookingSpotData
        const bookingForModal =
            (weekKey && weekData && weekData[weekKey] && weekData[weekKey].find(
                (booking) => booking.BookingDate === bookingDateStr
            )) ||
            bookingSpotData.find(
                (booking) => booking.BookingDate === bookingDateStr
            );

        const GuestVehicleTypes = bookingForModal?.GuestVehicleTypes || bookingForModal?.GuestVehicleType || [];
        const GuestFuelTypes = bookingForModal?.GuestFuelTypes || [];
        const GuestShareableTypes = bookingForModal?.GuestShareableTypes || [];
        const GuestAccessibleTypes = bookingForModal?.GuestAccessibleTypes || [];
        const guestShareableOptions = [{ Id: 0, Name: "--" }, ...GuestShareableTypes];
        const guestAccessibleOptions = [{ Id: 0, Name: "--" }, ...GuestAccessibleTypes];
        return (
            <div>
                {/* <form> */}
                <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                    id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                        <div className="modal-content modal-radius">
                            <div className="modal-body">
                                <div className="close-modal">
                                    <a className="close-modal">
                                        <img src={Close} alt="Close" onClick={resetForm} />
                                    </a>
                                </div>
                                <div className="pt-2">
                                    <h5 className="popup-title">{t("react_guest_details")}</h5>
                                </div>

                                {/* <h5>Guest Details</h5> */}
                                <form>
                                    <div>
                                        <div className="form-row mb-3">
                                            <label className="popup-inner-title m-0">{t("firstName")}*</label>
                                            <input
                                                type="text"
                                                placeholder={`${t("firstName")}*`}
                                                className={`form-control ${guestErrors.fullDay.firstname ? "error-form" : ""} ${!guestErrors.fullDay.firstname && guestName ? "success-validation" : ""}`}
                                                value={guestName}
                                                onChange={(e) => {
                                                    setGuestName(e.target.value);
                                                    clearGuestFieldError("fullDay", "firstname");
                                                }}
                                            />
                                            {guestErrors.fullDay.firstname && (
                                                <div className="error-text"><img src={Images.ErrorMsg} alt="" /> <p>{guestErrors.fullDay.firstname}</p></div>
                                            )}
                                        </div>

                                        <div className="form-row mb-3">
                                            <label className="popup-inner-title m-0">{t("lastName")}*</label>
                                            <input
                                                type="text"
                                                placeholder={`${t("lastName")}*`}
                                                className={`form-control ${guestErrors.fullDay.lastname ? "error-form" : ""} ${!guestErrors.fullDay.lastname && guestLastName ? "success-validation" : ""}`}
                                                value={guestLastName}
                                                onChange={(e) => {
                                                    setGuestLastName(e.target.value);
                                                    clearGuestFieldError("fullDay", "lastname");
                                                }}
                                            />
                                            {guestErrors.fullDay.lastname && (
                                                <div className="error-text"><img src={Images.ErrorMsg} alt="" /> <p>{guestErrors.fullDay.lastname}</p></div>
                                            )}
                                        </div>

                                        <div className="form-row mb-3">
                                            <label className="popup-inner-title m-0">{t("email_address")}*</label>
                                            <input
                                                type="email"
                                                placeholder="___@____"
                                                className={`form-control ${guestErrors.fullDay.email ? "error-form" : ""} ${!guestErrors.fullDay.email && guestEmail ? "success-validation" : ""}`}
                                                value={guestEmail}
                                                onChange={(e) => {
                                                    setGuestEmail(e.target.value);
                                                    clearGuestFieldError("fullDay", "email");
                                                }}
                                            />
                                            {guestErrors.fullDay.email && (
                                                <div className="error-text"><img src={Images.ErrorMsg} alt="" /> <p>{guestErrors.fullDay.email}</p></div>
                                            )}
                                        </div>

                                        <div className="form-row mb-3">
                                            <label className="popup-inner-title m-0">{t("react_national_id_optional")}</label>
                                            <input
                                                type="text"
                                                placeholder={`${t("react_national_id_optional")}`}
                                                className="form-control"
                                                value={identificatoin}
                                                onChange={(e) => setIdentification(e.target.value)}
                                            />
                                        </div>

                                        {GuestVehicleTypes.length > 0 && (
                                            <div className="form-row mb-3">
                                                <label className="popup-inner-title m-0">{t("vehicle_registration_number")}</label>
                                                <input
                                                    type="text"
                                                    placeholder={`${t("vehicle_registration_number")}`}
                                                    className="form-control"
                                                    value={selectedGuestVehicleNumber}
                                                    onChange={(e) => setSelectedGuestVehicleNumber(e.target.value)}
                                                />
                                            </div>
                                        )}

                                        {GuestVehicleTypes.length > 0 && (
                                            <div className="form-row mb-3">
                                                <label className="popup-inner-title m-0">{t("react_vehicle_size")}</label>
                                                <div className="custom-dropdown modal-dropdown mb-3" style={{ position: "relative" }}>
                                                    <CustomSearchableDropdown
                                                        items={GuestVehicleTypes}
                                                        value={selectedGuestVehicleType?.Id ?? GuestVehicleTypes[0]?.Id ?? ""}
                                                        labelKey="Name"
                                                        valueKey="Id"
                                                        searchable={false}
                                                        placeholder={`${t("react_national_id_optional")}`}
                                                        disabled={!GuestVehicleTypes.length}
                                                        onChange={(value) => {
                                                            const vehicleType = GuestVehicleTypes.find((v) => String(v.Id) === String(value)) || null;
                                                            setSelectedGuestVehicleType(vehicleType);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {GuestFuelTypes.length > 0 && (
                                            <div className="form-row mb-3">
                                                <label className="popup-inner-title m-0">{t("fuel")}</label>
                                                <div className="custom-dropdown modal-dropdown mb-3" style={{ position: "relative" }}>
                                                    <CustomSearchableDropdown
                                                        items={GuestFuelTypes}
                                                        value={selectedGuestFuelType?.Id ?? GuestFuelTypes[0]?.Id ?? ""}
                                                        labelKey="Name"
                                                        valueKey="Id"
                                                        searchable={false}
                                                        placeholder={`${t("fuel")}`}
                                                        disabled={!GuestFuelTypes.length}
                                                        onChange={(value) => {
                                                            const fuelType = GuestFuelTypes.find((f) => String(f.Id) === String(value)) || null;
                                                            setSelectedGuestFuelType(fuelType);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {GuestAccessibleTypes.length > 0 && (
                                            <div className="form-row mb-3">
                                                <label className="popup-inner-title m-0">{t("VehicleTypeReducedMobility")}</label>
                                                <div className="custom-dropdown modal-dropdown mb-3" style={{ position: "relative" }}>
                                                    <CustomSearchableDropdown
                                                        items={guestAccessibleOptions}
                                                        value={selectedGuestAccessibleType?.Id ?? 0}
                                                        labelKey="Name"
                                                        valueKey="Id"
                                                        searchable={false}
                                                        placeholder={`${t("VehicleTypeReducedMobility")}`}
                                                        disabled={!guestAccessibleOptions.length}
                                                        onChange={(value) => {
                                                            const accessibleType = guestAccessibleOptions.find((item) => String(item.Id) === String(value)) || null;
                                                            setSelectedGuestAccessibleType(accessibleType);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {GuestShareableTypes.length > 0 && (
                                            <div className="form-row mb-3">
                                                <label className="popup-inner-title m-0">{t("label_shareable_category")}</label>
                                                <div className="custom-dropdown modal-dropdown mb-3" style={{ position: "relative" }}>
                                                    <CustomSearchableDropdown
                                                        items={guestShareableOptions}
                                                        value={selectedGuestShareableType?.Id ?? 0}
                                                        labelKey="Name"
                                                        valueKey="Id"
                                                        searchable={false}
                                                        placeholder={`${t("label_shareable_category")}`}
                                                        disabled={!guestShareableOptions.length}
                                                        onChange={(value) => {
                                                            const shareableType = guestShareableOptions.find((item) => String(item.Id) === String(value)) || null;
                                                            setSelectedGuestShareableType(shareableType);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </form>
                                <div className="tags-btn mt-4">
                                    <button
                                        type="submit"
                                        className="w-100 min-height-56 selected"
                                        onClick={async (e) => {
                                            e.preventDefault();
                                            const isValid = validateGuestFields(
                                                {
                                                    name: guestName,
                                                    surname: guestLastName,
                                                    email: guestEmail
                                                },
                                                "fullDay"
                                            );

                                            if (!isValid) {
                                                return;
                                            }
                                             onClose()
                                            if (!pendingGuestBooking) return;

                                            await executeRandomSpaceBooking(
                                                pendingGuestBooking.zoneId,
                                                pendingGuestBooking.bookingDateStr,
                                                selectedGuestVehicleType?.Id ?? pendingGuestBooking.VehicleTypeId,
                                                selectedGuestFuelType?.Id ?? pendingGuestBooking.fuelId,
                                                selectedGuestShareableType?.Id ?? pendingGuestBooking.vehicleShareableId,
                                                selectedGuestAccessibleType?.Id ?? pendingGuestBooking.vehicleAccessibleId,
                                                pendingGuestBooking.vehicleRegistrationId,
                                                pendingGuestBooking.isGuestFlag,
                                                {
                                                    guestName: guestName,
                                                    guestLastName: guestLastName,
                                                    guestEmail: guestEmail,
                                                    guestIdentification: identificatoin,
                                                    guestVehicleNumber: selectedGuestVehicleNumber,
                                                    spotName: pendingGuestBooking.spotName,
                                                    startTime: pendingGuestBooking.startTime,
                                                    endTime: pendingGuestBooking.endTime
                                                }
                                            );

                                            resetForm();
                                        }}
                                    >
                                        {t("confirm")}
                                    </button>
                                </div>

                                <div >
                                    <button
                                    type='button'
                                    className="main-btn outline-gray-btn w-100 mw-100 min-height-56 mt-3"
                                        onClick={() => {
                                            setshowGuestPopupFullday(false);
                                            setGuestErrors((prev) => ({
                                                ...prev,
                                                fullDay: {
                                                    firstname: "",
                                                    lastname: "",
                                                    email: ""
                                                }
                                            }));
                                        }}

                                    >
                                        {t("cancel")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* </form> */}
            </div>
        )
    }

    // const history = useHistory();

    function GotoMapClick(zoneId, bookingDateStr) {
        console.log("GotoMapClick clicked");

        if (mapAvailableType === 2 || mapAvailableType === 3) {

            history.push("/map", {
                selectedZoneId: zoneId,
                selectedDate: bookingDateStr
            });

        } else {
            history.push("/no-map-available", { zoneId });
        }
    }

    // function GotoMapClick(zoneId, bookingDateStr) {
    //     console.log("GotoMapClick() clicked", mapAvailableType);
    // //     if (mapAvailableType === 2) {
    // //         window.location.href = `/map?zoneId=${encodeURIComponent(zoneId)}&bookingDate=${encodeURIComponent(bookingDateStr)}`;
    // //     } else if (mapAvailableType === 3) {
    // //         window.location.href = `/map?zoneId=${encodeURIComponent(zoneId)}&bookingDate=${encodeURIComponent(bookingDateStr)}`;
    // //     } else {
    // //         window.location.href = `/no-map-available?zoneId=${zoneId}`;
    // //     }
    // // }
    //    if (mapAvailableType === 2 || mapAvailableType === 3) {
    //     navigate(`/map?zoneId=${zoneId}&bookingDate=${bookingDateStr}`);
    // } else {
    //     navigate("/no-map-available", {
    //         state: { zoneId }
    //     });
    // }
    // }
    //   function GotoMapClick(zoneId, bookingDateStr) {
    //     if (mapAvailableType === 2 || mapAvailableType === 3) {
    //       navigate("/mapcanvas", {
    //         state: {
    //           zoneId,
    //           bookingDate: bookingDateStr
    //         }
    //       });
    //     } else {
    //       navigate("/no-map-available", {
    //         state: { zoneId }
    //       });
    //     }
    //   }

    const Calendar_APIforBooking = useCallback(
        async (bookingDateStr, zoneId, SpotId) => {
            try {
                console.log("Calendar_APIforBooking()", zoneId, "=zoneId", bookingDateStr, "=bookingDateStr", SpotId, "=SpotId");

                await performCalendarApiCall(bookingDateStr, zoneId, SpotId);
                console.log("Calendar refreshed successfully.");
            } catch (err) {
                console.error("Error refreshing calendar:", err);
            }
        },
        [performCalendarApiCall]
    );

    const pullBookingStatus = async (reqParams, bookingDateStr, requestZoneId = reqParams?.ZoneId) => {

        const maxAttempts = 3;

        for (let attempt = 1; attempt <= maxAttempts; attempt++) {

            try {

                const response = await BookingStatus_api(reqParams);
                const result = handleResponseCode(response);
                // handleApiResponsemap(response, setNotification, t, {
                //                 successMsg: 0,
                //                 errorMsg: 1
                //             });
                handleApiUiResponse(response, {
                    successToaster: 0,
                    errorToaster: 1,
                    alertPopup: 1,
                    onConfirmByCode: {
                        603: async () => {
                            if (activeZoneIdRef.current === requestZoneId) {
                                await fetchBookings(requestZoneId, formatDate(bookingDateStr));
                            }
                        },

                        602: async () => {
                            if (activeZoneIdRef.current === requestZoneId) {
                                await fetchBookings(requestZoneId, formatDate(bookingDateStr));
                            }
                        },
                        606: async () => { await Calendar_Logic(); },
                    },
                });

                const records = response?.Data?.Records || {};
                const spotId = records?.SpotId ?? null;
                const isPastBooking = records?.IsPastBooking ?? 0;
                const errorCode = response?.Data?.ResponseCode;
                // // handleApiResponse(response, setNotification, t, {
                // //     successMsg: 1,
                // //     errorMsg: 1
                // // }); 

                if (errorCode === 423) {
                    localStorage.clear();
                    sessionStorage.clear();
                    history.push("/Login", { replace: true });
                    return { stopFetch: true };
                }

                // if (result.code === 416 || result.code === 427 || result.code === 605) {
                //     return { stopFetch: true };
                // }

                if (errorCode !== 200 && errorCode !== 1555) {
                    return { stopFetch: true };
                }

                if (toSafeFloat(spotId) === -1) {
                    return { stopFetch: false };
                }

                    if (toSafeFloat(spotId) > 0) {
                    let refreshedCalendarData = null;
                    if (activeZoneIdRef.current === requestZoneId) {
                        refreshedCalendarData = await fetchBookings(requestZoneId, formatDate(bookingDateStr));
                        openGuestBookingConfirmation(refreshedCalendarData, reqParams);
                    }
                    if (isPastBooking === 1) {
                        const res = await PostBookingQuestion_api({
                            ZoneId: reqParams.ZoneId
                        });

                        if (res?.Data?.ResponseCode === 200) {
                            const questions =
                                res?.Data?.Records?.QuestionAnswerList || [];
                            //console.log("questions from pullbookingstatus", questions)
                            setPostRequestParams({
                                ZoneId: requestZoneId,
                                ClaimDate: getBookingDateStr(bookingDateStr),
                                StartTime: "",
                                EndTime: "",
                                SpotId: spotId,
                                ClaimId: response?.Data?.Records?.LastId_tblparkingrelease,
                                CompanyId: res?.Data?.Records?.CompanyId,
                                IsGuest: activeGuestFlag,
                            });
                            setPostbookingQueModalData(questions);

                            //setShowAlldayPostEventModal(false);

                            setShowPostbookingQueModal(true);  // ✅ OPEN MODAL HERE

                            return { stopFetch: true };
                        }

                    }

                    return { stopFetch: true };
                }

                if (attempt < maxAttempts) {
                    await new Promise(res => setTimeout(res, 3000));
                }

            } catch (error) {
                console.error("BookingStatus_api error:", error);
            }
        }

        return { stopFetch: false };
    };

    const executeRandomSpaceBooking = async (
        zoneId,
        bookingDateStr,
        VehicleTypeId,
        fuelId,
        vehicleShareableId,
        vehicleAccessibleId,
        vehicleRegistrationId,
        isGuestFlag,
        guestData = null
    ) => {
        const requestZoneId = zoneId;
        console.log("Parameters for MakeBooking_api()", zoneId, bookingDateStr, isGuestFlag,
            VehicleTypeId,
            fuelId,
            vehicleShareableId,
            vehicleAccessibleId,
            vehicleRegistrationId);
        try {
            setLoadingDates((prev) => (prev.includes(bookingDateStr) ? prev : [...prev, bookingDateStr]));
            console.log(setLoadingDates, "GETRANDOMSPACE()loadingDates");

            // Pass vehicle details to MakeBooking_API
            const response = await MakeBooking_API(
                zoneId,
                bookingDateStr,
                VehicleTypeId,
                fuelId,
                vehicleShareableId,
                vehicleAccessibleId,
                vehicleRegistrationId,
                selectedTeamMember,
                isGuestFlag,
                guestData,
                serializeFiltersForApi(filters).TagsFilter
            );
            console.log("MakeBooking_api())", response);
            // handleApiResponsemap(response, setNotification, t, {
            //                 successMsg: 1,
            //                 errorMsg: 1
            //             });
            handleApiUiResponse(response, {
                successToaster: 0,
                errorToaster: 1,
                alertPopup: 1
            });

            if (response && response.Data?.ResponseCode === 200) {

                const bookingStatusreqParams = {
                    ZoneId: zoneId,
                    BookingQueueId: response?.Data?.Records?.BookingQueueId,
                    IsGuest: isGuestFlag,

                    // FROM SELECTED VEHICLE
                    VehicleTypeId: VehicleTypeId ? VehicleTypeId : 0,
                    VehicleFuelId: fuelId ? fuelId : 0,
                    VehicleShareableId: vehicleShareableId ? vehicleShareableId : 0,
                    VehicleAccessibleId: vehicleAccessibleId ? vehicleAccessibleId : 0,
                    TeamMemberGuId: selectedTeamMember ? selectedTeamMember : 0,
                    BookingDateStr: bookingDateStr,
                    SpotName: guestData?.spotName || "",
                    BookingStartTime: guestData?.startTime || "",
                    BookingEndTime: guestData?.endTime || "",
                    GuestFirstName: guestData?.guestName || guestData?.guestName30mit || "",
                    GuestLastName: guestData?.guestLastName || guestData?.guestLastName30mit || ""
                    //CarRegistrationNumber:vehicleRegistrationId ? vehicleRegistrationId : 0
                };
                console.log(fuelId)
                const statusResult = await pullBookingStatus(bookingStatusreqParams, bookingDateStr, requestZoneId);
                console.log("statusResult from getrandomspace", statusResult);

                if (!statusResult?.stopFetch && activeZoneIdRef.current === requestZoneId) {
                    await fetchBookings(zoneId, formatDate(selectedDate));
                }

                // await new Promise((resolve) => setTimeout(resolve, timeOutTime));

                /*
                // Duplicate Calendar_api refresh for Get Random Space.
                // Kept commented for reference because fetchBookings(...) now
                // refreshes weekData, recordsData, checkInCheckOutRecords,
                // calendarRenderKey, and selected member credit in one call.
                const bookingDate = new Date(bookingDateStr);
                const dayOfWeek = bookingDate.getDay();
                const diff = bookingDate.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
                const mondayOfWeek = new Date(bookingDate.setDate(diff));
                const weekKey = `${mondayOfWeek.getFullYear()}-${mondayOfWeek.getMonth()}-${mondayOfWeek.getDate()}`;

                setLoadingWeeks((prev) => ({ ...prev, [weekKey]: true }));
                try {
                    const year = bookingDate.getFullYear();
                    const month = String(bookingDate.getMonth() + 1).padStart(2, '0');
                    const day = String(bookingDate.getDate()).padStart(2, '0');
                    const formattedDate = `${year}-${month}-${day}`;
                    const fetchResponse = await fetchWithTokenRefresh2(BASE_URL + Calendar_api, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            ZoneId: zoneId,
                            GuId: getGuId(),
                            BookingStartDate: formattedDate,
                            Month: month,
                            Year: year,
                            TeamMemberGuId: selectedTeamMember,
                            FilterStartTime: '',
                            DeviceId: DeviceId,
                            OsVersion: OsVersion,
                            TagsFilter: '',
                            ManufactureModel: ManufactureModel,
                            IsGuest: activeGuestFlag,
                            FuelFilter: '',
                            AppVersion: App_version,
                            ShareableFilter: '',
                            Language: AppConstant.Language,
                            FilterEndTime: '',
                            VehicleTypeFilter: '',
                            IsFromAppHome: 0,
                            AccessibleFilter: '',
                            FacilityFilter: '',
                            LogScreenName: "",
                            LogActionType: "",
                            LogPopup: ""
                        }),
                    });
                    const data = await fetchResponse.json();
                    const updatedCredit = getUpdatedCreditForSelectedMember(data?.Data?.Records);
                    setCreditBalance(updatedCredit)
                    if (data?.Data?.Records?.Schedule) {
                        setWeekData((prev) => ({ ...prev, [weekKey]: data.Data.Records.Schedule }));
                        setCreditBalance(updatedCredit);
                        setTeamMemberList((prevList) =>
                            prevList.map((member) =>
                                member.GuId === selectedTeamMember
                                    ? { ...member, Credit: updatedCredit }
                                    : member
                            )
                        );
                    } else {
                        setWeekData((prev) => ({ ...prev, [weekKey]: [] }));
                        setCreditBalance(updatedCredit);
                        setTeamMemberList((prevList) =>
                            prevList.map((member) =>
                                member.GuId === selectedTeamMember
                                    ? { ...member, Credit: updatedCredit }
                                    : member
                            )
                        );
                    }
                    setCalendarRenderKey((prev) => prev + 1);
                } catch (refreshError) {
                    setWeekData((prev) => ({ ...prev, [weekKey]: [] }));
                } finally {
                    setLoadingWeeks((prev) => ({ ...prev, [weekKey]: false }));
                    setShowBookingProcess(false)
                }
                */
                setShowBookingProcess(false)

            } else {
                console.error("Booking failed:", response?.Data?.ResponseMessage);
            }
        } catch (error) {
            console.error("Error calling GetRandomSpace:", error);
        } finally {
            setLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
        }
    };

    const GetRandomSpace = async (
        zoneId,
        bookingDateStr,
        VehicleTypeId,
        fuelId,
        vehicleShareableId,
        vehicleAccessibleId,
        vehicleRegistrationId,
        isGuestFlag = 0
    ) => {
        setCheckedPreBookingQue(false);

        if (isGuestFlag === 1) {
            const bookingForDate = getBookingForDate(bookingDateStr);

            setPendingGuestBooking({
                zoneId,
                bookingDateStr,
                VehicleTypeId,
                fuelId,
                vehicleShareableId,
                vehicleAccessibleId,
                vehicleRegistrationId,
                isGuestFlag,
                spotName: bookingForDate?.SpotName || bookingForDate?.Schedules?.[0]?.SpotName || "",
                startTime: bookingForDate?.BookingStartTime || bookingForDate?.StartTime || "",
                endTime: bookingForDate?.BookingEndTime || bookingForDate?.EndTime || "",
            });

            if (bookingForDate?.HourlySpotAvailable === 1) {
                setShowGuestPopup30mit(true);
            } else {
                setshowGuestPopupFullday(true);
            }
            return;
        }

        await executeRandomSpaceBooking(
            zoneId,
            bookingDateStr,
            VehicleTypeId,
            fuelId,
            vehicleShareableId,
            vehicleAccessibleId,
            vehicleRegistrationId,
            isGuestFlag
        );
    };

    const CancelBooking = async (zoneId, bookingDateStr, cancelBookingSpotId) => {
        console.log(
            `Cancel Booking Clicked: ZoneId=${zoneId}, BookingDate=${bookingDateStr}, SpotId=${cancelBookingSpotId}`
        );
        try {
            // setLoadingDates((prev) => [...prev, bookingDateStr]);
            setIsLoading(true);
            const response = await CancelBooking_API(zoneId, bookingDateStr, cancelBookingSpotId, selectedTeamMember, activeGuestFlag);
            console.log("CancelBooking_api response:", response);
            //   handleApiResponse(response, setNotification, t, {
            //                         successMsg: 0,
            //                         errorMsg: 1,
            //                     });

            handleApiUiResponse(response, {
                successToaster: 0,
                errorToaster: 1,
                alertPopup: 1,
                     onConfirmByCode: {
                        607: async () => {
                            await Calendar_Logic();
                        },
                    }
            });

            // if (response && response.Data?.ResponseCode === 200) {
            //     await new Promise((resolve) => setTimeout(resolve, timeOutTime));

            //     await Calendar_APIforBooking(bookingDateStr, zoneId);
            // }
            if (response && response.Data?.ResponseCode === 200) {
                // await new Promise((resolve) => setTimeout(resolve, timeOutTime));
                // handleApiResponse(response, setNotification, t, {
                //                     successMsg: 0,
                //                     errorMsg: 1
                //                 });
                handleApiUiResponse(response, {
                    successToaster: 0,
                    errorToaster: 1,
                    alertPopup: 1,
                     onConfirmByCode: {
                        607: async () => {
                            await Calendar_Logic();
                        },
                    }
                });

                // --- Refresh the week data for the week containing bookingDateStr ---
                const bookingDate = getSafeDisplayDate(bookingDateStr);
                if (!bookingDate) {
                    console.error("Invalid booking date during cancel refresh:", bookingDateStr);
                    return;
                }
                const dayOfWeek = bookingDate.getDay();
                const diff = bookingDate.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
                const mondayOfWeek = new Date(bookingDate);
                mondayOfWeek.setDate(diff);
                const weekKey = `${mondayOfWeek.getFullYear()}-${mondayOfWeek.getMonth()}-${mondayOfWeek.getDate()}`;

                setLoadingWeeks((prev) => ({ ...prev, [weekKey]: true }));
                try {
                    const year = bookingDate.getFullYear();
                    const month = String(bookingDate.getMonth() + 1).padStart(2, '0');
                    const day = String(bookingDate.getDate()).padStart(2, '0');
                    const formattedDate = `${year}-${month}-${day}`;

                    const fetchResponse = await fetchWithTokenRefresh2(BASE_URL + Calendar_api, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            ZoneId: zoneId,
                            GuId: getGuId(),
                            BookingStartDate: formattedDate,
                            Month: month,
                            Year: year,
                            TeamMemberGuId: selectedTeamMember,
                            FilterStartTime: '',
                            DeviceId: DeviceId,
                            OsVersion: OsVersion,
                            TagsFilter: '',
                            ManufactureModel: ManufactureModel,
                            IsGuest: activeGuestFlag,
                            FuelFilter: '',
                            AppVersion: App_version,
                            ShareableFilter: '',
                            Language: AppConstant.Language,
                            FilterEndTime: '',
                            VehicleTypeFilter: '',
                            IsFromAppHome: 0,
                            AccessibleFilter: '',
                            FacilityFilter: '',
                            LogScreenName: "",
                            LogActionType: "",
                            LogPopup: ""
                        }),
                    });
                    const data = await fetchResponse.json();
                    const refreshedRecords = data?.Data?.Records || {};
                    const updatedCredit = getUpdatedCreditForSelectedMember(data?.Data?.Records);
                    setRecordsData(refreshedRecords);
                    setCheckInCheckOutRecords(refreshedRecords?.CurrentDayBookingRecords ?? []);
                    setCreditBalance(updatedCredit)
                    if (data?.Data?.Records?.Schedule) {
                        setWeekData((prev) => ({ ...prev, [weekKey]: data.Data.Records.Schedule }));
                        setCreditBalance(updatedCredit);
                        setTeamMemberList((prevList) =>
                            prevList.map((member) =>
                                member.GuId === selectedTeamMember
                                    ? { ...member, Credit: updatedCredit }
                                    : member
                            )
                        );
                    } else {
                        setWeekData((prev) => ({ ...prev, [weekKey]: [] }));
                    }
                    setCalendarRenderKey((prev) => prev + 1);
                } catch (refreshError) {
                    setWeekData((prev) => ({ ...prev, [weekKey]: [] }));
                } finally {
                    // setLoadingWeeks((prev) => ({ ...prev, [weekKey]: false }));
                    setShowBookingProcess(false)
                    setIsLoading(false);
                }
                // --- End refresh logic ---
            } else {
                console.error("Cancel booking failed:", response?.Data?.ResponseMessage);
            }
        } catch (error) {
            console.error("Error calling CancelBooking_api:", error);
        } finally {
            setLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
        }
    }

    const CheckInOutSingleBtn = async (zoneId, bookingDateStr, cancelBookingSpotId, checkInFlag) => {
        console.log(
            `Cancel Booking Clicked: ZoneId=${zoneId}, BookingDate=${bookingDateStr}, SpotId=${cancelBookingSpotId}, CheckInFlag=${checkInFlag}`
        );
        try {
            //setLoadingDates((prev) => [...prev, bookingDateStr]);
            const response = await CheckInOutsingleBtn(zoneId, bookingDateStr, cancelBookingSpotId, checkInFlag);
             handleApiUiResponse(response, {
                successToaster: 0,
                errorToaster: 0,
                alertPopup: 1,
                onConfirmByCode: {
                    449: async () => {
                        await Calendar_Logic();;
                    }
                }
            });
            console.log("CheckInUser_api response:", response);

            if (response && response.Data?.ResponseCode === 200) {
                await new Promise((resolve) => setTimeout(resolve, timeOutTime));

                //await Calendar_APIforBooking(bookingDateStr, zoneId);
                //await fetchBookings(zoneId, formatDate(bookingDateStr));
            } else {
                console.error("Cancel booking failed:", response?.Data?.ResponseMessage);
            }
        } catch (error) {
            console.error("Error calling CancelBooking_api:", error);
        } finally {
            setLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
        }
    }

    const CheckInOutAPI = async (zoneId, bookingDateStr, cancelBookingSpotId, checkInFlag) => {
        console.log(
            `Cancel Booking Clicked: ZoneId=${zoneId}, BookingDate=${bookingDateStr}, SpotId=${cancelBookingSpotId}, CheckInFlag=${checkInFlag}`
        );
        try {
            //setLoadingDates((prev) => [...prev, bookingDateStr]);
            const response = await CheckInUser_API(zoneId, bookingDateStr, cancelBookingSpotId, checkInFlag);
            console.log("CheckInUser_api response:", response);
            handleApiUiResponse(response, {
                successToaster: 0,
                errorToaster: 0,
                alertPopup: 1,
                onConfirmByCode: {
                    449: async () => {
                        await Calendar_Logic();;
                    }
                }
            });
            if (response && response.Data?.ResponseCode === 200) {
                await new Promise((resolve) => setTimeout(resolve, timeOutTime));

                //await Calendar_APIforBooking(bookingDateStr, zoneId);
                //await fetchBookings(zoneId, formatDate(bookingDateStr));
            } else {
                console.error("Cancel booking failed:", response?.Data?.ResponseMessage);
            }
        } catch (error) {
            console.error("Error calling CancelBooking_api:", error);
        } finally {
            setLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
        }
    }

    const CheckOutAPI = async (zoneId, bookingDateStr, cancelBookingSpotId, checkInFlag) => {
        console.log(
            `Cancel Booking Clicked: ZoneId=${zoneId}, BookingDate=${bookingDateStr}, SpotId=${cancelBookingSpotId}, CheckInFlag=${checkInFlag}`
        );
        try {
            //setLoadingDates((prev) => [...prev, bookingDateStr]);
            const response = await CheckOutUser_API(zoneId, bookingDateStr, cancelBookingSpotId, checkInFlag);
            console.log("CheckOutUser_api response:", response);

            if (response && response.Data?.ResponseCode === 200) {
                await new Promise((resolve) => setTimeout(resolve, timeOutTime));

                //await Calendar_APIforBooking(bookingDateStr, zoneId);
                //await fetchBookings(zoneId, formatDate(bookingDateStr));
            } else {
                console.error("Cancel booking failed:", response?.Data?.ResponseMessage);
            }
        } catch (error) {
            console.error("Error calling CancelBooking_api:", error);
        } finally {
            setLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
        }
    }

    

    async function ParkingViolationReporting(zoneId, plateNoStr, spotIdStr, spotNameStr, bookingPeriodStr, bookingDateStr) {
        try {
            if (isLoading) return;
            setIsLoading(true);
            setLoadingDates((prev) => [...prev, bookingDateStr]);

            const spotViolationTypeStr = bookingPeriodStr === 2 ? 1 : 0;
            const reqParams = {
                ZoneId: zoneId,
                PlateNo: plateNoStr,
                SpotViolationType: "spotViolationTypeStr",
                SpotId: spotIdStr,
                SpotName: spotNameStr,
                Tags: "0",
            };

            const response = await ReportParkingViolation_api(reqParams);

            if (response && response.Data?.ResponseCode === 200) {
                setParkingViolationReportingData(response.Data);
                setShowReportParkingViolationModal(false);
                setShowAlternateParkingSpotModal(true);
            } else {
                console.error("ReportParkingViolation_api failed:", response?.Data?.ResponseMessage);
            }
        } catch (error) {
            console.error("Error calling ReportParkingViolation_api:", error);
        } finally {
            setLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
            setIsLoading(false);
        }
    }

    async function AlternateParkingSpotBooking(zoneId, bookingDateStr) {
        if (!parkingViolationReportingData) return;

        try {
            setIsLoading(true);
            setLoadingDates((prev) => [...prev, bookingDateStr]);

            const reqParams = {
                ViolatedSpotId: parkingViolationReportingData?.Records?.ViolatedSpotId,
                SpotId: parkingViolationReportingData?.Records?.SpotId,
                ZoneId: zoneId,
                Tags: "0",
                BookingId: parkingViolationReportingData?.Records?.BookingId,
                StartTime: parkingViolationReportingData?.Records?.StartTime,
                EndTime: parkingViolationReportingData?.Records?.EndTime,
                NewBookingPeriod: parkingViolationReportingData?.Records?.NewBookingPeriod,
            };

            const response = await GetAlternateParkingSpot_api(reqParams);
            // handleApiResponse(response, setNotification, t, {
            //     successMsg: 1,
            //     errorMsg: 1
            // });
            handleApiUiResponse(response, {
                successToaster: 1,
                errorToaster: 1,
                alertPopup: 1
            });

            if (response && response.Data?.ResponseCode === 200) {
                await fetchBookings(zoneId, formatDate(selectedDate));
                setShowAlternateParkingSpotModal(false);
                setParkingViolationReportingData(null);
            } else {
                console.error("GetAlternateParkingSpot_api failed:", response?.Data?.ResponseMessage);
            }
        } catch (error) {
            console.error("Error calling GetAlternateParkingSpot_api:", error);
        } finally {
            setLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
            setIsLoading(false);
        }
    }

    const ScheduleMeetingModal = ({ onClose }) => {
        const handleSubmit = () => {
            console.log("Meeting scheduled!");
            onClose(); // Close the popup after submission
        };

        return (
            <div className="modal newmeetingpopup" style={{ display: 'block', backgroundColor: 'rgba(232, 232, 232, 0.)' }}>
                <div className="modal-dialog modal-dialog-centered modal-custom-width">
                    <div className="modal-content modal-radius">
                        <div className="modal-body">
                            <div className="close-modal">
                                <a onClick={onClose}>
                                    <img src={Close} aria-label="Close" />
                                </a>
                            </div>
                            <div className="pt-4">
                                <h5 className="popup-title">{t("react_schedule_meeting")}</h5>
                            </div>
                            {/* <div className="divider-line mt-3"></div>
                            <div className="form-group">
                                <label htmlFor="meetingTitle">Meeting Title</label>
                                <input
                                    type="text"
                                    id="meetingTitle"
                                    className="form-control"
                                    placeholder="Enter meeting title"
                                />
                            </div>
                            <div className="form-group mt-3">
                                <label htmlFor="meetingDate">Meeting Date</label>
                                <input
                                    type="date"
                                    id="meetingDate"
                                    className="form-control"
                                />
                            </div>
                            <div className="mt-4">
                                <button
                                    className="main-btn outline-green-btn w-100"
                                    onClick={handleSubmit}
                                >
                                    Confirm Meeting
                                </button>
                            </div> */}
                            {/* <div className="modal-des"> */}
                            <form>
                                <div className="form-row">
                                    <label className="popup-inner-title m-0" for="datepicker-calender"> {t("date_time")} </label>
                                    <div className="booking-date"><input type="" id="datepicker-calender" autocomplete="off" /></div>
                                </div>
                                <div className="form-row">
                                    <label className="popup-inner-title m-0" for=""> {t("spot")} </label>
                                    <input type="text" className="form-control" autocomplete="off" placeholder="Galway room" />
                                </div>
                                <div className="form-row">
                                    <label className="popup-inner-title m-0" for="time-slot"> {t("react_preview_time_slot")}</label>
                                    <div id="timegridview"></div>
                                </div>
                                {/* <div className="form-row">
                                                                <label className="popup-inner-title m-0">Add employee</label>
                                                                <div className="custom-dropdown green-icon-drop-down mb-3">
                                                                    <select className="ctm-select">
                                                                        <option selected>Open this select menu</option>
                                                                        <option value="1">Option One</option>
                                                                        <option value="2">Option Two</option>
                                                                        <option value="3">Option Three</option>
                                                                        <option value="4">Option Four</option>
                                                                    </select>
                                                                </div>
                                                            </div> */}
                                <div className="modal-btn my-4">
                                    <a href="#" className="main-btn outline-green-btn">
                                        <span><img src={PlusButton} alt="plus" /></span>
                                        {t("react_add_external_guest")}
                                    </a>
                                </div>
                                <div className="form-row">
                                    <label className="popup-inner-title m-0" for="name"> {t("name")} </label>
                                    <input type="text" className="form-control" autocomplete="off" placeholder="Name" />
                                </div>
                                <div className="form-row">
                                    <label className="popup-inner-title m-0" for="surname"> {t("react_last_name")} </label>
                                    <input type="text" className="form-control" autocomplete="off" placeholder="Surname" />
                                </div>
                                <div className="form-row">
                                    <label className="popup-inner-title m-0" for="email"> {t("sender_email")} </label>
                                    <input type="text" className="form-control" autocomplete="off" placeholder="info@" />
                                    {/* <img src="assets/images/icons/modal-email.svg" className="form-icon" /> */}
                                </div>
                                {/* <div className="modal-btn">
                                                                <a href="#" className="main-btn outline-green-btn">
                                                                     
                                                                     Confirm EXTERNAL GUEST Button
                                                                     </a>
                                                            </div> */}
                                <div className="form-row participants-list">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                                        <label className="form-check-label" for="inlineCheckbox1">Andrea Martinez (andi234556@gmail.com)</label>
                                        <a href="#"><img src={Deleteicon} className="img-fluid" atl="delete" /></a>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2" />
                                        <label className="form-check-label" for="inlineCheckbox2">Name Surname (namesurname@gmail.com)</label>
                                        <a href="#"><img src={Deleteicon} className="img-fluid" atl="delete" /></a>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    // var meetingModalDate = selectedBookingDate
    var selectedZoneId = selectedCalendarZoneId


    const fetchBookings = async (zoneIdParam, bookingDateStr) => {

        console.log("fetchBookings called with:", { zoneIdParam, bookingDateStr });
        // setIsLoading(true);
        const zoneId = zoneIdParam;
        if (!bookingDateStr) return;

        const bookingDate = getSafeDisplayDate(bookingDateStr);
        if (!bookingDate) {
            console.error("Invalid booking date passed to fetchBookings:", bookingDateStr);
            return;
        }
        const dayOfWeek = bookingDate.getDay();
        const diff = bookingDate.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
        const mondayOfWeek = new Date(bookingDate);
        mondayOfWeek.setDate(diff);
        const weekKey = `${mondayOfWeek.getFullYear()}-${mondayOfWeek.getMonth()}-${mondayOfWeek.getDate()}`;


        // const bookingDate = new Date(bookingDateStr);
        //         const dayOfWeek = bookingDate.getDay();
        //         const diff = bookingDate.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
        //         const mondayOfWeek = new Date(bookingDate.setDate(diff));
        //         const weekKey = `${mondayOfWeek.getFullYear()}-${mondayOfWeek.getMonth()}-${mondayOfWeek.getDate()}`;
        setLoadingWeeks((prev) => ({ ...prev, [weekKey]: true }));
        try {
            // setLoadingDates((prev) => [...prev, bookingDateStr]);
            // const reqParams = {
            //     BookingStartDate: bookingDate,
            //     ZoneId: zoneId,
            // };

            const year = bookingDate.getFullYear();
            const month = String(bookingDate.getMonth() + 1).padStart(2, '0');
            const day = String(bookingDate.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;

            console.log("Formatted Date:", formattedDate);

            const response = await fetchWithTokenRefresh2(BASE_URL + Calendar_api, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    ZoneId: zoneId,
                    GuId: getGuId(),
                    BookingStartDate: formattedDate,
                    Month: month,
                    Year: year,
                    TeamMemberGuId: selectedTeamMember,
                    FilterStartTime: '',
                    DeviceId: DeviceId,
                    OsVersion: OsVersion,
                    TagsFilter: '',
                    ManufactureModel: ManufactureModel,
                    IsGuest: activeGuestFlag,
                    FuelFilter: '',
                    AppVersion: App_version,
                    ShareableFilter: '',
                    Language: AppConstant.Language,
                    FilterEndTime: '',
                    VehicleTypeFilter: '',
                    IsFromAppHome: 0,
                    AccessibleFilter: '',
                    FacilityFilter: '',
                    LogScreenName: "",
                    LogActionType: "",
                    LogPopup: ""
                }),
            });;
            const data = await response.json();
            const shouldApplyToActiveZone = activeZoneIdRef.current === zoneId;
            const refreshedRecords = data?.Data?.Records || {};
            const updatedCredit = getUpdatedCreditForSelectedMember(refreshedRecords);

            if (!shouldApplyToActiveZone) {
                return data;
            }

            setRecordsData(refreshedRecords);
            setCheckInCheckOutRecords(refreshedRecords?.CurrentDayBookingRecords ?? []);
            setCreditBalance(updatedCredit);
            setTeamMemberList((prevList) =>
                prevList.map((member) =>
                    member.GuId === selectedTeamMember
                        ? { ...member, Credit: updatedCredit }
                        : member
                )
            );

            if (data?.Data?.Records?.Schedule) {
                setWeekData((prev) => ({ ...prev, [weekKey]: data.Data.Records.Schedule }));
            } else {
                setWeekData((prev) => ({ ...prev, [weekKey]: [] }));
            }
            setCalendarRenderKey((prev) => prev + 1);
            return data;
        } catch (refreshError) {
            if (activeZoneIdRef.current === zoneId) {
                setWeekData((prev) => ({ ...prev, [weekKey]: [] }));
            }
            return null;
        } finally {
            setIsLoading(false);
            setLoadingWeeks((prev) => ({ ...prev, [weekKey]: false }));
        }
    };

    const isFilterApplied = (zoneId) => {
        const stored = sessionStorage.getItem(`mapFilters_${zoneId}`);
        if (!stored) return false;

        const filters = JSON.parse(stored);

        return Object.values(filters).some((val) => {
            if (Array.isArray(val)) {
                return val.length > 0;
            }

            return val !== "" && val !== null && val !== undefined;
        });
    };

    // If you have zoneMap, define or fetch it here
    const zoneMap = {};
    {/* New Meeting Modal (add this where you want the modal to render, e.g. at the bottom of your component's return) */ }
    const headerTitle = t("react_hi").replace("%s", UserFirstName || (sessionStorage.getItem("firstname")));
    console.log("ZoneCreditValue:", zoneCreditValue);
    return (
        <div>
            <div className="content-area">
                <header className="header">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-2">
                                <div className="greeting-title">
                                    <p>{headerTitle}</p>
                                </div>
                            </div>
                            <div className="col-md-8">
                                <form action="" className="d-flex justify-content-center custom-inline-dropdown gap-3">
                                    {/* <div className="dropdown form-input-container d-flex justify-content-center flex-column header-dropdown">
                                        <button className="dropdown-toggle form-control position-relative custom-dropdown-btn" type="button" id="desk-dropdown-btn" data-bs-toggle="dropdown" aria-expanded="false" name="deskdropdown" required>
                                            <span>Desk</span>
                                        </button>
                                        <ul className="dropdown-menu custom-dropdown" aria-labelledby="desk-dropdown" id="desk-dropdown">
                                            <li className="selected"><a className="dropdown-item" href="javascript:void(0);">Meeting room</a></li>
                                            <li><a className="dropdown-item" href="javascript:void(0);">Desk</a></li>
                                            <li><a className="dropdown-item" href="javascript:void(0);">Parking</a></li>
                                            <li><a className="dropdown-item" href="javascript:void(0);">Assets</a></li>
                                        </ul>
                                    </div> */}
                                    {/* <div className="dropdown form-input-container d-flex justify-content-center flex-column"> */}

                                    {/* <div className="col-xl-9 offset-xl-3 col-lg-10 offset-lg-2"> */}
                                    <div className="filter-panel d-flex justify-content-end align-items-center gap-3">
                                        <div className="filter-options d-flex gap-3 w-100">
                                            {!isTagListDataEmpty == true &&
                                                <div className="filter-icon" onClick={() => setShowFilter(true)}>
                                                    {selectedCalendarZoneId && isFilterApplied(selectedCalendarZoneId) ? (
                                                        <img src={filterIconOrange} alt="Filter Applied" />
                                                    ) : (
                                                        <img src={filterIcon} alt="No Filter" />
                                                    )}
                                                </div>
                                            }
                                            {/* CommonFilter Modal for CalendarEvent */}
                                            {showFilter && recordsData?.TagListData && (
                                                <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                                                    id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                                                >
                                                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                                                        <div className="modal-content modal-radius">
                                                            <div>
                                                                <CommonFilter
                                                                    bookingDate={mainCurrentDate}
                                                                    tagListData={recordsData?.TagListData}
                                                                    selectedZone={zoneList?.find(z => z.Id === selectedCalendarZoneId)}
                                                                    onApply={(appliedFilters) => {
                                                                        setFilters(appliedFilters);

                                                                        // ⏳ Clear future cache trackers
                                                                        setWeekData({});
                                                                        setLoadingWeeks({});

                                                                        applyFilters(
                                                                            selectedCalendarZoneId,
                                                                            mainCurrentDate,
                                                                            selectedTeamMember,
                                                                            selectedTeamId,
                                                                            activeGuestFlag,
                                                                            appliedFilters
                                                                        );

                                                                        setShowFilter(false);
                                                                    }}
                                                                    onClose={() => setShowFilter(false)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}


                                            <div
                                                ref={rootRef}
                                                // className="custom-dropdown green-icon-drop-down header-dropdown"
                                                className="employee-list location-list"
                                                onClick={(e) => e.stopPropagation()}
                                                style={{ position: "relative", overflow: "visible", zIndex: 1 }}
                                                label="Zone"
                                            >
                                                <div
                                                    role="button"
                                                    onClick={toggle}
                                                    className="dropdown-toggle form-control position-relative custom-dropdown-btn ctm-select"
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                                        <p className='sub-dropdown-name'>{t("zone")}</p>
                                                        <span style={{ fontSize: "16px", fontWeight: "bold", color: "#1c988a" }}>
                                                            {zoneList?.find((z) => z.Id === selectedCalendarZoneId)?.ZoneName ||
                                                                `${t("select_a_zone")}`}
                                                        </span>
                                                    </div>
                                                    {/* <span>
                                                            {zoneList?.find((z) => z.Id === selectedCalendarZoneId)?.ZoneName ||
                                                                "-- Select a Zone --"}
                                                        </span> */}
                                                    {/* <span>{open ? "▴" : "▾"}</span> */}
                                                </div>

                                                {open && (
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            top: "calc(100% + 6px)",
                                                            left: "auto",
                                                            right: "auto",
                                                            zIndex: 10000,
                                                            background: "#fff",
                                                            border: "1px solid rgba(0,0,0,.08)",
                                                            borderRadius: 12,
                                                            boxShadow: "0 10px 30px rgba(0,0,0,.15)",
                                                            maxHeight: 300,
                                                            overflowY: "auto",
                                                            width: "100%"
                                                        }}
                                                    >
                                                        {zoneList?.length > 0 ? (
                                                            zoneList.map((zone) => (
                                                                <div
                                                                    key={zone.GuId}
                                                                    // onClick={() => onSelect(zone)}
                                                                    onClick={() => {
                                                                        onSelect(zone);
                                                                        setOpen(false);

                                                                        // try {
                                                                        //     setIsLoading(true);
                                                                        //     const { calendarData, error } = await FetchCalendarWithZone(
                                                                        //         zone.Id,
                                                                        //         filters,
                                                                        //         selectedTeamMember // 👈 PASS THE MEMBER ID HERE!
                                                                        //     );

                                                                        //     if (!error && calendarData?.Data?.ResponseCode === 200) {
                                                                        //         const rec = calendarData.Data.Records || {};
                                                                        //         setRecordsData(rec);
                                                                        //         setBookingSpotData(Array.isArray(rec.Schedule) ? rec.Schedule : []);
                                                                        //     }
                                                                        // } catch (err) {
                                                                        //     setBookingSpotData([]);
                                                                        // } finally {
                                                                        //     setIsLoading(false);
                                                                        // }
                                                                    }}
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: 8,
                                                                        padding: "8px 12px",
                                                                        cursor: "pointer",
                                                                        whiteSpace: "nowrap",
                                                                        fontFamily: "var(--font-roboto)",
                                                                        fontSize: "12px",
                                                                        fontWeight: "400",
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="radio"
                                                                        name="areadropdown"
                                                                        value={zone.Id}
                                                                        checked={selectedCalendarZoneId === zone.Id}
                                                                        readOnly
                                                                        style={{
                                                                            marginRight: 8,
                                                                            accentColor: selectedCalendarZoneId === zone.Id ? "#1c988a" : "initial"
                                                                        }}
                                                                    />
                                                                    <span
                                                                        style={{
                                                                            overflow: "hidden",
                                                                            textOverflow: "ellipsis",
                                                                        }}
                                                                    >
                                                                        {zone.ZoneName}
                                                                    </span>
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div style={{ padding: "8px 12px", color: "#9ca3af" }}>
                                                                {selectedZoneName}
                                                            </div>
                                                        )}

                                                    </div>
                                                )}
                                            </div>

                                            {(teamMemberList && teamMemberList.length > 0) ? (
                                                <div
                                                    ref={teamMemberDropdownRef}
                                                    className="employee-list "
                                                    style={{ position: "relative" }}
                                                >
                                                    <div
                                                        role="button"
                                                        onClick={() => setTeamMemberOpen(!teamMemberOpen)}
                                                        className="dropdown-toggle form-control position-relative custom-dropdown-btn ctm-select"
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        <div className="d-flex flex-column justify-content-center">
                                                            <p className="sub-dropdown-name">{t("react_book_for")}</p>
                                                            <span
                                                                style={{
                                                                    fontSize: "16px",
                                                                    fontWeight: "bold",
                                                                    color: "#1c988a",
                                                                }}
                                                            >
                                                                {(() => {
                                                                    if (activeGuestFlag === 1) return t("guest");

                                                                    const member = teamMemberList.find(m => m.GuId === selectedTeamMember);
                                                                    if (member) return member.FullName;


                                                                    return t("select");
                                                                })()}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {teamMemberOpen && (
                                                        <div
                                                            style={{
                                                                position: "absolute",
                                                                top: "calc(100% + 6px)",
                                                                left: 0,
                                                                width: "100%",
                                                                background: "#fff",
                                                                borderRadius: 12,
                                                                boxShadow: "0 10px 30px rgba(0,0,0,.15)",
                                                                maxHeight: 300,
                                                                overflowY: "auto",
                                                                zIndex: 9999,
                                                            }}
                                                        >
                                                            {teamMemberList.map(member => (
                                                                <div
                                                                    key={member.GuId}
                                                                    onClick={() => handleMemberSelectionInCalendar(member)}
                                                                    style={{
                                                                        padding: "8px 12px",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        cursor: "pointer",
                                                                        fontSize: "12px"
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="radio"
                                                                        checked={selectedTeamMember === member.GuId && selectedTeamId === null}
                                                                        readOnly
                                                                        style={{
                                                                            marginRight: 8,
                                                                            accentColor: "#1c988a",
                                                                        }}
                                                                    />
                                                                    <span>{member.FullName}</span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                    {/* </div> */}

                                    <div className="calendar-switcher justify-content-start w-auto">
                                        <input
                                            type="checkbox"
                                            // checked={!isMonthly}
                                            className="toggle"
                                            id="toggle"
                                            checked={true} readOnly
                                        // onChange={() => setIsMonthly(!isMonthly)}
                                        />
                                        <label htmlFor="toggle">
                                            <span
                                                // className={isMonthly ? "on" : ""}
                                                className='on'
                                                id="switch-to-month"
                                                onClick={() => setIsMonthly(true)}
                                            >
                                                {t("CalendarViewModeSwitcherMonthly")}
                                            </span>
                                            <span
                                                className="off"
                                                id="switch-to-week"
                                                onClick={() =>
                                                    history.push("/weekCalendar", {
                                                        selectedZoneId: selectedCalendarZoneId,
                                                    })
                                                }
                                            >
                                                {t("react_weekly_calendar")}
                                            </span>
                                        </label>
                                    </div>
                                </form>
                            </div>

                            <div className="col-md-2">
                                <div className="menu-bar-options d-flex justify-content-end gap-3">
                                    {zoneCreditValue !== 0 && activeGuestFlag == 0 && (
                                        <CreditInfoCard
                                            userZoneCreditValue={zoneCreditValue}
                                            userZoneCreditBalance={selectedMemberCredit}
                                            creditBalanceRefillEvery={selectedMemberCreditBalanceRefillEvery}
                                            IsThumbnailPresent={isThumbnailPresent}
                                            CompanyId={companyId}
                                            creditPersonName={selectedCreditPersonName}
                                        />)}

                                    {/* <div className="notification-info">
                                        <a href="#" data-bs-toggle="offcanvas"
                                            data-bs-target="#notification-panel"
                                            aria-controls="notification-panel"
                                            className="position-relative notification-icon">
                                            <img src={notificationicon} alt="" />
                                            <span className="orange-dot">
                                            </span>
                                        </a>
                                    </div> */}
                                    {/* <NotificationPanel /> */}
                                    {/* <div className="profile-info">
                                        <div className="dropdown dropdwon-green">
                                            <a href="#" className="profileImg" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                <img src={profileImg} alt="" />
                                            </a>

                                            
                                        </div>
                                    </div> */}
                                    <div className="menu-bar-options d-flex justify-content-end gap-3">
                                        <div className="notification-info">
                                            <a href="#" data-bs-toggle="offcanvas" data-bs-target="#notification-panel" aria-controls="notification-panel" className="position-relative notification-icon">
                                                <img src={notificationicon} alt="" />
                                                {hasUnreadNotifications && (
                                                    <span className="orange-dot"></span>
                                                )}</a>
                                        </div>
                                        <NotificationPanel onUnreadChange={setHasUnreadNotifications} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                <div className="component-area">
                    {isLoading && (
                        <div id='preloader'>

                            <img src={Images.LoaderFull} alt="" />
                        </div>
                    )}
                    <Sidebar
                        IsThumbnailPresent={isThumbnailPresent}
                        CompanyId={companyId}
                    />
                    <div className="pt-96 my-container active-cont">
                        <div className="container">
                            {/* <HeaderFilter /> */}
                            <div ref={setCalendarEl}>
                                <div className="p-4 relative monthly-view-sec">

                                    <FullCalendar
                                        locale={i18n.language}
                                        plugins={[dayGridPlugin, interactionPlugin]}
                                        initialView="dayGridMonth"
                                        firstDay={1}
                                        eventClick={handleEventClick}
                                        customButtons={
                                            activeGuestFlag === 0
                                                ? {
                                                    checkInBtn: {
                                                        click: handleCheckInButtonClick,
                                                        classNames: ['my-custom-button'],
                                                    },
                                                }
                                                : {}
                                        }
                                        headerToolbar={
                                            activeGuestFlag === 0
                                                ? { left: 'checkInBtn', center: 'prev,title,next', right: false }
                                                : { left: '', center: 'prev,title,next', right: false }
                                        }
                                        viewDidMount={handleViewMount}
                                        datesSet={handleDatesSet}
                                        dateClick={handleDateClick}
                                        dayCellContent={renderDayCellContent}
                                        customDataVersion={calendarRenderKey}


                                    // plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                    // headerToolbar={{
                                    //     left: "prev,next today",
                                    //     right: "dayGridMonth,customWeek",
                                    // }}
                                    // views={{
                                    //     customWeek: {
                                    //         type: "timeGrid",
                                    //         buttonText: "Week",
                                    //         visibleRange() {
                                    //           const start = new Date()
                                    //           const end = new Date(start.getTime() + 6 * 24 * 60 * 60 * 1000);

                                    //           return { start, end };
                                    //         },
                                    //     },
                                    // }}
                                    // dayHeaderFormat={{ weekday: "short", day: "numeric" }}
                                    />

                                    {/* <FullCalendar
                                        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                        headerToolbar={{
                                            left: "prev,next today",
                                            right: "dayGridMonth,customWeek,timeGridDay",
                                        }}

                                        initialView="dayGridMonth"
                                         firstDay={1}

                                        // key={selectedDate ? selectedDate.toISOString().split("T")[0] : "calendar"}
                                        // ref={calendarRef}
                                        views={{
                                            customWeek: {
                                                type: "timeGrid",
                                                buttonText: "Week",
                                                // visibleRange(currentDate) {
                                                //   const start = selectedDateRef.current;
                                                //   const end = new Date(start.getTime() + 6 * 24 * 60 * 60 * 1000);

                                                //   return { start, end };
                                                // },
                                            },
                                        }}

                                        height="auto"
                                        
                                        selectable={true}
                                        editable={true}
                                        nowIndicator={true}
                                        events={events}
                                        eventClick={handleEventClick}
                                        
                                        // sele.ct={handleDateSelect}
                                        // initialDate={selectedDate}
                                        // slotMaxTime={slotMaxTime}
                                        // slotMinTime={slotMinTime}
                                        // dayHeaderFormat={{ weekday: "short", day: "numeric" }}
                                    /> */}

                                </div>
                            </div>
                            {/* Modals */}
                            {(notification && !isLoading) && (
                                <NotificationMessage
                                    type={notification.type}
                                    title={notification.title}
                                    message={notification.message}
                                    duration={2000}
                                    onClose={() => setNotification(null)}
                                />
                            )}
                            {renderApiUi(isLoading)}
                            {showBookingModal && (
                                <BookingModal
                                    date={bookingCreateDate}
                                    onClose={() => setShowBookingModal(false)}
                                    zoneId={selectedCalendarZoneId}
                                />
                            )}
                            {showCancelModal && (
                                <CancellationModal
                                    date={selectedCancelDate}
                                    onClose={() => setShowCancelModal(false)}
                                    zoneId={selectedCalendarZoneId}
                                    cancelBookingSpotId={cancelBookingSpotId}
                                    checkInFlag={checkInFlag}
                                />
                            )}
                            {showNoVehicleModal && (
                                // {showmodal && (
                                <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                                    id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                                >
                                    <div className="modal fade show alertpopup d-block">
                                        <div className="modal-dialog modal-dialog-centered modal-custom-width">
                                            <div className="modal-content modal-radius">
                                                <div className="modal-body">
                                                    <div className="d-flex justify-content-between align-items-center mb-4">
                                                        <h5 className="popup-title">{t("warning")}</h5>
                                                        <div className="close-modal">
                                                            <a onClick={() => setShowNoVehicleModal(false)}>
                                                                <img src={WarningcloseIcon} aria-label="Close" />
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div className="modal-des mt-35">
                                                        <p>
                                                            {t("no_vehicle_alert")}
                                                        </p>
                                                        <div className="modal-img text-center"><img className="warning-icon" src={WarningIcon} alt="Warning Icon" /></div>

                                                        <div className="d-flex justify-content-end gap-3 mt-4">
                                                            <button
                                                                type="button"
                                                                className="main-btn outline-alert-btn w-full"
                                                                onClick={() => setShowNoVehicleModal(false)}
                                                            >
                                                                {t("confirm")}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                //   )}
                            )}
                            {showScheduleMeetingModal && (
                                <NewMeetingModal
                                    setIsLoading={setIsLoading}
                                    isLoading={isLoading}
                                    show={true}
                                    date={meetingModalDate}
                                    // startTime="00:00:00"
                                    // endTime="23:59:59"
                                    selectedZone={selectedZoneId}
                                    mapType={selectedZoneId ? (zoneList[selectedZoneId] ?? 2) : undefined}
                                    onClose={() => setShowScheduleMeetingModal(false)}
                                    onConfirm={fetchBookings}
                                    onMeetingCreated={() => {
                                        setIsLoading(true);
                                        fetchBookings(selectedZoneId, meetingModalDate || new Date())
                                        setIsLoading(false);
                                    }
                                    }
                                    setNotification={setNotification}
                                    setShowScheduleMeetingModal={setShowScheduleMeetingModal}

                                // onConfirm={GetRandomSpace}
                                // onMeetingCreated={() => GetRandomSpace(selectedZoneId, new Date())}
                                />
                            )}
                            {showJoinQueueModal && (
                                <JoinQueueModal
                                    date={joinQueueDate}
                                    onClose={() => setShowJoinQueueModal(false)}
                                    zoneId={selectedCalendarZoneId}
                                />
                            )}
                            {showLeaveQueueModal && (
                                <LeaveQueueModal
                                    date={leaveQueueDate}
                                    onClose={() => setShowLeaveQueueModal(false)}
                                    zoneId={selectedCalendarZoneId}
                                />
                            )}
                            {showReportParkingViolationModal && (
                                <ReportParkingViolationModal
                                    zoneId={selectedCalendarZoneId}
                                    onClose={() => setShowReportParkingViolationModal(false)}
                                />
                            )}
                            {showAlternateParkingSpotModal && (
                                <AlternateParkingSpotModal
                                    zoneId={selectedCalendarZoneId}
                                    onClose={() => {
                                        setShowAlternateParkingSpotModal(false);
                                        setParkingViolationReportingData(null);
                                    }}
                                />
                            )}
                            {guestBookingConfirmation && (
                                <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}>
                                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                                        <div className="modal-content modal-radius">
                                            <div className="modal-body">
                                                <div className="close-modal">
                                                    <a className="close-modal">
                                                        <img src={Close} alt="Close" onClick={closeGuestBookingConfirmation} />
                                                    </a>
                                                </div>
                                                <div className="pt-4">
                                                    <h5 className="popup-title">{t("your_booking_is_confirmed")}</h5>
                                                </div>
                                                <div className="divider-line mt-3"></div>
                                                <div className="modal-des">
                                                    <div className="">
                                                        <div className="icon-with-list mb-3">
                                                            <div className="icon-wrap">
                                                                <img src={Images.Participant} />
                                                                <h4>{guestBookingConfirmation.name} ({t("guest")})</h4>
                                                            </div>
                                                            <div className="icon-wrap">
                                                                <img src={Images.CalendarMenu} alt="repeat" />
                                                                <h4>{formatDateToEEEddMMM(guestBookingConfirmation.bookedDate)}</h4>
                                                            </div>
                                                            
                                                             {/* {guestBookingConfirmation.startTime && guestBookingConfirmation.endTime && (
                                                                <div className="icon-wrap">
                                                                    <img src={Images.TimeIcon} alt="time" />
                                                                    <h4>
                                                                        {guestBookingConfirmation.startTime} - {guestBookingConfirmation.endTime}
                                                                    </h4>
                                                                </div>
                                                            )} */}

                                                            <div className="icon-wrap align-items-start">
                                                                <img className="pt-1" src={Images.ZoneMap} alt="map" />
                                                                <h4>
                                                                    {guestBookingConfirmation.zoneName}
                                                                    <span className="d-block">{guestBookingConfirmation.spotName}</span>
                                                                </h4>
                                                            </div>
                                                           
                                                            <div className='text-center mt-5 mb-2'>
                                                                <img src={guestConfirmation} alt="" />
                                                             </div>   
                                                        </div>
                                                        {/* <div className="me-4 mt-3">
                                                            <button
                                                                type="button"
                                                                className="w-100 mw-100 min-height-56 main-btn cancel-btn"
                                                                onClick={closeGuestBookingConfirmation}
                                                            >
                                                                {t("ok")}
                                                            </button>
                                                        </div> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {showPostbookingQueModal && (
                                <PostbookingQueModal
                                    questions={postbookingQueModalData}
                                    onClose={() => setShowPostbookingQueModal(false)}
                                    onSubmit={async () => {

                                        setShowPostbookingQueModal(false);

                                        /* await fetchBookings(
                                            selectedZoneId,
                                            formatDate(selectedDate)
                                        ); */

                                    }}
                                    postRequestParams={postRequestParams}
                                    selectedBookingDate={selectedBookingDate || postRequestParams?.ClaimDate}
                                />
                            )}

                            {showGuestPopupFullday && GuestModal({ onClose: resetForm })}
                            {showGuestPopup30mit && (
                                <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                                    id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                                >
                                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                                        <div className="modal-content modal-radius">
                                            <div className="modal-body">
                                                <div className="close-modal">
                                                    <a className="close-modal">
                                                        <img src={Close} alt="Close" onClick={resetForm} />
                                                    </a>
                                                </div>
                                                <div className="pt-2">
                                                    <h5 className="popup-title">Guest Details</h5>
                                                </div>

                                                <div className="form-row mb-3">
                                                    <label className="popup-inner-title m-0">First Name*</label>
                                                    <input
                                                        type="text"
                                                        placeholder="First Name"
                                                        className={`form-control ${guestErrors.thirtyMin.firstname ? "error-form" : ""} ${!guestErrors.thirtyMin.firstname && guestName30mit ? "success-validation" : ""}`}
                                                        value={guestName30mit}
                                                        onChange={(e) => {
                                                            setGuestName30mit(e.target.value);
                                                            clearGuestFieldError("thirtyMin", "firstname");
                                                        }}
                                                    />
                                                    {guestErrors.thirtyMin.firstname && (
                                                        <div className="error-text"><img src={Images.ErrorMsg} alt="" /> <p>{guestErrors.thirtyMin.firstname}</p></div>
                                                    )}
                                                </div>

                                                <div className="form-row mb-3">
                                                    <label className="popup-inner-title m-0">Last Name*</label>
                                                    <input
                                                        type="text"
                                                        placeholder="Last Name"
                                                        className={`form-control ${guestErrors.thirtyMin.lastname ? "error-form" : ""} ${!guestErrors.thirtyMin.lastname && guestLastName30mit ? "success-validation" : ""}`}
                                                        value={guestLastName30mit}
                                                        onChange={(e) => {
                                                            setGuestLastName30mit(e.target.value);
                                                            clearGuestFieldError("thirtyMin", "lastname");
                                                        }}
                                                    />
                                                    {guestErrors.thirtyMin.lastname && (
                                                        <div className="error-text"><img src={Images.ErrorMsg} alt="" /> <p>{guestErrors.thirtyMin.lastname}</p></div>
                                                    )}
                                                </div>

                                                <div className="form-row mb-3">
                                                    <label className="popup-inner-title m-0">Email address*</label>
                                                    <input
                                                        type="email"
                                                        placeholder="___@____"
                                                        className={`form-control ${guestErrors.thirtyMin.email ? "error-form" : ""} ${!guestErrors.thirtyMin.email && guestEmail30mit ? "success-validation" : ""}`}
                                                        value={guestEmail30mit}
                                                        onChange={(e) => {
                                                            setGuestEmail30mit(e.target.value);
                                                            clearGuestFieldError("thirtyMin", "email");
                                                        }}
                                                    />
                                                    {guestErrors.thirtyMin.email && (
                                                        <div className="error-text"><img src={Images.ErrorMsg} alt="" /> <p>{guestErrors.thirtyMin.email}</p></div>
                                                    )}
                                                </div>

                                                <div className="form-row mb-3">
                                                    <label className="popup-inner-title m-0">Identification number (optional)</label>
                                                    <input
                                                        type="text"
                                                        placeholder="Identification number (optional)"
                                                        className="form-control"
                                                        value={identificatoin30mit}
                                                        onChange={(e) => setIdentification30mit(e.target.value)}
                                                    />
                                                </div>

                                                <div className="tags-btn mt-4">
                                                    <button
                                                        type="submit"
                                                        className="w-100 min-height-56 selected"
                                                        onClick={async (e) => {
                                                            e.preventDefault();

                                                            const isValid = validateGuestFields(
                                                                {
                                                                    name: guestName30mit,
                                                                    surname: guestLastName30mit,
                                                                    email: guestEmail30mit
                                                                },
                                                                "thirtyMin"
                                                            );

                                                            if (!isValid) {
                                                                return;
                                                            }

                                                            if (!pendingGuestBooking) return;

                                                            await executeRandomSpaceBooking(
                                                                pendingGuestBooking.zoneId,
                                                                pendingGuestBooking.bookingDateStr,
                                                                pendingGuestBooking.VehicleTypeId,
                                                                pendingGuestBooking.fuelId,
                                                                pendingGuestBooking.vehicleShareableId,
                                                                pendingGuestBooking.vehicleAccessibleId,
                                                                pendingGuestBooking.vehicleRegistrationId,
                                                                pendingGuestBooking.isGuestFlag,
                                                                {
                                                                    guestName30mit: guestName30mit,
                                                                    guestLastName30mit: guestLastName30mit,
                                                                    guestEmail30mit: guestEmail30mit,
                                                                    spotName: pendingGuestBooking.spotName,
                                                                    startTime: pendingGuestBooking.startTime,
                                                                    endTime: pendingGuestBooking.endTime
                                                                }
                                                            );

                                                            resetForm();
                                                        }}
                                                    >
                                                        {t("confirm")}
                                                    </button>
                                                </div>

                                                <div className="main-btn outline-gray-btn w-100 mw-100 min-height-56 mt-3">
                                                    <a type="button" onClick={resetForm()}>
                                                        {t("cancel")}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {showAddVehiclePopup && (
                                <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                                    id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                                >
                                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                                        <div className="modal-content modal-radius">
                                            <div className="modal-body">
                                                <div className="close-modal">
                                                    <a className="close-modal" onClick={handleAddVehiclePopupClose}>
                                                        <img src={Images.Close} alt="Close" />
                                                    </a>
                                                </div>
                                                <div className="pt-2">
                                                    <h5 className="popup-title">{t("warning")}</h5>
                                                </div>
                                                <div className="form-row mb-3">
                                                    <label>{t("first_login_settings_msg")}</label>
                                                </div>

                                                {/* <div className="main-btn outline-gray-btn w-100 mw-100 min-height-56 mt-3">
                                                        <a
                                                            onClick={handleAddVehiclePopupClose}
                                                            // type="button"
                                                        >
                                                            {t("cancel")}
                                                        </a>
                                                        </div> */}

                                                <div className="mt-4">
                                                    <button
                                                        className="w-100 min-height-56 main-btn fill-green-btn"
                                                        onClick={handleAddVehiclePopupConfirm}
                                                        type="button"
                                                    >
                                                        {t("confirm")}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {showBookingProcess && (
                                <LoadingProcessModal

                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="modal fade" id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-custom-width">
                    <div className="modal-content modal-radius">
                        <div className="modal-body">
                            <div className="close-modal">
                                <img src={Close} alt="Close" data-bs-dismiss="modal" aria-label="Close" />
                            </div>
                            <div className="pt-4">
                                <h5 className="popup-title">New Booking</h5>
                            </div>
                            <div className="date-with-credit d-flex align-items-center justify-content-between pt-2">
                                <div id="selectedDate" className="selected-current-date">
                                    {selectedDate}
                                </div>
                                <div className="credit-info">
                                    <a href="#" className="orange-outline-with-icon">
                                        <img src={OrangeStar} alt="Star" /><span>-1</span>
                                    </a>
                                </div>
                            </div>
                            <div className="divider-line mt-3"></div>
                            <div className="mb-4">
                                <a href="#" className="green-outline-with-icon w-100 mw-100 min-height-56 selected">
                                    <img src={GreenMap} alt="Map" /><span>Go to Map</span>
                                </a>
                            </div>
                            <div className="">
                                <a href="#" className="green-outline-with-icon w-100 mw-100 min-height-56">
                                    <img src={EditSquare} alt="Edit" /><span>Get Random Space</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

            {/* Check In Button */}
            {showModal && (

                <CheckInCheckOutList
                    ZoneId={selectedCalendarZoneId}
                    // zoneName={zones.find((z) => z.Id === selectedZoneId)?.ZoneName}
                    zoneName={zoneList?.find((z) => z.Id === selectedCalendarZoneId)?.ZoneName}

                    checkInCheckOutRecords={checkInCheckOutRecords}
                    setCheckInCheckOutRecords={setCheckInCheckOutRecords}
                    selectedZoneId={selectedZoneId} isLoading={isLoading}
                    closeModal={() => {
                        setShowModal(false);
                    }}
                    selectedDate={checkInCheckOutRecords?.[0]?.BookingDate || selectedDate}
                    onCheckInCheckout={async (zoneId, bookingDateStr) => {
                        setIsLoading(true);
                        try {
                            await fetchBookings(
                                zoneId ?? selectedCalendarZoneId,
                                bookingDateStr ?? checkInCheckOutRecords?.[0]?.BookingDate ?? formatDate(selectedDate)
                            );
                        } finally {
                            setIsLoading(false);
                        }
                    }}
                    onCheckInApiResponse={async ({ response, zoneId, bookingDateStr, closeModal }) => {
                        const responseCode = Number(response?.Data?.ResponseCode);

                        if (responseCode !== 449) {
                            return;
                        }

                        closeModal();
                        handleApiUiResponse(response, {
                            successToaster: 0,
                            errorToaster: 0,
                            alertPopup: 1,
                            onConfirmByCode: {
                                449: async () => {
                                    setIsLoading(true);
                                    try {
                                        await fetchBookings(
                                            zoneId ?? selectedCalendarZoneId,
                                            bookingDateStr ?? checkInCheckOutRecords?.[0]?.BookingDate ?? formatDate(selectedDate)
                                        );
                                    } finally {
                                        setIsLoading(false);
                                    }
                                }
                            }
                        });
                    }}
                    mapAvailableType={recordsData?.MapType}
                    mapAvailable={mapAvailable}
                />
            )
            }
            {/* <TeamsComponent /> */}
        </div>
    )
}

// Define the CSS for the selected day content
const styles = `
    .fc-day-content .my-selected-day-content {
        background-color: #008080; /* Your desired green color */
        color: white; /* Optional: text color */
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%; /* Ensure it fills the cell */
    }
`;
const CalendarWithStyles = (props) => (
    <>
        <style>{styles}</style>
        <Calendar {...props} />
    </>
);

export default CalendarWithStyles;

function Dropdown({ dropdownId, items, label }) {
    const [selectedItem, setSelectedItem] = useState(items[0]);

    const handleItemClick = (item) => {
        setSelectedItem(item);
    };

    return (
        <div className="employee-list">
            <div className="dropdown form-input-container d-flex justify-content-center flex-column">
                <button
                    className="dropdown-toggle form-control position-relative custom-dropdown-btn"
                    type="button"
                    id={dropdownId}
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    name="empdropdown"
                    required
                >
                    <p className="sub-dropdown-name">{label}</p>
                    <span>{selectedItem}</span>
                </button>
                <ul className="dropdown-menu custom-dropdown" aria-labelledby={dropdownId}>
                    {items.map((item, index) => (
                        <li
                            key={index}
                            className={item === selectedItem ? "selected" : ""}
                            onClick={() => handleItemClick(item)}
                        >
                            <a className="dropdown-item">
                                {item}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
